import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            label_seguimiento_en_tiempo_real: "Real-time Tracking",
            label_gestion_de_entregas: "Delivery Management",
            label_optimizacion_de_rutas: "Route Optimization",
            label_notificaciones_automaticas: "Automatic Notifications",
            label_reportes_detallados: "Detailed Reports",
            label_etas_precisos: "Precise ETAs",
            label_mayor_satisfaccion_del_cliente: "Greater Customer Satisfaction",
            label_reduccion_de_costos: "Cost Reduction",
            label_escalabilidad: "Scalability",
            label_entregas_puntuales: "Punctual Deliveries",
            label_tus_clientes_pueden_ver_exactamente_donde_esta_su_pedido_en_todo_momento: "Your customers can see exactly where their order is at any time",
            label_carga_y_administra_todas_tus_entregas_desde_una_unica_plataforma: "Load and manage all your deliveries from a single platform",
            label_algoritmos_inteligentes_para_las_rutas_mas_eficientes: "Intelligent algorithms for the most efficient routes",
            label_alertas_instantaneas_para_clientes_y_gestores_de_flota: "Instant alerts for customers and fleet managers",
            label_analitica_completa_de_tiempos_eficiencia_y_satisfaccion: "Complete analytics for time, efficiency and satisfaction",
            label_tiempos_estimados_de_llegada_actualizados_en_tiempo_real: "Estimated arrival times updated in real time",
            label_transparencia_total_en_cada_entrega_genera_confianza_y_lealtad: "Total transparency in each delivery generates trust and loyalty",
            label_optimiza_rutas_y_reduce_llamadas_de_dnde_esta_mi_pedido: "Optimize routes and reduce calls of \"Where is my order?\"",
            label_crece_sin_limites_desde_1_hasta_10000_entregas_diarias: "Grow without limits, from 1 to 10,000 daily deliveries",
            label_mejora_tus_tiempos_de_entrega_hasta_un_40: "Improve your delivery times up to 40%",
            label_ultima_milla: "Last Mile",
            label_ultima_milla_corto: "LM",
            label_tms: "TMS",
            label_inicio: "Home",
            label_caracteristicas: "Features",
            label_beneficios: "Benefits",
            label_contacto: "Contact",
            label_iniciar_sesion: "Login",
            label_comenzar_ahora: "Start Now",
            label_ultima_milla_inteligente: "Last Mile Intelligent",
            label_transforma_tus_entregas_en: "Transform your deliveries into",
            label_experiencias_inolvidables: "Unforgettable experiences",
            label_la_plataforma_de_seguimiento_en_tiempo_real_que_conecta_tu_empresa_con_tus_clientes: "The real-time tracking platform that connects your company with your customers.",
            label_ellos_ven_exactamente_donde_esta_su_pedido_tu_optimizas_cada_entrega: "They see exactly where their order is, you optimize each delivery.",
            label_ver_demo: "See Demo",
            label_mejora_en_tiempos_de_entrega: "Improve in delivery times",
            label_satisfaccion_del_cliente: "Customer Satisfaction",
            label_reduccion_de_llamadas: "Call Reduction",
            label_todo_lo_que_necesitas_para_tms: "Everything you need for TMS",
            label_una_plataforma_completa_diseñada_para_empresas_que_entregan_productos_personalizados: "A complete platform designed for companies that deliver personalized products",
            label_como_funciona: "How it works",
            label_tan_simple_que_empezaras_en_minutos: "So simple that you'll start in minutes",
            label_carga_tus_entregas: "Load your deliveries",
            label_sube_tu_lista_de_pedidos_con_direcciones_de_clientes_puedes_hacerlo_manualmente_o_mediante_excel_api: "Upload your list of orders with customer addresses. You can do it manually or through Excel/API.",
            label_asigna_vehiculos: "Assign vehicles",
            label_el_sistema_optimiza_rutas_automaticamente_tus_conductores_reciben_las_entregas_en_su_app_movil: "The system optimizes routes automatically. Your drivers receive the deliveries in their mobile app.",
            label_clientes_rastrean: "Customers track",
            label_tus_clientes_reciben_un_link_unico_para_ver_en_tiempo_real_donde_esta_su_pedido_sin_llamadas_ni_dudas: "Your customers receive a unique link to see in real time where their order is. No calls or doubts!",
            label_por_que_elegirnos: "Why choose us",
            label_ventajas_que_transformaran_tu_operacion: "Advantages that will transform your operation",
            label_listo_para_revolucionar_tus_entregas: "Ready to revolutionize your deliveries?",
            label_unete_a_las_empresas_que_ya_estan_ofreciendo_la_mejor_experiencia_de_entrega: "Join the companies that are already offering the best delivery experience",
            label_hablar_con_ventas: "Talk to sales",
            label_politica_de_privacidad: "Privacy Policy & Terms of Use",
            label_ultima_actualizacion: "Last updated",
            label_politica_intro: "This document describes the terms of use and privacy practices applicable to the DataTerra TMS (Transport Management System) platform and related products offered by our company.",
            label_politica_seccion_servicio_titulo: "1. About the service",
            label_politica_seccion_servicio_texto: "DataTerra TMS is a software platform that allows companies and users to register an account and use tools for delivery management, route optimization, real-time tracking, and related logistics operations. Access to the platform may require registration and acceptance of these terms.",
            label_politica_seccion_proveedor_titulo: "2. Role of the provider",
            label_politica_seccion_proveedor_texto: "We act solely as the technology provider of the TMS software, mobile applications, and any other digital products made available under the DataTerra brand. We do not operate your logistics business, do not control your deliveries, and are not a party to the relationships between you and your customers, drivers, or third parties.",
            label_politica_seccion_responsabilidad_titulo: "3. Limitation of liability",
            label_politica_seccion_responsabilidad_texto: "To the fullest extent permitted by applicable law, DataTerra and its affiliates shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from your use or inability to use the software, mobile app, APIs, or any other product or service we provide. We are not responsible in any way for how you, your organization, your employees, contractors, or end users use the platform, including but not limited to data entered, routes planned, communications sent, or business decisions made using our tools.",
            label_politica_seccion_uso_usuario_titulo: "4. User and client responsibility",
            label_politica_seccion_uso_usuario_texto: "You are solely responsible for your account credentials, the accuracy of the information you upload, compliance with local laws and regulations, and the proper use of the software in your operations. You agree to use the TMS and related products only for lawful purposes and at your own risk.",
            label_politica_seccion_cambios_titulo: "5. Changes to terms and conditions",
            label_politica_seccion_cambios_texto: "We may modify these terms, this privacy policy, pricing, features, or any other condition of use at any time and at our sole discretion. Changes may take effect immediately upon publication on this page or within the application. We are not obligated to provide prior notice to users or clients. Continued use of the software after changes constitutes your acceptance of the updated terms.",
            label_politica_seccion_privacidad_titulo: "6. Privacy and data",
            label_politica_seccion_privacidad_texto: "Information processed through the platform is used to provide and improve the service. You remain the owner of your operational data. We implement reasonable security measures; however, no system is completely secure. For questions about data handling, contact us using the information below.",
            label_politica_seccion_aceptacion_titulo: "7. Acceptance",
            label_politica_seccion_aceptacion_texto: "By creating an account, signing in, or using any DataTerra product, you acknowledge that you have read, understood, and agree to this Privacy Policy and Terms of Use.",
            label_politica_volver_landing: "Back to home",
            label_plataforma_de_ultima_milla: "Last Mile Platform",
            label_usuario: "Username",
            label_contrasena: "Password",
            label_mostrar_contrasena: "Show password",
            label_ocultar_contrasena: "Hide password",
            label_ingresar: "Login",
            label_volver_al_inicio: "Back to Home",
            label_ingresa_tus_credenciales_para_continuar: "Enter your credentials to continue",
            label_cargando: "Loading...",
            label_ingresa_tu_usuario: "Enter your username",
            label_ingresa_tu_contrasena: "Enter your password",
            label_gestionar_categoria: "Manage Category",
            label_administra_la_lista_de_categorias: "Manage the list of categories",
            label_estado: "Status",
            label_buscar: "Search",
            label_nuevo: "New",
            label_compartir: "Share",
            alert_enlace_copiado: "Link copied",
            alert_no_se_pudo_compartir: "Could not share",
            label_peticion_enviada_titulo: "Request sent successfully",
            label_peticion_enviada_mensaje: "Your request was sent to the server correctly.",
            label_puede_cerrar_pestana: "You can close this tab now.",
            label_cerrar_pestana: "Close tab",
            label_gestionar_producto: "Manage Product",
            label_administra_la_lista_de_productos: "Manage the list of products",
            label_crear_producto: "Create Product",
            label_categoria: "Category",
            label_codigo: "Code",
            label_nombre: "Name",
            label_nota: "Note",
            label_modificar_producto: "Modify Product",
            label_modificar_pais: "Modify Country",
            label_crear_pais: "Create Country",
            label_descripcion: "Description",
            label_gestionar_paises: "Manage Countries",
            label_administra_la_lista_de_paises: "Manage the list of countries",
            label_gestionar_ciudades: "Manage Cities",
            label_administra_la_lista_de_ciudades: "Manage the list of cities",
            label_modificar_ciudad: "Modify City",
            label_crear_ciudad: "Create City",
            label_pais: "Country",
            label_modificar_vendedor: "Modify Seller",
            label_crear_vendedor: "Create Seller",
            label_gestionar_vendedores: "Manage Sellers",
            label_administra_la_lista_de_vendedores: "Manage the list of sellers",
            label_modificar_estado: "Modify Status",
            label_crear_estado: "Create Status",
            label_gestionar_estados: "Manage Statuses",
            label_administra_la_lista_de_estados: "Manage the list of statuses",
            label_modificar_sub_estado: "Modify Sub Status",
            label_crear_sub_estado: "Create Sub Status",
            label_gestionar_sub_estados: "Manage Sub Statuses",
            label_administra_la_lista_de_sub_estados: "Manage the list of sub statuses",
            label_modificar_grupo_cliente: "Modify Group Client",
            label_crear_grupo_cliente: "Create Group Client",
            label_gestionar_grupo_clientes: "Manage Group Clients",
            label_administra_la_lista_de_grupo_clientes: "Manage the list of group clients",
            label_modificar_cliente: "Modify Client",
            label_crear_cliente: "Create Client",
            label_gestionar_clientes: "Manage Clients",
            label_administra_la_lista_de_clientes: "Manage the list of clients",
            label_grupo_cliente: "Group Client",
            label_ciudad: "City",
            label_latitud: "Latitude",
            label_longitud: "Longitude",
            label_mapa: "Map",
            label_telefonos: "Phones",
            label_email: "Email",
            label_color: "Color",
            label_seleccionar_color: "Select color",
            label_usuarios_permitidos: "Allowed users",
            placeholder_seleccione_usuarios: "Select users",
            alert_accion_creada_usuarios_error: "Action was created but some user permissions failed to save",
            alert_accion_modificada_usuarios_error: "Action was updated but some user permissions failed to sync",
            label_gestionar_telefono: "Manage Phone",
            label_aceptar: "Accept",
            label_cancelar: "Cancel",
            label_gestionar_email: "Manage Email",
            label_modificar_estado_pago: "Modify Payment Status",
            label_modificar_estado_pedido: "Modify order status",
            label_crear_estado_pago: "Create Payment Status",
            label_gestionar_estado_pago: "Manage Payment Statuses",
            label_administra_la_lista_de_estado_pago: "Manage the list of payment statuses",
            label_agregar_campo: "Add Field",
            label_agregar: "Add",
            label_no_hay_campos: "No fields added",
            label_etiqueta: "Label",
            label_tipo: "Type",
            label_texto: "Text",
            label_numero: "Number",
            label_fecha: "Date",
            label_valor: "Value",
            label_habilitado: "Enabled",
            label_deshabilitado: "Disabled",
            label_eliminar: "Delete",
            label_placeholder: "Placeholder",
            label_hora: "Hour",
            label_hora_salida: "Departure time",
            label_hora_llegada: "Arrival time",
            label_fecha_salida: "Departure date",
            label_fecha_llegada: "Arrival date",
            label_seleccione_transportadora: "Select Transport company",
            label_seleccione_vehiculo: "Select vehicle",
            label_seleccione_destino: "Select destination",
            label_seleccione_producto: "Select product",
            label_seleccione_tipo_de_carga: "Select load type",
            label_input_cantidad: "Quantity",
            label_date_time: "Date and Time",
            label_only_letters_and_underscore_allowed: "Only letters and underscore allowed",
            label_gestionar_quien_recibe_entrega: "Manage Who Receives Delivery",
            label_administra_la_lista_de_quien_recibe_entrega: "Manage the list of who receives delivery",
            label_crear_quien_recibe_entrega: "Create Who Receives Delivery",
            label_modificar_quien_recibe_entrega: "Modify Who Receives Delivery",
            label_gestionar_formulario: "Manage Form",
            label_administra_la_lista_de_formulario: "Manage the list of form",
            label_crear_formulario: "Create Form",
            label_modificar_formulario: "Modify Form",
            label_firma: "Signature",
            label_fotografia: "Photo",
            label_estado_de_pago: "Payment Status",
            label_quien_recibe_entrega: "Person Delivering / Person Receiving",
            label_key: "Key",
            label_campo: "Field",
            label_tms_inteligente: "TMS Intelligent",
            label_numero_documento: "Document Number",
            label_codigo_cliente: "Client Code",
            label_nombre_cliente: "Client Name",
            label_latitud_cliente: "Latitude Client",
            label_longitud_cliente: "Longitude Client",
            label_direccion_cliente: "Address Client",
            label_telefono_cliente: "Phone Client",
            label_fecha_factura: "Invoice Date",
            label_numero_factura: "Invoice Number",
            label_valor_factura: "Invoice Value",
            label_codigo_almacen: "Warehouse Code",
            label_nombre_almacen: "Warehouse Name",
            label_latitud_almacen: "Latitude Warehouse",
            label_longitud_almacen: "Longitude Warehouse",
            label_codigo_producto: "Product Code",
            label_nombre_producto: "Product Name",
            label_unidad_medida: "Unit of Measure",
            label_cantidad: "Quantity",
            label_peso: "Weight",
            label_capacidad_carga: "Load capacity",
            label_peso_esta_solicitud: "Weight of this request",
            label_peso_otras_solicitudes: "Weight of other requests",
            label_peso_total: "Total weight",
            label_exceso: "Excess",
            label_solicitudes_en_conflicto: "Requests in conflict",
            alert_capacidad_carga_excedida: "Vehicle load capacity exceeded",
            label_carga_asignada_vehiculo: "Load assigned to vehicle",
            label_desglose_por_unidad: "Breakdown by unit",
            label_disponible: "Available",
            label_ver_carga_asignada: "View assigned load",
            label_sin_periodo_definido: "No time period defined (showing only this request)",
            alert_no_se_pudo_obtener_info_vehiculo: "Could not fetch vehicle info",
            label_volumen: "Volume",
            label_monto: "Amount",
            label_moneda: "Currency",
            label_codigo_vendedor: "Seller Code",
            label_nombre_vendedor: "Seller Name",
            label_region: "Region",
            label_fecha_entrega: "Delivery Date",
            label_numero_embarque: "Shipment Number",
            label_tipo_servicio: "Service Type",
            label_estado_pago: "Payment Status",
            label_telefonos_notificacion: "Notification Phones",
            label_correos_notificacion: "Notification Emails",
            label_prefijo: "Prefix",
            label_observaciones: "Observations",
            label_importar: "Import",
            label_exportar: "Export",
            label_importar_general: "Import Generic",
            label_importar_personalizado: "Import Personalized",
            label_vehiculo: "Vehicle",
            label_formulario: "Form",
            label_limpiar: "Clean",
            label_gestionar_almacen: "Manage Warehouse",
            label_administra_la_lista_de_almacen: "Manage the list of warehouse",
            label_crear_almacen: "Create Warehouse",
            label_modificar_almacen: "Modify Warehouse",
            label_gestionar_tipo_cliente: "Manage Type Client",
            label_administra_la_lista_de_tipo_cliente: "Manage the list of type client",
            label_crear_tipo_cliente: "Create Type Client",
            label_modificar_tipo_cliente: "Modify Type Client",
            label_prioridad: "Priority",
            label_tipo_cliente: "Type Client",
            label_detalle: "Detail",
            label_seleccionar_fecha: "Select date",
            label_ver_detalle: "View detail",
            label_gestionar_grupo_geocerca: "Manage Group Geocerca",
            label_administra_la_lista_de_grupo_geocerca: "Manage the list of group geocerca",
            label_crear_grupo_geocerca: "Create Group Geocerca",
            label_modificar_grupo_geocerca: "Modify Group Geocerca",
            label_grupo_geocerca: "Group Geocerca",
            label_geocerca: "Geocerca",
            label_opciones_avanzadas: "Advanced options",
            tooltip_opciones_avanzadas_vehiculo: "Click to open advanced options. Right-click to turn them on or off.",
            label_invertir: "Invert",
            label_dividir: "Divide",
            label_items_seleccionados: "Selected items",
            label_cerrar: "Close",
            label_continuar: "Continue",
            label_volver: "Back",
            label_copiar: "Copy",
            label_sin_items_seleccionados: "No items selected",
            label_unir_pedidos: "Join orders",
            label_gestionar_tipo_usuario_movil: "Manage Type User Mobile",
            label_administra_la_lista_de_tipo_usuario_movil: "Manage the list of type user mobile",
            label_crear_tipo_usuario_movil: "Create Type User Mobile",
            label_modificar_tipo_usuario_movil: "Modify Type User Mobile",
            label_gestionar_rol_usuario_web: "Manage Role User Web",
            label_administra_la_lista_de_rol_usuario_web: "Manage the list of role user web",
            label_crear_rol_usuario_web: "Create Role User Web",
            label_modificar_rol_usuario_web: "Modify Role User Web",
            label_gestionar_usuario_movil: "Manage User Mobile",
            label_administra_la_lista_de_usuario_movil: "Manage the list of user mobile",
            label_crear_usuario_movil: "Create User Mobile",
            label_modificar_usuario_movil: "Modify User Mobile",
            label_tipo_usuario_movil: "Type User Mobile",
            label_password: "Password",
            label_nombre_conductor: "Name Conductor",
            label_ocultar_sidebar: "Hide sidebar",
            label_configuracion: "Configuration",
            label_ruteo: "Route",
            label_obtener_mejor_ruta: "Get better route",
            label_obtener_mejor_ruta_por_prioridad: "Get better route by priority",
            label_asignacion: "Assignment",
            label_administra_la_lista_de_asignacion: "Manage the list of assignment",
            label_finalizar_proceso: "Finalize process",
            label_gestionar_progress_bar: "Manage Progress Bar",
            label_administra_la_lista_de_progress_bar: "Manage the list of progress bar",
            label_crear_progress_bar: "Create Progress Bar",
            label_modificar_progress_bar: "Modify Progress Bar",
            label_start: "Start",
            label_end: "End",
            label_guardar: "Save",
            label_actualizar: "Update",
            label_ver_ruta: "View route",
            label_lista_seguimiento: "Tracking List",
            label_administra_la_lista_de_seguimiento: "Manage the tracking list",
            label_productos: "Products",
            label_todos: "All",
            label_camiones: "Trucks",
            label_sin_productos: "No products",
            label_cantidad_programada: "Scheduled quantity",
            label_cantidad_entregada: "Delivered quantity",
            label_cambiar_placa: "Change Vehicle",
            label_sin_datos: "No data available",
            label_resumen_recorrido: "Route summary",
            label_ver_resumen_recorrido: "View route summary",
            label_tiempo_total: "Total time",
            label_distancia_total: "Total distance",
            label_mover_a_otra_posicion: "Move to another position",
            label_sin_workflow: "No workflow available",
            label_detalle_workflow: "Workflow details",
            label_workflow: "Workflow",
            label_historico: "History",
            label_velocidad: "Speed",
            label_tipo_evento: "Event",
            label_sin_coordenadas_historico: "No coordinates available to show on the map.",
            label_inicio: "Start",
            label_fin: "End",
            label_hoja_de_ruta: "Route sheet",
            label_exportar_pdf: "Export PDF",
            label_exportar_csv: "Export CSV",
            label_imprimir: "Print",
            label_hoja_de_ruta_y_carga: "Route sheet and load",
            label_control_despacho_y_transporte: "Control of dispatch and transport",
            label_agregar_grafico_seleccionado: "Add selected chart",
            label_guardar_layout: "Save layout",
            label_quitar: "Remove",
            label_error_al_cargar_datos: "Error loading data",
            label_piechartestados: "Pie chart statuses",
            label_dashboard_vacio: "No data available",
            label_configuracion_guardada_servidor: "Configuration saved on the server",
            label_configuracion_guardada_localmente: "Configuration saved locally",
            label_detalle_pagos: "Payment details",
            label_no_hay_informacion_disponible: "No information available",
            label_total: "Total",
            label_formulario_retorno: "Return form",
            label_pendiente: "Pending",
            label_iniciado: "Started",
            label_copiar_hoja_de_ruta: "Copy route sheet",
            label_detalle_entrega: "Delivery details",
            label_hoja_de_ruta_tiempos_entrega: "Route sheet times delivery",
            label_detalle_monto_que_debio_ser_pagado_a_conductor: "Amount to be paid to the conductor",
            label_detalle_monto_pagado_a_conductor: "Amount paid to the conductor",
            label_pedir_detalles_productos: "Ask for products details",
            label_detalles_totales: "Total details",
            label_entrada_salida_geocerca: "Entry/Exit Geocerca",
            label_detalle_salida_entrada_geocerca: "Entry/Exit Geocerca details",
            label_tabla: "Table",
            label_mapa_de_clientes: "Map of clients",
            label_visualiza_el_mapa_de_clientes: "Visualize the map of clients",
            label_mostrar_etiquetas_clientes_mapa: "Show client names on map",
            label_detalle_cliente_en_mapa: "Client details",
            label_clientes_por_geocerca_mapa: "Clients in geofence",
            label_concepto_geocerca: "Concepto Geocerca",
            label_proximamente: "Coming soon",
            label_error_carga_mapa: "The map could not be loaded. Check your connection and try again.",
            label_placa: "Plate",
            label_cargando_informacion: "Loading information",
            label_grupo_geocerca_cliente: "Group Geofence Client",
            label_grupo_geocerca_ciudades: "Group Geofence Cities",
            label_ruta_planificada: "Planned route",
            label_ruta_vehiculo: "Vehicle route",
            label_lista_vehiculos: "List of vehicles",
            label_reporte_estado_entregas: "Report of delivery status",
            label_genera_el_reporte_de_estado_de_entregas: "Generate the report of delivery status",
            label_fecha_programada: "Scheduled date",
            label_pedidos_programados: "Scheduled orders",
            label_pedidos_realizados: "Completed orders",
            label_km_planificada: "Planned km",
            label_km_recorrido: "Recorded km",
            label_obligatorio: "Required",
            label_no_obligatorio: "Not required",
            label_gestionar_estados_incidente: "Manage Incident Statuses",
            label_administra_la_lista_de_estados_incidente: "Manage the list of incident statuses",
            label_crear_estado_incidente: "Create Incident Status",
            label_modificar_estado_incidente: "Modify Incident Status",
            label_gestionar_sub_estados_incidente: "Manage Incident Sub Statuses",
            label_administra_la_lista_de_sub_estados_incidente: "Manage the list of incident sub statuses",
            label_crear_sub_estado_incidente: "Create Incident Sub Status",
            label_modificar_sub_estado_incidente: "Modify Incident Sub Status",
            label_gestionar_persona: "Manage Person",
            label_administra_la_lista_de_personas: "Manage the list of persons",
            label_crear_persona: "Create Person",
            label_modificar_persona: "Modify Person",
            label_notificar_a: "Notify to",
            label_grupo_geocerca_georuta: "Group Geo Route",
            label_gestionar_incidentes: "Manage Incidents",
            label_administra_la_lista_de_incidentes: "Manage the list of incidents",
            label_detalle_incidente: "Incident Detail",
            label_sin_detalle: "No detail",
            label_ubicacion: "Location",
            label_vista_previa: "Preview",
            label_copiado: "Copied",
            label_abrir: "Open",
            label_asignar_por_peso: "Assign by weight",
            label_usar_vehiculo_solo_una_vez: "Use vehicle only once",
            label_si: "Yes",
            label_no: "No",
            label_unidades_disponibles: "Available units",
            label_usar_vehiculo_del_excel: "Use vehicle from excel",
            label_fecha_inicio: "Start date",
            label_fecha_fin: "End date",
            label_cliente: "Client",
            label_documento: "Document Number",
            label_finalizado: "Finalized",
            label_pedidos: "Orders",
            label_estadopagos: "Payment Statuses",
            label_metodo: "Method",
            label_subtotal: "Subtotal",
            label_dividir_si_no_se_encuentra_vehiculo: "Divide if no vehicle is not found",
            label_reporte_resumen_entregas: "Summary of deliveries",
            label_genera_el_reporte_de_resumen_de_entregas: "Generate the report of summary of deliveries",
            label_registros: "Records",
            label_exportar_excel: "Export Excel",
            label_sub_estado: "Sub Status",
            label_estado_asignado: "Assigned",
            label_estado_en_proceso: "In progress",
            label_detalle_estado_pago: "Payment status detail",
            label_gestionar_viajes: "Manage Trips",
            label_administra_la_lista_de_viajes: "Manage the list of trips",
            label_nuevo_viaje: "New trip",
            label_notificar_inicio_viaje: "Notify start of trip",
            label_notificar_fin_viaje: "Notify end of trip",
            label_grupo_geocerca_viaje: "Group Geocerca Trip",
            label_geocerca_inicio: "Geocerca inicio",
            label_geocerca_fin: "Geocerca fin",
            label_fecha_hora_inicio: "Date/Time Start",
            label_fecha_hora_fin: "Date/Time End",
            label_minutos: "Minutes",
            label_now: "Now",
            label_modificar_viaje: "Modify trip",
            label_tranportadora_sindicato: "Transport Company",
            label_usuario_singular: "Individual User",
            label_grupo: "Group",
            label_sub_grupo: "Sub Group",
            label_vehiculos: "Vehicles",
            label_grupo_geocerca_clientes: "Group Geocerca Clients",
            label_georuta: "Georuta",
            label_cantidad_vehiculos_requeridos: "Required vehicles",
            label_notificar_alerta: "Notify alert",
            label_gestionar_estado_viajes: "Manage State Trips",
            label_administra_la_lista_de_estado_viajes: "Manage the list of state trips",
            label_nuevo_estado_viaje: "New state trip",
            label_modificar_estado_viaje: "Modify state trip",
            label_visible_para_transportadora: "Visible for transport company",
            label_estado_viaje: "State trip",
            label_datos_generales: "General data",
            label_geocercas: "Geofences",
            label_notificaciones: "Notifications",
            label_este_usuario_puede_hacer_gestion_estrege_recogo_productos: "This user can make management of delivery/collection products",
            label_visible_para_app: "Visible for app",
            label_crear_usuario_web: "Create User Web",
            label_rol_usuario_web: "Role User Web",
            label_nombre_usuario: "User Name",
            label_confirmar_password: "Confirm Password",
            label_cambiar_fecha_entrega: "Change Delivery Date",
            label_gestionar_permisos: "Manage Permissions",
            label_seleccionar_todo: "Select all",
            label_funcionalidad: "Functionality",
            label_gestionar_tipo_carguio: "Manage Loading Type",
            label_administra_la_lista_de_tipo_carguio: "Manage the list of loading type",
            label_crear_tipo_carguio: "Create Loading Type",
            label_modificar_tipo_carguio: "Modify Loading Type",
            label_gestionar_registro_camiones: "Manage Vehicle Registration",
            label_administra_la_lista_de_registro_camiones: "Manage the list of vehicle registration",
            label_crear_registro_camiones: "Create Vehicle Registration",
            label_modificar_registro_camiones: "Modify Vehicle Registration",
            label_gestionar_kanban: "Manage Kanban",
            label_administra_la_lista_de_kanban: "Manage the list of kanban",
            label_crear_kanban: "Create Kanban",
            label_modificar_kanban: "Modify Kanban",
            label_gestionar_kanban_viaje: "Manage Trip Kanban",
            label_administra_la_lista_de_kanban_viaje: "Manage the list of trip kanban",
            label_crear_kanban_viaje: "Create Trip Kanban",
            label_modificar_kanban_viaje: "Modify Trip Kanban",
            label_gestionar_kanban_producto: "Manage Product Kanban",
            label_administra_la_lista_de_kanban_producto: "Manage the list of product kanban",
            label_crear_kanban_producto: "Create Product Kanban",
            label_modificar_kanban_producto: "Modify Product Kanban",
            label_agregar_columna: "Add column",
            label_seleccionar_tipo_columna: "Column type",
            label_gestionar_estados_vehiculo: "Manage Vehicle Statuses",
            label_administra_la_lista_de_estados_vehiculo: "Manage the list of vehicle statuses",
            label_crear_estado_vehiculo: "Create Vehicle Status",
            label_modificar_estado_vehiculo: "Modify Vehicle Status",
            label_gestionar_ejes_vehiculo: "Manage Vehicle Axles",
            label_administra_la_lista_de_ejes_vehiculo: "Manage the list of vehicle axles",
            label_crear_ejes_vehiculo: "Create Vehicle Axles",
            label_modificar_ejes_vehiculo: "Modify Vehicle Axles",
            label_pedir_descripcion: "Ask for description",
            label_gestionar_usuario_web: "Manage User Web",
            label_administra_la_lista_de_usuario_web: "Manage the list of user web",
            label_modificar_usuario_web: "Modify User Web",
            label_gestionar_tipo_choferes: "Manage Type Chofer",
            label_administra_la_lista_de_tipo_choferes: "Manage the list of type chofer",
            label_crear_tipo_chofer: "Create Type Chofer",
            label_modificar_tipo_chofer: "Modify Type Chofer",
            label_licencia: "Driver License",
            label_telefono: "Telephone",
            label_tipo_chofer: "Type Chofer",
            label_ejes_vehiculo: "Vehicle Axles",
            label_gestionar_requerimiento_viajes: "Manage Trip Requirements",
            label_administra_la_lista_de_requerimiento_viajes: "Manage the list of trip requirements",
            label_nuevo_requerimiento_viaje: "New trip requirement",
            label_modificar_requerimiento_viaje: "Modify trip requirement",
            label_es_transportadora_o_sindicato: "Is transport company or union?",
            label_gestionar_transportadoras_sindicato: "Manage Carriers/Unions",
            label_administra_la_lista_de_transportadoras_sindicato: "Manage the list of carriers/unions",
            label_crear_transportadora_sindicato: "Create Carrier/Union",
            label_modificar_transportadora_sindicato: "Modify Carrier/Union",
            label_gestionar_formulario_viajes: "Manage Trip Forms",
            label_administra_la_lista_de_formulario_viajes: "Manage Trip Forms List",
            label_nuevo_formulario_viaje: "New Trip Form",
            label_modificar_formulario_viaje: "Modify Trip Form",
            label_seleccione_origen: "Select Origin",
            label_seleccione_chofer: "Select driver",
            label_gestionar_programacion_camiones: "Manage Truck Scheduling",
            label_administra_la_lista_de_programacion_camiones: "Manage the list of truck scheduling",
            label_nuevo_programacion_camiones: "New Truck Scheduling",
            label_modificar_programacion_camiones: "Modify Truck Scheduling",
            label_formulario_viaje: "Trip Form",
            label_siguiente: "Next",
            label_atras: "Back",
            label_es_chofer: "Is driver",
            label_gestionar_respuesta_solicitud_programacion_camiones: "Manage State Request Truck Scheduling",
            label_administra_la_lista_de_estado_solicitud_programacion_camiones: "Manage the list of state request truck scheduling",
            label_solicitud: "Request",
            label_respuestas: "Answers",
            label_configurar_acciones_solicitud: "Configure request actions",
            label_configurar_acciones_solicitud_desc: "Configure the optional notification message and recipients for OK and X.",
            label_accion_aceptar_ok: "Accept (OK)",
            label_accion_aceptar_estado_viaje_ayuda: "When the user clicks OK, the request is updated with this trip status.",
            label_accion_rechazar_x: "Reject (X)",
            label_accion_rechazar_estado_viaje_ayuda: "When the user clicks X, the request is updated with this trip status.",
            label_mensaje_notificacion: "Notification message",
            placeholder_mensaje_notificacion_rechazo: "Enter the notification message",
            alert_solicitud_aceptada: "Request accepted",
            alert_solicitud_rechazada: "Request rejected",
            alert_configure_acciones_solicitud: "Configure OK and X: select a trip status for each action first.",
            label_fecha_inicio_viaje: "Start Trip date",
            label_fecha_fin_viaje: "End Trip date",
            label_hora_inicio_viaje: "Start Trip time",
            label_hora_fin_viaje: "End Trip time",
            label_seleccione_georuta: "Select Geofence Route",
            label_grupo_geocerca_depositos: "Group Geocerca Warehouses",
            label_orden: "Order",
            label_gestionar_prioridad_entrega: "Manage Delivery Priority",
            label_administra_la_lista_de_prioridad_entrega: "Manage the list of delivery priority",
            label_crear_prioridad_entrega: "Create Delivery Priority",
            label_modificar_prioridad_entrega: "Modify delivery priority",
            label_gestionar_solicitud_producto: "Manage Product Request",
            label_administra_la_lista_de_solicitud_producto: "Manage the list of product request",
            label_crear_solicitud_producto: "Create Product Request",
            label_modificar_solicitud_producto: "Modify product request",
            label_producto: "Product",
            label_destino: "Destination",
            label_requerimiento: "Requirement",
            label_despachado: "Dispatched",
            label_gestionar_programacion_solicitud_producto: "Manage Programation Product Request",
            label_administra_la_lista_de_programacion_solicitud_producto: "Manage the list of programation product request",
            label_gestionar_programacion_camiones_kanban: "Manage Trucks Kanban",
            label_administra_la_lista_de_programacion_camiones_kanban: "Manage the trucks kanban board",
            label_gestionar_programacion_productos_kanban: "Manage Products Kanban",
            label_administra_la_lista_de_programacion_productos_kanban: "Manage the products kanban board",
            label_este_estado_inicia_viaje: "This status starts the trip",
            label_acciones_kanban: "Kanban Actions",
            label_acciones_kanban_viaje: "Trip Kanban Actions",
            label_acciones_kanban_producto: "Product Kanban Actions",
            label_crear_acciones_kanban: "Create Kanban Actions",
            label_crear_acciones_kanban_viaje: "Create Trip Kanban Actions",
            label_crear_acciones_kanban_producto: "Create Product Kanban Actions",
            label_configurar_acciones_programacion_kanban: "Configure kanban actions",
            label_configurar_acciones_programacion_kanban_desc: "For each action, choose the destination column, optional message, and people to notify.",
            label_mover_a_kanban: "Move to kanban column",
            label_mover_a_kanban_ayuda: "When this action is clicked, the card moves to the selected column.",
            placeholder_seleccione_kanban: "Select kanban column",
            alert_configure_acciones_programacion_kanban: "Configure this action first: select a destination kanban column.",
            alert_card_movida_kanban: "Card moved to kanban column",
            label_datos_faltantes_iniciar_viaje: "Missing data to start the trip",
            label_faltan_datos_iniciar_viaje_desc: "To move this card to the column that starts trips, the form must contain the following fields:",
            label_detalle_respuestas: "Response details",
            label_sin_respuesta: "No answer",
            label_meta: "Additional data",
            label_motivo: "Reason",
            label_aprobar_solicitud: "Approve request",
            label_rechazar_solicitud: "Reject request",
            placeholder_ingrese_motivo: "Enter reason",
            alert_debe_ingresar_motivo: "You must enter a reason",
            alert_solicitud_aprobada: "Request approved",
            label_iniciar_viaje: "Start trip",
            label_viajes: "trips",
            label_mapa_viaje: "Trip map",
            alert_no_hay_columna_inicia_viaje: "No kanban column is marked as 'starts trip'. Configure it from the kanban settings.",
            label_mostrar_todos: "Show all",
            label_mostrar_seleccionados: "Selected only",
            label_seleccionar_todos: "Select all",
            label_modificar_acciones_kanban: "Modify Kanban Actions",
            label_modificar_acciones_kanban_viaje: "Modify Trip Kanban Actions",
            label_modificar_acciones_kanban_producto: "Modify Product Kanban Actions",
            label_gestionar_formulario_programacion_camiones: "Manage Form Truck Scheduling",
            label_administra_la_lista_de_formulario_programacion_camiones: "Manage the list of Form Truck Scheduling",
            label_es_viaje_aprobado: "Is trip approved",
            label_guardar_estado: "Save status",
            label_fecha_programacion_salida: "Date of programation departure",
            label_fecha_carguio: "Date of loading",
            label_distancia_alerta: "Alert distance",
            label_geocerca_origen: "Geofence Origin",
            label_geocerca_destino: "Geofence Destination",
            label_es_cliente: "It's a client",
            label_agregar_producto: "Add product",
            label_fecha_programada_inicio: "Programmed start date",
            label_fecha_programada_fin: "Programmed end date",
            label_kilo: "Kilogram",
            label_tonelada: "Ton",
            label_libra: "Pound",
            label_litro: "Liter",
            label_m3: "Cubic Meter",
            label_gallon: "Gallon",
            label_programacion_camiones: "Programation Trucks",
            label_formulario_programacion_camiones: "Form Truck Scheduling",
            label_gestionar_estado_solicitudes: "Manage State Requests",
            label_administra_la_lista_de_estado_solicitudes: "Manage the list of state requests",
            label_nuevo_estado_solicitud: "New state request",
            label_modificar_estado_solicitud: "Modify state request",
            label_estado_solicitud: "State Request",
            label_administra_la_lista_de_estado_solicitud_producto: "Manage Product Request Status List",
            label_aprobado: "Approved",
            label_rechazado: "Rejected",
            label_filtro_fecha: "Date filter",
            label_filtro_todas: "All",
            label_filtro_hoy: "Today",
            label_filtro_ayer: "Yesterday",
            label_filtro_rango: "Custom range",
            label_seleccionar_personas_alerta: "Select persons to notify",
            label_seleccionar_personas_alerta_desc: "The alerts will be sent to the emails and phone numbers of the selected persons.",
            label_notificar_sin_destinatario: "Notify without recipient",
            label_confirmar: "Confirm",
            label_formulario_solicitud_producto: "Product Request Form",

            alert_debe_seleccionar_producto: "You must select a product",
            alert_debe_ingresar_cantidad: "You must enter a quantity",
            alert_producto_ya_agregado: "Product already added",
            alert_usuario_o_contrasena_incorrecto: "Username or password incorrect",
            alert_procesando_solicitud: "Processing request...",
            alert_se_creo_correctamente: "Created correctly",
            alert_se_actualizo_correctamente: "Updated correctly",
            alert_esta_de_deshabilitar_categoria: "Are you sure you want to disable the category?",
            alert_esta_de_habilitar_categoria: "Are you sure you want to enable the category?",
            alert_se_deshabilito_correctamente: " Disabled correctly",
            alert_se_habilito_correctamente: " Enabled correctly",
            alert_debe_ingresar_nombre: "You must enter a name",
            alert_fecha_invalida: "Invalid date",
            alert_esta_de_deshabilitar_producto: "Are you sure you want to disable the product?",
            alert_esta_de_habilitar_producto: "Are you sure you want to enable the product?",
            alert_esta_de_deshabilitar_pais: "Are you sure you want to disable the country?",
            alert_esta_de_habilitar_pais: "Are you sure you want to enable the country?",
            alert_debe_ingresar_descripcion: "You must enter a description",
            alert_esta_de_deshabilitar_ciudad: "Are you sure you want to disable the city?",
            alert_esta_de_habilitar_ciudad: "Are you sure you want to enable the city?",
            alert_esta_de_deshabilitar_vendedor: "Are you sure you want to disable the seller?",
            alert_esta_de_habilitar_vendedor: "Are you sure you want to enable the seller?",
            alert_esta_de_deshabilitar: "Are you sure you want to disable?",
            alert_esta_de_habilitar: "Are you sure you want to enable?",
            alert_formato_color_invalido: "Invalid color format. Use #RRGGBB or #RGB",
            alert_debe_ingresar_al_menos_un_campo_de_requerimiento: "You must enter at least one requirement field",
            alert_label_debe_tener_mas_de_2_caracteres: "Label must have more than 2 characters",
            alert_key_no_puede_estar_vacio: "Key cannot be empty",
            alert_key_debe_ser_unico: "Key must be unique",
            alert_es_default: "It is default",
            alert_processed_successfully: "Processed successfully",
            alert_se_agrego_correctamente: "Added correctly",
            alert_debe_seleccionar_columnas: "You must select columns",
            alert_no_se_pudo_crear: "Could not create",
            alert_no_se_pudo_modificar: "Could not modify",
            alert_se_modifico_correctamente: "Modified correctly",
            alert_archivo_invalido: "Invalid file",
            alert_archivo_vacio: "Empty file",
            alert_maximo_500_elementos: "Maximum 500 elements",
            alert_debe_seleccionar_vehiculo: "You must select a vehicle",
            alert_debe_seleccionar_fecha: "You must select a date",
            alert_debe_seleccionar_formulario: "You must select a form",
            alert_no_se_pudo_leer_configuracion: "Could not read configuration",
            alert_debe_ingresar_prioridad: "You must enter a priority",
            alert_debe_seleccionar_grupo_geocerca: "You must select a group geocerca",
            alert_debe_seleccionar_al_menos_un_elemento: "You must select at least one element",
            alert_debe_seleccionar_vehiculo_fecha_formulario: "You must select a vehicle, date and form",
            alert_se_dividio_correctamente: "Divided correctly",
            alert_debe_ingresar_numero_documento: "You must enter a document number",
            alert_copiado_al_portapapeles: "Copied to clipboard",
            alert_debe_seleccionar_mas_de_un_elemento: "You must select more than one element",
            alert_se_unio_correctamente: "Joined correctly",
            alert_debe_seleccionar_unidad: "You must select a vehicle",
            alert_debe_ingresar_nombre_conductor: "You must enter a name conductor",
            alert_debe_ingresar_usuario: "You must enter a username",
            alert_debe_ingresar_password: "You must enter a password",
            alert_debe_ingresar_peso: "You must enter a weight",
            alert_debe_ingresar_volumen: "You must enter a volume",
            alert_debe_ingresar_inicio: "You must enter a start",
            alert_debe_ingresar_fin: "You must enter a end",
            alert_debe_ingresar_color: "You must enter a color",
            alert_punto_interes_no_valido: "The interest point is not valid",
            alert_error_al_calcular_distancia: "Error calculating the distance of the interest point",
            alert_vehiculo_no_seleccionado: "Vehicle not selected",
            alert_no_hay_pedidos_para_ordenar: "No orders with valid origin/destination",
            label_calcular_orden_recomendado: "Calculate recommended order",
            label_orden_recomendado: "Recommended order",
            label_sin_posicion_actual: "No live position, starting from first origin",
            label_recoger: "Pickup",
            label_entregar: "Delivery",
            label_dibujar_ruta: "Draw route",
            label_ocultar_ruta: "Hide route",
            label_calculando_tiempos: "Calculating real times…",
            label_directions_fallback: "Straight-line estimates",
            label_guardar_cambios: "Save changes",
            alert_orden_creado: "Order saved",
            alert_orden_actualizado: "Order updated",
            alert_secuencia_vacia: "No stops to save",
            alert_sin_empresa: "Company (idEmpresa) not detected",
            alert_confirmar_recalcular: "You already computed an order. Recompute and replace the current sequence?",
            alert_confirmar_recalcular_guardado: "There is already a saved order for this vehicle. Recompute and replace the sequence? Changes won't be saved until you click Save.",
            alert_orden_pickup_antes_destino: "Delivery cannot occur before its own pickup",
            label_arrastrar_para_reordenar: "Drag to reorder",
            label_estado_borrador: "Draft",
            label_estado_confirmado: "Confirmed",
            label_estado_en_curso: "In progress",
            label_estado_completado: "Completed",
            label_estado_cancelado: "Cancelled",
            label_confirmar_orden: "Confirm",
            label_iniciar_viaje_orden: "Start trip",
            label_completar_orden: "Complete",
            label_cancelar_orden: "Cancel",
            label_eliminar_orden: "Delete order",
            alert_guardar_antes_cambiar_estado: "Save the order before changing state",
            alert_guardar_cambios_pendientes: "You have unsaved changes. Save first.",
            alert_estado_actualizado: "State updated",
            alert_orden_deshabilitado: "Order removed",
            alert_no_se_pudo_deshabilitar: "Could not disable the order",
            alert_confirmar_deshabilitar_orden: "Delete (disable) this order? You can re-enable it from history.",
            label_sin_guardar: "unsaved",
            alert_punto_vehiculo_no_valido: "Vehicle position is not valid",
            alert_no_se_pudo_procesar: "Could not process",
            alert_orden_detalle_pedido_actualizada: "Order detail pedido updated",
            alert_debe_seleccionar_solo_un_elemento: "You must select only one element",
            alert_se_cambio_placa_correctamente: "Vehicle changed correctly",
            alert_debe_seleccionar_grafico: "You must select a chart",
            alert_debe_ingresar_al_menos_un_estado_de_pago: "You must enter at least one payment status",
            alert_label_no_puede_estar_vacio: "Label cannot be empty",
            alert_debe_seleccionar_concepto_geocerca: "You must select a concepto geofence",
            alert_esta_de_importar_clientes: "Are you sure you want to import clients?",
            alert_se_importaron_correctamente: "Clients imported correctly",
            alert_no_se_pudo_importar_clientes: "Could not import clients",
            alert_fecha_inicio_debe_ser_menor_a_fecha_fin: "The start date must be less than the end date",
            alert_maximo_31_dias_por_consulta: "Maximum 31 days for query",
            alert_procesando_solicitud_detalle_pedido: "Processing request for detail order",
            alert_fecha_inicio_no_valido: "Date Start Invalid",
            alert_fecha_fin_no_valido: "Date End Invalid",
            alert_hora_inicio_no_valido: "Start time invalid (use 24h HH:mm)",
            alert_hora_fin_no_valido: "End time invalid (use 24h HH:mm)",
            alert_debe_seleccionar_geocerca_inicio: "You must select a geocerca inicio",
            alert_debe_seleccionar_geocerca_fin: "You must select a geocerca fin",
            alert_debe_seleccionar_georuta: "You must select a georuta",
            alert_debe_ingresar_cantidad_vehiculos_requeridos: "You must enter a quantity of required vehicles",
            alert_debe_seleccionar_estado_viaje: "You must select a state trip",
            alert_debe_seleccionar_tipo_usuario_movil: "You must select a type user mobile",
            alert_debe_ingresar_confirmar_password: "You must enter a confirm password",
            alert_debe_ingresar_nombre_usuario: "You must enter a user name",
            alert_la_contraseña_y_la_confirmación_de_la_contraseña_no_coinciden: "The password and the confirmation password do not match",
            alert_debe_seleccionar_rol_usuario_web: "You must select a role user web",
            alert_usuario_movil_ya_existe: "The user mobile already exists",
            alert_se_cambio_fecha_entrega_correctamente: "The delivery date was changed correctly",
            alert_debe_seleccionar_formulario_viaje: "You must select a trip form",
            alert_no_se_pudo_obtener_campos_dinamicos: "Could not obtain dynamic fields",
            alert_debe_ingresar_orden: "You must enter an order",
            alert_debe_ingresar_orden_numerico: "You must enter a numeric order",
            alert_debe_ingresar_peso_valido: "You must enter a valid weight",
            alert_debe_ingresar_etiqueta: "You must enter a label",
            alert_numero_invalido: "Invalid number",
            alert_debe_seleccionar_unidad_medida: "You must select a unit of measure",
            alert_debe_seleccionar_cliente: "You must select a client",

            menu_dashboard: "Dashboard",
            menu_administracion: "Management",
            menu_categorias: "Categories",
            menu_salir: "Exit",
            menu_productos: "Products",
            menu_pais: "Countries",
            menu_ciudades: "Cities",
            menu_vendedores: "Sellers",
            menu_estados: "Statuses",
            menu_grupo_clientes: "Group Clients",
            menu_clientes: "Clients",
            menu_estado_pago: "Payment Status",
            menu_quien_recibe_entrega: "Who Receives Delivery",
            menu_formulario: "Form",
            menu_asignacion: "Assignment",
            menu_configuracion: "Settings",
            menu_principal: "Main",
            menu_almacen: "Warehouse",
            menu_seguimiento: "Tracking",
            menu_mapa: "Map",
            menu_grilla: "Grid",
            menu_tipo_cliente: "Type Client",
            menu_grupo_geocerca: "Group Geocerca",
            menu_usuarios: "Users",
            menu_usuarios_web: "Users Web",
            menu_usuarios_movil: "Users Mobile",
            menu_tipo_usuario_web: "Type User Web",
            menu_tipo_usuario_movil: "Type User Mobile",
            menu_rol_usuario_web: "Role User Web",
            menu_progress_bar: "Progress Bar",
            menu_reportes: "Reports",
            menu_reporte_estado_entregas: "Delivery status",
            menu_incidente: "Incident",
            menu_estado_incidente: "Incident Status",
            menu_lista_incidentes: "List of incidents",
            menu_persona: "Person",
            menu_resumen_entregas: "Summary of deliveries",
            menu_viaje: "Trip",
            menu_lista_viajes: "List of trips",
            menu_estado_viajes: "Status Trips",
            menu_gestionar_clientes: "Manage Clients",
            menu_mapa_clientes: "Map Clients",
            menu_configuracion_clientes: "Configuration Clients",
            menu_paises: "Countries",
            menu_estado_de_pago: "Payment Status",
            menu_asignacion_principal: "Main Assignment",
            menu_asignacion_configuracion: "Assignment Configuration",
            menu_seguimiento_mapa: "Tracking Map",
            menu_seguimiento_grilla: "Tracking Grid",
            menu_reporte_resumen_entregas: "Summary of deliveries",
            menu_programacion_viajes: "Programation Trips",
            menu_tipo_carguio: "Loading Type",
            menu_registro_camiones: "Vehicle Registration",
            menu_kanban: "Kanban",
            menu_kanban_viaje: "Trip Kanban",
            menu_kanban_producto: "Product Kanban",
            menu_estado_vehiculo: "Vehicle Status",
            menu_ejes_vehiculo: "Vehicle Axles",
            menu_tipo_chofer: "Type Chofer",
            menu_lista_estado_vehiculo: "List Vehicle Status",
            menu_lista_ejes_vehiculo: "List Vehicle Axle",
            menu_formulario_viaje: "Trip Form",
            menu_gestionar_transportadora_sindicato: "Manage Carrier/Union",
            menu_formulario_programacion_camiones: "Form Truck Scheduling",
            menu_estado_solicitud_programacion_camiones: "Status Request Truck Scheduling",
            menu_solicitud_producto: "Product Request",
            menu_seguimiento_viaje: "Trip tracking",
            menu_prioridad_entrega: "Delivery Priority",
            menu_programacion_solicitud_productos: "Programation Product Request",
            menu_respuesta_solicitud_programacion_camiones: "Response Request Truck Scheduling",
            menu_listar_solicitud_programacion_camiones: "List Request Truck Scheduling",
            menu_listar_solicitud_producto: "List Request Product",
            menu_programacion: "Programation",
            menu_programacion_camiones_kanban: "Trucks Kanban",
            menu_programacion_productos_kanban: "Products Kanban",
            menu_estado_solicitud: "Status Request",

            grilla_placeholderbuscar: "Search",
            column_acciones: "Actions",
            column_descripcion: "Description",
            column_nota: "Note",
            column_fechaProceso: "Process Date",
            column_modificar: "Modify",
            column_eliminar: "Delete",
            column_deshabilitar: "Disable",
            column_habilitar: "Enable",
            column_estado: "Status",
            column_habilitado: "Enabled",
            column_deshabilitado: "Disabled",
            column_categoria: "Category",
            column_codigo: "Code",
            column_nombre: "Name",
            column_pais: "Country",
            column_sub_status: "Sub Status",
            column_latitud: "Latitude",
            column_longitud: "Longitude",
            column_hacer_default: "Make Default",
            column_es_default: "It is Default",
            column_numero_documento: "Document Number",
            column_codigo_cliente: "Client Code",
            column_nombre_cliente: "Client Name",
            column_latitud_cliente: "Client Latitude",
            column_longitud_cliente: "Client Longitude",
            column_direccion_cliente: "Client Address",
            column_telefono_cliente: "Client Phone",
            column_fecha_factura: "Invoice Date",
            column_numero_factura: "Invoice Number",
            column_valor_factura: "Invoice Value",
            column_codigo_almacen: "Warehouse Code",
            column_nombre_almacen: "Warehouse Name",
            column_latitud_almacen: "Warehouse Latitude",
            column_longitud_almacen: "Warehouse Longitude",
            column_codigo_producto: "Product Code",
            column_nombre_producto: "Product Name",
            column_unidad_medida: "Unit of Measure",
            column_cantidad: "Quantity",
            column_peso: "Weight",
            column_volumen: "Volume",
            column_monto: "Amount",
            column_moneda: "Currency",
            column_codigo_vendedor: "Seller Code",
            column_nombre_vendedor: "Seller Name",
            column_region: "Region",
            column_fecha_entrega: "Delivery Date",
            column_numero_embarque: "Shipment Number",
            column_tipo_servicio: "Service Type",
            column_estado_pago: "Payment Status",
            column_telefonos_notificacion: "Notification Phones",
            column_correos_notificacion: "Notification Emails",
            column_prefijo: "Prefix",
            column_observaciones: "Observations",
            column_prioridad: "Priority",
            column_tipo_cliente: "Type Client",
            column_color: "Color",
            column_ciudad: "City",
            column_usuario: "User",
            column_password: "Password",
            column_tipo_usuario_movil: "Type User Mobile",
            column_vehiculo: "Vehicle",
            column_formulario: "Form",
            column_detalles: "Details",
            column_placa: "Plate",
            column_si: "Yes",
            column_no: "No",
            column_pedir_descripcion: "Ask for description",
            column_inicio: "Start",
            column_fin: "End",
            column_cliente: "Client",
            column_geocerca: "Geofence",
            column_estado_pendiente: "Pending Status",
            column_estado_iniciado: "Started Status",
            column_sub_estado: "Sub Status",
            column_latitud_workflow: "Latitude Workflow",
            column_longitud_workflow: "Longitude Workflow",
            column_fecha_proceso: "Process Date",
            column_finalizado: "Finalized",
            column_coordenadas_cliente: "Client Coordinates",
            column_coordenadas_inicio_atencion: "Start Atention Coordinates",
            column_coordenadas_fin_atencion: "End Atention Coordinates",
            column_concepto_geocerca: "Geofence Concept",
            column_geocerca_inicio: "Geofence Start",
            column_geocerca_fin: "Geofence End",
            column_fecha_inicio: "Start Date",
            column_hora_inicio: "Start Time",
            column_fecha_fin: "End Date",
            column_hora_fin: "End Time",
            column_nombre_usuario: "User Name",
            column_tipo_usuario_web: "Type User Web",
            column_rol_usuario_web: "Role User Web",
            column_reset_password: "Reset Password",
            column_grupo: "Group",
            column_producto: "Product",
            column_requerimiento: "Requirement",
            column_despachado: "Dispatched",
            column_fecha_entrega_programada: "Delivery Date Programmed",
            column_fecha_programacion_salida: "Departure Date Programmed",
            column_fecha_carguio: "Loading Date",
            column_fecha_entrega_excel: "Delivery Date Excel",
            column_fecha_hora_entrada_geocerca: "Entry date/time",
            column_fecha_hora_salida_geocerca: "Exit date/time",
            column_tiempo_estadia_geocerca: "Stay duration",
            column_nro: "No.",
            column_weight: "Weight",
            column_sub_estados: "Sub Statuses",
            column_telefonos: "Phones",
            column_correos: "Emails",
            column_estado_incidente: "Incident Status",
            column_sub_estado_incidente: "Incident Sub Status",
            column_nombre_chofer: "Chofer Name",
            column_fecha_hora_incidente: "Incident Date/Time",
            column_fecha_registro: "Registration Date",
            column_nombre_conductor: "Conductor Name",
            column_notificar_a: "Notify to",
            column_permisos: "Permissions",
            column_formulario_viaje: "Trip Form",
            column_fecha_hora_inicio_atencion: "Start Atention Date/Time",
            column_fecha_hora_fin_atencion: "End Atention Date/Time",
            column_fecha_entrega_conductor: "Delivery Date Conductor",
            column_almacen: "Warehouse",

            placeholder_seleccione_estado: "Select Status",
            placeholder_seleccione_categoria: "Select Category",
            placeholder_ingresa_nombre: "Enter name",
            placeholder_ingresa_nota: "Enter note",
            placeholder_ingresa_codigo: "Enter code",
            placeholder_ingresa_descripcion: "Enter description",
            placeholder_seleccione_pais: "Select Country",
            placeholder_seleccione_grupo_cliente: "Select Group Client",
            placeholder_seleccione_ciudad: "Select City",
            placeholder_ingresa_latitud: "Enter latitude",
            placeholder_ingresa_longitud: "Enter longitude",
            placeholder_seleccione_tipo: "Select type",
            placeholder_ingresa_texto: "Enter text",
            placeholder_ingresa_numero: "Enter number",
            placeholder_ingresa_etiqueta: "Enter label",
            placeholder_ingresa_key: "Enter key",
            placeholder_seleccione_estado_de_pago: "Select payment status",
            placeholder_seleccione_quien_recibe_entrega: "Select who receives delivery",
            placeholder_seleccione_vehiculo: "Select vehicle",
            placeholder_seleccione_fecha: "Select date YYYY-MM-DD",
            placeholder_seleccione_formulario: "Select form",
            placeholder_ingresa_prioridad: "Enter priority",
            placeholder_seleccione_tipo_cliente: "Select type client",
            placeholder_seleccione_grupo_geocerca: "Select group geocerca",
            placeholder_seleccione_geocerca: "Select geocerca",
            placeholder_seleccione_geocercas: "Select geocercas",
            placeholder_seleccione_unidad: "Select vehicle",
            placeholder_seleccione_tipo_usuario_movil: "Select type user mobile",
            placeholder_ingresa_peso: "Enter weight",
            placeholder_ingresa_volumen: "Enter volume",
            placeholder_ingresa_nombre_conductor: "Enter name conductor",
            placeholder_ingresa_usuario: "Enter user",
            placeholder_ingresa_password: "Enter password",
            placeholder_ingresa_inicio: "Enter start",
            placeholder_ingresa_fin: "Enter end",
            placeholder_seleccione_grafico: "Select chart",
            placeholder_seleccione_concepto_geocerca: "Select concepto geocerca",
            placeholder_ingrese_numero_documento: "Enter document number",
            placeholder_seleccione_persona: "Select person",
            placeholder_seleccione_fecha_hora: "Select date/time",
            placeholder_seleccione_grupo: "Select group",
            placeholder_seleccione_sub_grupo: "Select sub group",
            placeholder_seleccione_vehiculos: "Select vehicles",
            placeholder_seleccione_georuta: "Select georuta",
            placeholder_ingresa_cantidad_vehiculos_requeridos: "Enter quantity of required vehicles",
            placeholder_seleccione_estado_viaje: "Select status trip",
            placeholder_seleccione_hora: "Select hour",
            placeholder_ingresa_nombre_usuario: "Enter user name",
            placeholder_seleccione_rol_usuario_web: "Select role user web",
            placeholder_ingresa_licencia: "Enter driver license",
            placeholder_ingresa_telefono: "Enter telephone",
            placeholder_seleccione_tipo_chofer: "Select type chofer",
            placeholder_seleccione_ejes_vehiculo: "Select vehicle axle",
            placeholder_seleccione_formulario_viaje: "Select trip form",
            placeholder_seleccionar_tipo_kanban: "Select kanban type",
            placeholder_seleccione_transportadora: "Select Shipping Company",
            placeholder_seleccione_geocerca_origen: "Select Origin Geocerca",
            placeholder_seleccione_geocerca_destino: "Select Destination Geocerca",
            placeholder_seleccione_producto: "Select Product",
            placeholder_seleccione_tipo_de_carga: "Select Type of Load",
            placeholder_seleccione_chofer: "Select Driver",
            placeholder_seleccione_estado_vehiculo: "Select vehicle status",
            placeholder_seleccione_geocerca_georuta: "Select Geofence Route",
            placeholder_ingresa_orden: "Enter order",
            placeholder_ingresa_grupo: "Enter group",
            placeholder_ingresa_requerimiento: "Enter requirement",
            placeholder_ingresa_despachado: "Enter dispatched",
            placeholder_seleccione_prioridad: "Select priority",
            placeholder_ingresa_distancia_alerta: "Enter alert distance",
            placeholder_ingresa_cantidad: "Enter quantity",
            placeholder_seleccione_unidad_medida: "Select Unit of Measure",
            placeholder_seleccione_cliente: "Select Client",
            placeholder_seleccione_estado_solicitud: "Select status request",

            titulo_configuracion_asignacion: "Settings Assignment",
            titulo_crear_asignacion: "Create Assignment",


            title_empresa: "COMPANY",
            title_nombre_del_chofer: "DRIVER NAME",
            title_fecha: "DATE",
            title_placa_del_camion: "VEHICLE PLATE",
            title_n_documento: "DOCUMENT NUMBER",
            title_hora_de_salida: "DEPARTURE TIME",
            title_hora_de_retorno: "RETURN TIME",
            title_fecha_emision: "EMISSION DATE",
            title_n_venta: "SALE NUMBER",
            title_n_factura: "INVOICE NUMBER",
            title_cliente: "CLIENT",
            title_verificado: "VERIFIED",
            title_tiempo: "TIME",

            chart_pie_chart_estados: "Statuses",
            chart_estado_pagos: "Payment Statuses",

            btn_productos: "Products",
            btn_workflow: "Workflow",
            btn_ver: "View",
            btn_agregar: "Add",
            btn_guardar: "Save",
            btn_buscar: "Search",
            btn_eliminar: "Delete",
            btn_nuevo: "New",
            btn_modificar: "Modify",
            btn_deshabilitar: "Disable",
            btn_habilitar: "Enable",
            btn_permisos: "Permissions",
            btn_importar: "Import",
            btn_exportar: "Export",
            btn_aceptar: "Accept",
            btn_cancelar: "Cancel",
            btn_sub_estados: "Sub Statuses",
            btn_default: "Default",
            btn_configuracion: "Configuration",
            btn_limpiar: "Clean",
            btn_eliminar_pedido: "Delete Order",
            btn_detalles_pedido: "Order Details",
            btn_eliminar_detalle_pedido: "Delete Detail Order",
            btn_configuracion_placa: "Configuration Plate",
            btn_filtros: "Filters",
            btn_configuracion_pedido: "Configuration Order",
            btn_acciones: "Actions",
            label_aplicar_template: "Apply template",
            label_guardar_como_template: "Save as template",
            label_gestionar_templates: "Manage templates",
            label_template_global: "Available to all users (global)",
            label_global: "Global",
            label_campos: "fields",
            label_aplicar: "Apply",
            label_deshabilitar: "Disable",
            placeholder_seleccione_template: "Select a template",
            alert_debe_seleccionar_template: "Select a template",
            alert_no_hay_campos_para_guardar: "No fields to save",
            alert_debe_ingresar_nombre: "You must enter a name",
            alert_se_deshabilito_correctamente: "Successfully disabled",
            alert_campos_template_omitidos_duplicados: "Some template fields were skipped because their semantic flag was already present",
            label_vehiculo_viaje: "Trip vehicle",
        }
    },
    es: {
        translation: {
            label_seguimiento_en_tiempo_real: "Seguimiento en Tiempo Real",
            label_gestion_de_entregas: "Gestión de Entregas",
            label_optimizacion_de_rutas: "Optimización de Rutas",
            label_notificaciones_automaticas: "Notificaciones Automáticas",
            label_reportes_detallados: "Reportes Detallados",
            label_etas_precisos: "ETAs Precisos",
            label_mayor_satisfaccion_del_cliente: "Mayor Satisfacción del Cliente",
            label_reduccion_de_costos: "Reducción de Costos",
            label_escalabilidad: "Escalabilidad",
            label_entregas_puntuales: "Entregas Puntuales",
            label_tus_clientes_pueden_ver_exactamente_donde_esta_su_pedido_en_todo_momento: "Tus clientes pueden ver exactamente dónde está su pedido en todo momento",
            label_carga_y_administra_todas_tus_entregas_desde_una_unica_plataforma: "Carga y administra todas tus entregas desde una única plataforma",
            label_algoritmos_inteligentes_para_las_rutas_mas_eficientes: "Algoritmos inteligentes para las rutas más eficientes",
            label_alertas_instantaneas_para_clientes_y_gestores_de_flota: "Alertas instantáneas para clientes y gestores de flota",
            label_analitica_completa_de_tiempos_eficiencia_y_satisfaccion: "Análisis completo de tiempo, eficiencia y satisfacción",
            label_tiempos_estimados_de_llegada_actualizados_en_tiempo_real: "Tiempos estimados de llegada actualizados en tiempo real",
            label_transparencia_total_en_cada_entrega_genera_confianza_y_lealtad: "Transparencia total en cada entrega genera confianza y lealtad",
            label_optimiza_rutas_y_reduce_llamadas_de_dnde_esta_mi_pedido: "Optimiza rutas y reduce llamadas de \"¿dónde está mi pedido?\"",
            label_crece_sin_limites_desde_1_hasta_10000_entregas_diarias: "Crece sin límites, desde 1 hasta 10,000 entregas diarias",
            label_mejora_tus_tiempos_de_entrega_hasta_un_40: "Mejora tus tiempos de entrega hasta un 40%",
            label_ultima_milla: "Ultima Milla",
            label_ultima_milla_corto: "UM",
            label_tms: "TMS",
            label_caracteristicas: "Características",
            label_beneficios: "Beneficios",
            label_contacto: "Contacto",
            label_iniciar_sesion: "Iniciar Sesión",
            label_comenzar_ahora: "Comenzar Ahora",
            label_ultima_milla_inteligente: "Ultima Milla Inteligente",
            label_transforma_tus_entregas_en: "Transforma tus entregas en",
            label_experiencias_inolvidables: "Experiencias inolvidables",
            label_la_plataforma_de_seguimiento_en_tiempo_real_que_conecta_tu_empresa_con_tus_clientes: "La plataforma de seguimiento en tiempo real que conecta tu empresa con tus clientes.",
            label_ellos_ven_exactamente_donde_esta_su_pedido_tu_optimizas_cada_entrega: "Ellos ven exactamente dónde está su pedido, tú optimizas cada entrega.",
            label_ver_demo: "Ver Demo",
            label_mejora_en_tiempos_de_entrega: "Mejora en tiempos de entrega",
            label_satisfaccion_del_cliente: "Satisfacción del Cliente",
            label_reduccion_de_llamadas: "Reducción de Llamadas",
            label_todo_lo_que_necesitas_para_tms: "Todo lo que necesitas para TMS",
            label_una_plataforma_completa_diseñada_para_empresas_que_entregan_productos_personalizados: "Una plataforma completa diseñada para empresas que entregan productos personalizados",
            label_como_funciona: "Cómo funciona",
            label_tan_simple_que_empezaras_en_minutos: "Tan simple que empezarás en minutos",
            label_carga_tus_entregas: "Carga tus entregas",
            label_sube_tu_lista_de_pedidos_con_direcciones_de_clientes_puedes_hacerlo_manualmente_o_mediante_excel_api: "Sube tu lista de pedidos con direcciones de clientes. Puedes hacerlo manualmente o mediante Excel/API.",
            label_asigna_vehiculos: "Asigna vehículos",
            label_el_sistema_optimiza_rutas_automaticamente_tus_conductores_reciben_las_entregas_en_su_app_movil: "El sistema optimiza rutas automáticamente. Tus conductores reciben las entregas en su app móvil.",
            label_clientes_rastrean: "Clientes rastrean",
            label_tus_clientes_reciben_un_link_unico_para_ver_en_tiempo_real_donde_esta_su_pedido_sin_llamadas_ni_dudas: "Tus clientes reciben un link único para ver en tiempo real dónde está su pedido. ¡Sin llamadas ni dudas!",
            label_por_que_elegirnos: "¿Por qué elegirnos?",
            label_ventajas_que_transformaran_tu_operacion: "Ventajas que transformarán tu operación",
            label_listo_para_revolucionar_tus_entregas: "¿Listo para revolucionar tus entregas?",
            label_unete_a_las_empresas_que_ya_estan_ofreciendo_la_mejor_experiencia_de_entrega: "Únete a las empresas que ya están ofreciendo la mejor experiencia de entrega",
            label_hablar_con_ventas: "Hablar con ventas",
            label_politica_de_privacidad: "Política de Privacidad y Términos de Uso",
            label_ultima_actualizacion: "Última actualización",
            label_politica_intro: "Este documento describe los términos de uso y las prácticas de privacidad aplicables a la plataforma DataTerra TMS (Sistema de Gestión de Transporte) y a los productos relacionados ofrecidos por nuestra empresa.",
            label_politica_seccion_servicio_titulo: "1. Sobre el servicio",
            label_politica_seccion_servicio_texto: "DataTerra TMS es una plataforma de software que permite a empresas y usuarios registrarse y utilizar herramientas para la gestión de entregas, optimización de rutas, seguimiento en tiempo real y operaciones logísticas relacionadas. El acceso a la plataforma puede requerir registro y la aceptación de estos términos.",
            label_politica_seccion_proveedor_titulo: "2. Rol del proveedor",
            label_politica_seccion_proveedor_texto: "Actuamos únicamente como proveedor tecnológico del software TMS, las aplicaciones móviles y cualquier otro producto digital disponible bajo la marca DataTerra. No operamos su negocio logístico, no controlamos sus entregas y no somos parte de las relaciones entre usted y sus clientes, conductores o terceros.",
            label_politica_seccion_responsabilidad_titulo: "3. Limitación de responsabilidad",
            label_politica_seccion_responsabilidad_texto: "En la máxima medida permitida por la ley aplicable, DataTerra y sus afiliados no serán responsables por daños directos, indirectos, incidentales, especiales o consecuentes derivados del uso o la imposibilidad de uso del software, la aplicación móvil, las APIs o cualquier otro producto o servicio que proporcionemos. No somos responsables de ninguna manera por el uso que usted, su organización, sus empleados, contratistas o usuarios finales hagan de la plataforma, incluidos, entre otros, los datos ingresados, las rutas planificadas, las comunicaciones enviadas o las decisiones comerciales tomadas con nuestras herramientas.",
            label_politica_seccion_uso_usuario_titulo: "4. Responsabilidad del usuario y del cliente",
            label_politica_seccion_uso_usuario_texto: "Usted es el único responsable de las credenciales de su cuenta, la exactitud de la información que cargue, el cumplimiento de las leyes y regulaciones locales, y el uso adecuado del software en sus operaciones. Usted acepta utilizar el TMS y los productos relacionados solo con fines lícitos y bajo su propio riesgo.",
            label_politica_seccion_cambios_titulo: "5. Cambios en los términos y condiciones",
            label_politica_seccion_cambios_texto: "Podemos modificar estos términos, esta política de privacidad, los precios, las funcionalidades o cualquier otra condición de uso en cualquier momento y a nuestra entera discreción. Los cambios pueden entrar en vigor de inmediato al publicarse en esta página o dentro de la aplicación. No estamos obligados a notificar previamente a los usuarios o clientes. El uso continuado del software después de los cambios constituye su aceptación de los términos actualizados.",
            label_politica_seccion_privacidad_titulo: "6. Privacidad y datos",
            label_politica_seccion_privacidad_texto: "La información procesada a través de la plataforma se utiliza para proporcionar y mejorar el servicio. Usted sigue siendo el titular de sus datos operativos. Implementamos medidas de seguridad razonables; sin embargo, ningún sistema es completamente seguro. Para consultas sobre el tratamiento de datos, contáctenos con la información indicada abajo.",
            label_politica_seccion_aceptacion_titulo: "7. Aceptación",
            label_politica_seccion_aceptacion_texto: "Al crear una cuenta, iniciar sesión o utilizar cualquier producto DataTerra, usted reconoce que ha leído, comprendido y acepta esta Política de Privacidad y Términos de Uso.",
            label_politica_volver_landing: "Volver al inicio",
            label_plataforma_de_ultima_milla: "Plataforma de Ultima Milla",
            label_usuario: "Usuario",
            label_contrasena: "Contraseña",
            label_mostrar_contrasena: "Mostrar contraseña",
            label_ocultar_contrasena: "Ocultar contraseña",
            label_ingresar: "Ingresar",
            label_volver_al_inicio: "Volver al Inicio",
            label_ingresa_tus_credenciales_para_continuar: "Ingresa tus credenciales para continuar",
            label_cargando: "Cargando...",
            label_ingresa_tu_usuario: "Ingresa tu usuario",
            label_ingresa_tu_contrasena: "Ingresa tu contraseña",
            label_gestionar_categoria: "Gestionar Categoría",
            label_administra_la_lista_de_categorias: "Administra la lista de categorías",
            label_estado: "Estado",
            label_buscar: "Buscar",
            label_nuevo: "Nuevo",
            label_compartir: "Compartir",
            alert_enlace_copiado: "Enlace copiado",
            alert_no_se_pudo_compartir: "No se pudo compartir",
            label_peticion_enviada_titulo: "Petición enviada correctamente",
            label_peticion_enviada_mensaje: "Su petición fue enviada al servidor correctamente.",
            label_puede_cerrar_pestana: "Ya puede cerrar esta pestaña.",
            label_cerrar_pestana: "Cerrar pestaña",
            label_gestionar_producto: "Gestionar Producto",
            label_administra_la_lista_de_productos: "Administra la lista de productos",
            label_crear_producto: "Crear Producto",
            label_categoria: "Categoría",
            label_codigo: "Código",
            label_nombre: "Nombre",
            label_nota: "Nota",
            label_modificar_producto: "Modificar Producto",
            label_modificar_pais: "Modificar País",
            label_crear_pais: "Crear País",
            label_descripcion: "Descripción",
            label_gestionar_paises: "Gestionar Países",
            label_administra_la_lista_de_paises: "Administra la lista de países",
            label_gestionar_ciudades: "Gestionar Ciudades",
            label_administra_la_lista_de_ciudades: "Administra la lista de ciudades",
            label_modificar_ciudad: "Modificar Ciudad",
            label_crear_ciudad: "Crear Ciudad",
            label_pais: "País",
            label_modificar_vendedor: "Modificar Vendedor",
            label_crear_vendedor: "Crear Vendedor",
            label_gestionar_vendedores: "Gestionar Vendedores",
            label_administra_la_lista_de_vendedores: "Administra la lista de vendedores",
            label_modificar_estado: "Modificar Estado",
            label_crear_estado: "Crear Estado",
            label_gestionar_estados: "Gestionar Estados",
            label_administra_la_lista_de_estados: "Administra la lista de estados",
            label_modificar_sub_estado: "Modificar Sub Estado",
            label_crear_sub_estado: "Crear Sub Estado",
            label_gestionar_sub_estados: "Gestionar Sub Estados",
            label_administra_la_lista_de_sub_estados: "Administra la lista de sub estados",
            label_modificar_grupo_cliente: "Modificar Grupo Cliente",
            label_crear_grupo_cliente: "Crear Grupo Cliente",
            label_gestionar_grupo_clientes: "Gestionar Grupo Clientes",
            label_administra_la_lista_de_grupo_clientes: "Administra la lista de grupo clientes",
            label_modificar_cliente: "Modificar Cliente",
            label_crear_cliente: "Crear Cliente",
            label_gestionar_clientes: "Gestionar Clientes",
            label_administra_la_lista_de_clientes: "Administra la lista de clientes",
            label_grupo_cliente: "Grupo Cliente",
            label_ciudad: "Ciudad",
            label_latitud: "Latitud",
            label_longitud: "Longitud",
            label_mapa: "Mapa",
            label_telefonos: "Telefonos",
            label_email: "Email",
            label_color: "Color",
            label_seleccionar_color: "Seleccionar color",
            label_usuarios_permitidos: "Usuarios permitidos",
            placeholder_seleccione_usuarios: "Seleccione usuarios",
            alert_accion_creada_usuarios_error: "La acción se creó pero no se pudieron guardar todos los permisos de usuarios",
            alert_accion_modificada_usuarios_error: "La acción se modificó pero no se pudieron sincronizar todos los permisos de usuarios",
            label_gestionar_telefono: "Gestionar Teléfono",
            label_aceptar: "Aceptar",
            label_cancelar: "Cancelar",
            label_gestionar_email: "Gestionar Email",
            label_modificar_estado_pago: "Modificar Estado de Pago",
            label_modificar_estado_pedido: "Modificar estado del pedido",
            label_crear_estado_pago: "Crear Estado de Pago",
            label_gestionar_estado_pago: "Gestionar Estados de Pago",
            label_administra_la_lista_de_estado_pago: "Administra la lista de estados de pago",
            label_agregar_campo: "Agregar Campo",
            label_agregar: "Agregar",
            label_no_hay_campos: "No hay campos agregados",
            label_etiqueta: "Etiqueta",
            label_tipo: "Tipo",
            label_texto: "Texto",
            label_numero: "Número",
            label_fecha: "Fecha",
            label_valor: "Valor",
            label_habilitado: "Habilitado",
            label_deshabilitado: "Deshabilitado",
            label_eliminar: "Eliminar",
            label_placeholder: "Placeholder",
            label_hora: "Hora",
            label_hora_salida: "Hora salida",
            label_hora_llegada: "Hora llegada",
            label_fecha_salida: "Fecha salida",
            label_fecha_llegada: "Fecha llegada",
            label_seleccione_transportadora: "Seleccione Transportadora",
            label_estado_vehiculo: "Estado vehículo",
            label_seleccione_vehiculo: "Seleccione vehículo",
            label_seleccione_destino: "Seleccione destino",
            label_seleccione_producto: "Seleccione producto",
            label_seleccione_tipo_de_carga: "Seleccione tipo de carga",
            label_input_cantidad: "Cantidad",
            label_date_time: "Fecha y Hora",
            label_only_letters_and_underscore_allowed: "Solo letras y guiones bajos permitidos",
            label_gestionar_quien_recibe_entrega: "Gestionar Quién Recibe Entrega",
            label_administra_la_lista_de_quien_recibe_entrega: "Administra la lista de quién recibe entrega",
            label_crear_quien_recibe_entrega: "Crear Quién Recibe Entrega",
            label_modificar_quien_recibe_entrega: "Modificar Quién Recibe Entrega",
            label_gestionar_formulario: "Gestionar Formulario",
            label_administra_la_lista_de_formulario: "Administra la lista de formulario",
            label_crear_formulario: "Crear Formulario",
            label_modificar_formulario: "Modificar Formulario",
            label_firma: "Firma",
            label_fotografia: "Fotografia",
            label_estado_de_pago: "Estado de Pago",
            label_quien_recibe_entrega: "Persona Entregando / Persona Recibiendo",
            label_key: "key",
            label_campo: "Campo",
            label_tms_inteligente: "TMS Inteligente",
            label_numero_documento: "Número de Documento",
            label_codigo_cliente: "Código de Cliente",
            label_nombre_cliente: "Nombre de Cliente",
            label_latitud_cliente: "Latitud Cliente",
            label_longitud_cliente: "Longitud Cliente",
            label_direccion_cliente: "Dirección Cliente",
            label_telefono_cliente: "Teléfono Cliente",
            label_fecha_factura: "Fecha de Factura",
            label_numero_factura: "Número de Factura",
            label_valor_factura: "Valor de Factura",
            label_codigo_almacen: "Código de Almacén",
            label_nombre_almacen: "Nombre de Almacén",
            label_latitud_almacen: "Latitud Almacén",
            label_longitud_almacen: "Longitud Almacén",
            label_codigo_producto: "Código de Producto",
            label_nombre_producto: "Nombre de Producto",
            label_unidad_medida: "Unidad de Medida",
            label_cantidad: "Cantidad",
            label_peso: "Peso",
            label_capacidad_carga: "Capacidad de carga",
            label_peso_esta_solicitud: "Peso de esta solicitud",
            label_peso_otras_solicitudes: "Peso de otras solicitudes",
            label_peso_total: "Peso total",
            label_exceso: "Exceso",
            label_solicitudes_en_conflicto: "Solicitudes en conflicto",
            alert_capacidad_carga_excedida: "Capacidad de carga del vehículo excedida",
            label_carga_asignada_vehiculo: "Carga asignada al vehículo",
            label_desglose_por_unidad: "Desglose por unidad",
            label_disponible: "Disponible",
            label_ver_carga_asignada: "Ver carga asignada",
            label_sin_periodo_definido: "Sin período definido (mostrando solo esta solicitud)",
            alert_no_se_pudo_obtener_info_vehiculo: "No se pudo obtener información del vehículo",
            label_volumen: "Volumen",
            label_monto: "Monto",
            label_moneda: "Moneda",
            label_codigo_vendedor: "Código de Vendedor",
            label_nombre_vendedor: "Nombre de Vendedor",
            label_region: "Región",
            label_fecha_entrega: "Fecha de Entrega",
            label_numero_embarque: "Número de Embarque",
            label_tipo_servicio: "Tipo de Servicio",
            label_estado_pago: "Estado de Pago",
            label_telefonos_notificacion: "Teléfonos de Notificación",
            label_correos_notificacion: "Correos de Notificación",
            label_prefijo: "Prefijo",
            label_observaciones: "Observaciones",
            label_importar: "Importar",
            label_exportar: "Exportar",
            label_importar_general: "Importar General",
            label_importar_personalizado: "Importar Personalizado",
            label_vehiculo: "Vehiculo",
            label_formulario: "Formulario",
            label_limpiar: "Limpiar",
            label_gestionar_almacen: "Gestionar Almacén",
            label_administra_la_lista_de_almacen: "Administra la lista de almacén",
            label_crear_almacen: "Crear Almacén",
            label_modificar_almacen: "Modificar Almacén",
            label_gestionar_tipo_cliente: "Gestionar Tipo Cliente",
            label_administra_la_lista_de_tipo_cliente: "Administra la lista de tipo cliente",
            label_crear_tipo_cliente: "Crear Tipo Cliente",
            label_modificar_tipo_cliente: "Modificar Tipo Cliente",
            label_prioridad: "Prioridad",
            label_tipo_cliente: "Tipo Cliente",
            label_detalle: "Detalle",
            label_seleccionar_fecha: "Seleccionar fecha",
            label_ver_detalle: "Ver detalle",
            label_gestionar_grupo_geocerca: "Gestionar Grupo Geocerca",
            label_administra_la_lista_de_grupo_geocerca: "Administra la lista de grupo geocerca",
            label_crear_grupo_geocerca: "Crear Grupo Geocerca",
            label_modificar_grupo_geocerca: "Modificar Grupo Geocerca",
            label_grupo_geocerca: "Grupo Geocerca",
            label_geocerca: "Geocerca",
            label_opciones_avanzadas: "Opciones Avanzadas",
            tooltip_opciones_avanzadas_vehiculo: "Clic: abrir opciones avanzadas. Clic derecho: activar o desactivar.",
            label_invertir: "Invertir",
            label_dividir: "Dividir",
            label_items_seleccionados: "Items seleccionados",
            label_cerrar: "Cerrar",
            label_continuar: "Continuar",
            label_volver: "Volver",
            label_copiar: "Copiar",
            label_sin_items_seleccionados: "No items seleccionados",
            label_unir_pedidos: "Unir pedidos",
            label_crear_tipo_usuario_movil: "Crear Tipo Usuario Movil",
            label_gestionar_rol_usuario_web: "Gestionar Rol Usuario Web",
            label_administra_la_lista_de_rol_usuario_web: "Administra la lista de rol usuario web",
            label_crear_rol_usuario_web: "Crear Rol Usuario Web",
            label_modificar_rol_usuario_web: "Modificar Rol Usuario Web",
            label_gestionar_usuario_movil: "Gestionar Usuario Movil",
            label_administra_la_lista_de_usuario_movil: "Administra la lista de usuario movil",
            label_crear_usuario_movil: "Crear Usuario Movil",
            label_modificar_usuario_movil: "Modificar Usuario Movil",
            label_tipo_usuario_movil: "Tipo Usuario Movil",
            label_password: "Contraseña",
            label_nombre_conductor: "Nombre Conductor",
            label_ocultar_sidebar: "Ocultar sidebar",
            label_configuracion: "Configuración",
            label_ruteo: "Ruteo",
            label_obtener_mejor_ruta: "Obtener mejor ruta",
            label_obtener_mejor_ruta_por_prioridad: "Obtener mejor ruta por prioridad",
            label_asignacion: "Asignación",
            label_administra_la_lista_de_asignacion: "Administra la lista de asignación",
            label_finalizar_proceso: "Finalizar proceso",
            label_gestionar_progress_bar: "Gestionar Progress Bar",
            label_administra_la_lista_de_progress_bar: "Administra la lista de progress bar",
            label_crear_progress_bar: "Crear Progress Bar",
            label_modificar_progress_bar: "Modificar Progress Bar",
            label_start: "Inicio",
            label_end: "Fin",
            label_guardar: "Guardar",
            label_actualizar: "Actualizar",
            label_ver_ruta: "Ver ruta",
            label_lista_seguimiento: "Lista de Seguimiento",
            label_administra_la_lista_de_seguimiento: "Administra la lista de seguimiento",
            label_productos: "Productos",
            label_todos: "Todos",
            label_camiones: "Camiones",
            label_sin_productos: "Sin productos",
            label_cantidad_programada: "Cantidad programada",
            label_cantidad_entregada: "Cantidad entregada",
            label_cambiar_placa: "Cambiar Vehículo",
            label_sin_datos: "No hay datos disponibles",
            label_resumen_recorrido: "Resumen del recorrido",
            label_ver_resumen_recorrido: "Ver resumen del recorrido",
            label_tiempo_total: "Tiempo total",
            label_distancia_total: "Distancia total",
            label_mover_a_otra_posicion: "Mover a otra posición",
            label_sin_workflow: "No hay workflow disponible",
            label_detalle_workflow: "Detalle de Workflow",
            label_workflow: "Workflow",
            label_historico: "Historico",
            label_velocidad: "Velocidad",
            label_tipo_evento: "Tipo de evento",
            label_sin_coordenadas_historico: "Sin coordenadas de inicio/fin para mostrar en el mapa.",
            label_fin: "Fin",
            label_hoja_de_ruta: "Hoja de Ruta",
            label_exportar_pdf: "Exportar PDF",
            label_exportar_csv: "Exportar CSV",
            label_imprimir: "Imprimir",
            label_hoja_de_ruta_y_carga: "Hoja de Ruta y Carga",
            label_control_despacho_y_transporte: "Control del despacho y transporte",
            label_agregar_grafico_seleccionado: "Agregar gráfico seleccionado",
            label_guardar_layout: "Guardar layout",
            label_quitar: "Eliminar",
            label_error_al_cargar_datos: "Error al cargar datos",
            label_piechartestados: "Estados",
            label_dashboard_vacio: "No hay datos disponibles",
            label_configuracion_guardada_servidor: "Configuración guardada en el servidor",
            label_configuracion_guardada_localmente: "Configuración guardada localmente",
            label_detalle_pagos: "Detalles de pagos",
            label_no_hay_informacion_disponible: "No hay información disponible",
            label_total: "Total",
            label_formulario_retorno: "Formulario de Retorno",
            label_pendiente: "Pendiente",
            label_iniciado: "Iniciado",
            label_copiar_hoja_de_ruta: "Copiar hoja de ruta",
            label_detalle_entrega: "Detalle Entrega",
            label_hoja_de_ruta_tiempos_entrega: "Hoja de Ruta Tiempos de Entrega",
            label_detalle_monto_que_debio_ser_pagado_a_conductor: "Detalle de monto que debio ser pagado a conductor",
            label_detalle_monto_pagado_a_conductor: "Detalle de monto pagado a conductor",
            label_pedir_detalles_productos: "Pedir detalle de productos",
            label_detalles_totales: "Detalle totales",
            label_entrada_salida_geocerca: "Entrada/Salida Geocerca",
            label_detalle_salida_entrada_geocerca: "Detalle de salida/entrada de geocerca",
            label_tabla: "Tabla",
            label_mapa_de_clientes: "Mapa de clientes",
            label_visualiza_el_mapa_de_clientes: "Visualiza el mapa de clientes",
            label_mostrar_etiquetas_clientes_mapa: "Mostrar nombres de clientes en el mapa",
            label_detalle_cliente_en_mapa: "Detalle del cliente",
            label_clientes_por_geocerca_mapa: "Clientes en geocerca",
            label_concepto_geocerca: "Concepto Geocerca",
            label_proximamente: "Próximamente",
            label_error_carga_mapa: "No se pudo cargar el mapa. Compruebe la conexión e intente de nuevo.",
            label_placa: "Placa",
            label_cargando_informacion: "Cargando información",
            label_grupo_geocerca_cliente: "Grupo Geocerca Cliente",
            label_grupo_geocerca_ciudades: "Grupo Geocerca Ciudades",
            label_ruta_planificada: "Ruta planificada",
            label_ruta_vehiculo: "Ruta vehiculo",
            label_lista_vehiculos: "Lista de vehiculos",
            label_reporte_estado_entregas: "Reporte de estado de entregas",
            label_genera_el_reporte_de_estado_de_entregas: "Genera el reporte de estado de entregas",
            label_fecha_programada: "Fecha programada",
            label_pedidos_programados: "Pedidos programados",
            label_pedidos_realizados: "Pedidos realizados",
            label_km_planificada: "Km planificada",
            label_km_recorrido: "Km recorrido",
            label_obligatorio: "Obligatorio",
            label_no_obligatorio: "No obligatorio",
            label_gestionar_estados_incidente: "Gestionar Estados Incidente",
            label_administra_la_lista_de_estados_incidente: "Administra la lista de estados incidente",
            label_crear_estado_incidente: "Crear Estado Incidente",
            label_modificar_estado_incidente: "Modificar Estado Incidente",
            label_gestionar_sub_estados_incidente: "Gestionar Sub Estados Incidente",
            label_administra_la_lista_de_sub_estados_incidente: "Administra la lista de sub estados incidente",
            label_crear_sub_estado_incidente: "Crear Sub Estado Incidente",
            label_modificar_sub_estado_incidente: "Modificar Sub Estado Incidente",
            label_gestionar_persona: "Gestionar Persona",
            label_administra_la_lista_de_personas: "Administra la lista de personas",
            label_crear_persona: "Crear Persona",
            label_modificar_persona: "Modificar Persona",
            label_notificar_a: "Notificar a",
            label_grupo_geocerca_georuta: "Grupo Geocerca Georuta",
            label_gestionar_incidentes: "Gestionar Incidentes",
            label_administra_la_lista_de_incidentes: "Administra la lista de incidentes",
            label_detalle_incidente: "Detalle Incidente",
            label_sin_detalle: "Sin detalle",
            label_ubicacion: "Ubicación",
            label_vista_previa: "Vista previa",
            label_copiado: "Copiado",
            label_abrir: "Abrir",
            label_asignar_por_peso: "Asignar por peso",
            label_usar_vehiculo_solo_una_vez: "Usar vehiculo solo una vez",
            label_si: "Si",
            label_no: "No",
            label_unidades_disponibles: "Unidades disponibles",
            label_usar_vehiculo_del_excel: "Usar vehiculo del excel",
            label_fecha_inicio: "Fecha inicio",
            label_fecha_fin: "Fecha fin",
            label_cliente: "Cliente",
            label_documento: "Nro Documento",
            label_finalizado: "Finalizado",
            label_pedidos: "Pedidos",
            label_estadopagos: "Estados de Pago",
            label_metodo: "Método",
            label_subtotal: "Subtotal",
            label_dividir_si_no_se_encuentra_vehiculo: "Dividir si no se encuentra vehiculo",
            label_reporte_resumen_entregas: "Resumen de entregas",
            label_genera_el_reporte_de_resumen_de_entregas: "Genera el reporte de resumen de entregas",
            label_registros: "Registros",
            label_exportar_excel: "Exportar Excel",
            label_sub_estado: "Sub Estado",
            label_estado_asignado: "Asignado",
            label_estado_en_proceso: "En Proceso",
            label_detalle_estado_pago: "Detalle estado pago",
            label_gestionar_viajes: "Gestionar Viajes",
            label_administra_la_lista_de_viajes: "Administra la lista de viajes",
            label_nuevo_viaje: "Nuevo viaje",
            label_notificar_inicio_viaje: "Notificar inicio de viaje",
            label_notificar_fin_viaje: "Notificar fin de viaje",
            label_grupo_geocerca_viaje: "Grupo Geocerca Viaje",
            label_geocerca_inicio: "Geocerca inicio",
            label_geocerca_fin: "Geocerca fin",
            label_fecha_hora_inicio: "Fecha/Hora Inicio",
            label_fecha_hora_fin: "Fecha/Hora Fin",
            label_minutos: "Minutos",
            label_now: "Ahora",
            label_modificar_viaje: "Modificar viaje",
            label_tranportadora_sindicato: "Transportadora/Sindicato",
            label_usuario_singular: "Usuario singular",
            label_grupo: "Grupo",
            label_sub_grupo: "Sub Grupo",
            label_vehiculos: "Vehiculos",
            label_grupo_geocerca_clientes: "Grupo Geocerca Clientes",
            label_georuta: "Georuta",
            label_cantidad_vehiculos_requeridos: "Vehiculos requeridos",
            label_notificar_alerta: "Notificar alerta",
            label_gestionar_estado_viajes: "Gestionar Estado Viajes",
            label_administra_la_lista_de_estado_viajes: "Administra la lista de estado viajes",
            label_nuevo_estado_viaje: "Nuevo estado viaje",
            label_modificar_estado_viaje: "Modificar estado viaje",
            label_visible_para_transportadora: "Visible para transportadora",
            label_estado_viaje: "Estado viaje",
            label_datos_generales: "Datos generales",
            label_geocercas: "Geocercas",
            label_notificaciones: "Notificaciones",
            label_este_usuario_puede_hacer_gestion_estrege_recogo_productos: "Este usuario puede hacer gestión estrega/recogo productos",
            label_visible_para_app: "Visible para app",
            label_crear_usuario_web: "Crear Usuario Web",
            label_rol_usuario_web: "Rol Usuario Web",
            label_nombre_usuario: "Nombre Usuario",
            label_confirmar_password: "Confirmar Contraseña",
            label_cambiar_fecha_entrega: "Cambiar Fecha Entrega",
            label_gestionar_permisos: "Gestionar Permisos",
            label_seleccionar_todo: "Seleccionar todo",
            label_funcionalidad: "Funcionalidad",
            label_gestionar_tipo_carguio: "Gestionar Tipo Carguio",
            label_administra_la_lista_de_tipo_carguio: "Administra la lista de tipo carguio",
            label_crear_tipo_carguio: "Crear Tipo Carguio",
            label_modificar_tipo_carguio: "Modificar Tipo Carguio",
            label_gestionar_registro_camiones: "Gestionar Registro Camiones",
            label_administra_la_lista_de_registro_camiones: "Administra la lista de registro camiones",
            label_crear_registro_camiones: "Crear Registro Camiones",
            label_modificar_registro_camiones: "Modificar Registro Camiones",
            label_gestionar_kanban: "Gestionar Kanban",
            label_administra_la_lista_de_kanban: "Administra la lista de kanban",
            label_crear_kanban: "Crear Kanban",
            label_modificar_kanban: "Modificar Kanban",
            label_gestionar_kanban_viaje: "Gestionar Kanban Viaje",
            label_administra_la_lista_de_kanban_viaje: "Administra la lista de kanban viaje",
            label_crear_kanban_viaje: "Crear Kanban Viaje",
            label_modificar_kanban_viaje: "Modificar Kanban Viaje",
            label_gestionar_kanban_producto: "Gestionar Kanban Producto",
            label_administra_la_lista_de_kanban_producto: "Administra la lista de kanban producto",
            label_crear_kanban_producto: "Crear Kanban Producto",
            label_modificar_kanban_producto: "Modificar Kanban Producto",
            label_agregar_columna: "Agregar columna",
            label_seleccionar_tipo_columna: "Tipo de columna",
            label_gestionar_estados_vehiculo: "Gestionar Estados Vehiculo",
            label_administra_la_lista_de_estados_vehiculo: "Administra la lista de estados vehiculo",
            label_crear_estado_vehiculo: "Crear Estado Vehiculo",
            label_modificar_estado_vehiculo: "Modificar Estado Vehiculo",
            label_gestionar_ejes_vehiculo: "Gestionar Ejes Vehiculo",
            label_administra_la_lista_de_ejes_vehiculo: "Gestionar la lista de ejes vehiculo",
            label_crear_ejes_vehiculo: "Crear Ejes Vehiculo",
            label_modificar_ejes_vehiculo: "Modificar Ejes Vehiculo",
            label_pedir_descripcion: "Pedir descripción",
            label_gestionar_usuario_web: "Gestionar Usuario Web",
            label_administra_la_lista_de_usuario_web: "Administra la lista de usuario web",
            label_modificar_usuario_web: "Modificar Usuario Web",
            label_gestionar_tipo_choferes: "Gestionar Tipo Chofer",
            label_administra_la_lista_de_tipo_choferes: "Administra la lista de tipo chofer",
            label_crear_tipo_chofer: "Crear Tipo Chofer",
            label_modificar_tipo_chofer: "Modificar Tipo Chofer",
            label_licencia: "Licencia",
            label_telefono: "Teléfono",
            label_tipo_chofer: "Tipo Chofer",
            label_ejes_vehiculo: "Ejes Vehiculo",
            label_gestionar_requerimiento_viajes: "Gestionar Requerimiento Viajes",
            label_administra_la_lista_de_requerimiento_viajes: "Administra la lista de requerimiento viajes",
            label_nuevo_requerimiento_viaje: "Nuevo requerimiento viaje",
            label_modificar_requerimiento_viaje: "Modificar requerimiento viaje",
            label_es_transportadora_o_sindicato: "Es transportadora o sindicato",
            label_gestionar_transportadoras_sindicato: "Gestionar Transportadoras/Sindicato",
            label_administra_la_lista_de_transportadoras_sindicato: "Administra la lista de transportadoras/sindicato",
            label_crear_transportadora_sindicato: "Crear Transportadora/Sindicato",
            label_modificar_transportadora_sindicato: "Modificar Transportadora/Sindicato",
            label_gestionar_formulario_viajes: "Gestionar Formulario Viajes",
            label_administra_la_lista_de_formulario_viajes: "Administra la lista de formulario viajes",
            label_nuevo_formulario_viaje: "Nuevo formulario viaje",
            label_modificar_formulario_viaje: "Modificar formulario viaje",
            label_seleccione_origen: "Seleccione origen",
            label_seleccione_chofer: "Seleccione chofer",
            label_gestionar_programacion_camiones: "Gestionar Programación Camiones",
            label_administra_la_lista_de_programacion_camiones: "Administra la lista de programación camiones",
            label_nuevo_programacion_camiones: "Nuevo programación camiones",
            label_modificar_programacion_camiones: "Modificar programación camiones",
            label_formulario_viaje: "Formulario de viaje",
            label_siguiente: "Siguiente",
            label_atras: "Atrás",
            label_es_chofer: "Es chofer",
            label_gestionar_respuesta_solicitud_programacion_camiones: "Gestionar Estado Solicitud Programacion Camiones",
            label_administra_la_lista_de_estado_solicitud_programacion_camiones: "Administra el estado de la solicitud de programacion de camiones",
            label_solicitud: "Solicitud",
            label_respuestas: "Respuestas",
            label_configurar_acciones_solicitud: "Configurar acciones de solicitud",
            label_configurar_acciones_solicitud_desc: "Configure el mensaje y los destinatarios opcionales para OK y X.",
            label_accion_aceptar_ok: "Aceptar (OK)",
            label_accion_aceptar_estado_viaje_ayuda: "Al hacer clic en OK, la solicitud se actualiza con este estado de viaje.",
            label_accion_rechazar_x: "Rechazar (X)",
            label_accion_rechazar_estado_viaje_ayuda: "Al hacer clic en X, la solicitud se actualiza con este estado de viaje.",
            label_mensaje_notificacion: "Mensaje de notificación",
            placeholder_mensaje_notificacion_rechazo: "Escriba el mensaje de notificación",
            alert_solicitud_aceptada: "Solicitud aceptada",
            alert_solicitud_rechazada: "Solicitud rechazada",
            alert_configure_acciones_solicitud: "Configure OK y X: seleccione un estado de viaje para cada acción primero.",
            label_fecha_inicio_viaje: "Fecha inicio viaje",
            label_fecha_fin_viaje: "Fecha fin viaje",
            label_hora_inicio_viaje: "Hora inicio viaje",
            label_hora_fin_viaje: "Hora fin viaje",
            label_seleccione_georuta: "Seleccione georuta",
            label_grupo_geocerca_depositos: "Grupo Geocerca Depósitos",
            label_orden: "Orden",
            label_gestionar_prioridad_entrega: "Gestionar Prioridad Entrega",
            label_administra_la_lista_de_prioridad_entrega: "Administra la lista de prioridad entrega",
            label_crear_prioridad_entrega: "Crear Prioridad Entrega",
            label_modificar_prioridad_entrega: "Modificar prioridad de entrega",
            label_gestionar_solicitud_producto: "Gestionar Solicitud Producto",
            label_administra_la_lista_de_solicitud_producto: "Administra la lista de solicitud producto",
            label_crear_solicitud_producto: "Crear Solicitud Producto",
            label_modificar_solicitud_producto: "Modificar solicitud producto",
            label_producto: "Producto",
            label_destino: "Destino",
            label_requerimiento: "Requerimiento",
            label_despachado: "Despachado",
            label_gestionar_programacion_solicitud_producto: "Gestionar Programacion Solicitud Producto",
            label_administra_la_lista_de_programacion_solicitud_producto: "Administrar Programacion Solicitud Producto",
            label_gestionar_programacion_camiones_kanban: "Gestionar Kanban Camiones",
            label_administra_la_lista_de_programacion_camiones_kanban: "Administra el tablero kanban de camiones",
            label_gestionar_programacion_productos_kanban: "Gestionar Kanban Productos",
            label_administra_la_lista_de_programacion_productos_kanban: "Administra el tablero kanban de productos",
            label_este_estado_inicia_viaje: "Este estado inicia viaje",
            label_acciones_kanban: "Acciones Kanban",
            label_acciones_kanban_viaje: "Acciones Kanban Viaje",
            label_acciones_kanban_producto: "Acciones Kanban Producto",
            label_crear_acciones_kanban: "Crear Acciones Kanban",
            label_crear_acciones_kanban_viaje: "Crear Acciones Kanban Viaje",
            label_crear_acciones_kanban_producto: "Crear Acciones Kanban Producto",
            label_configurar_acciones_programacion_kanban: "Configurar acciones del kanban",
            label_configurar_acciones_programacion_kanban_desc: "Para cada acción, elija la columna destino, el mensaje opcional y a quién notificar.",
            label_mover_a_kanban: "Mover a columna kanban",
            label_mover_a_kanban_ayuda: "Al hacer clic en esta acción, la tarjeta se mueve a la columna seleccionada.",
            placeholder_seleccione_kanban: "Seleccione columna kanban",
            alert_configure_acciones_programacion_kanban: "Configure esta acción primero: seleccione una columna kanban destino.",
            alert_card_movida_kanban: "Tarjeta movida a la columna kanban",
            label_datos_faltantes_iniciar_viaje: "Faltan datos para iniciar el viaje",
            label_faltan_datos_iniciar_viaje_desc: "Para mover esta tarjeta a la columna que inicia viajes, el formulario debe contener los siguientes campos:",
            label_detalle_respuestas: "Detalle de respuestas",
            label_sin_respuesta: "Sin respuesta",
            label_meta: "Datos adicionales",
            label_motivo: "Motivo",
            label_aprobar_solicitud: "Aprobar solicitud",
            label_rechazar_solicitud: "Rechazar solicitud",
            placeholder_ingrese_motivo: "Ingrese el motivo",
            alert_debe_ingresar_motivo: "Debe ingresar un motivo",
            alert_solicitud_aprobada: "Solicitud aprobada",
            label_iniciar_viaje: "Iniciar viaje",
            label_viajes: "viajes",
            label_mapa_viaje: "Mapa viaje",
            alert_no_hay_columna_inicia_viaje: "No hay ninguna columna kanban marcada como 'inicia viaje'. Configúrela desde la gestión de kanban.",
            label_mostrar_todos: "Mostrar todos",
            label_mostrar_seleccionados: "Solo seleccionados",
            label_seleccionar_todos: "Seleccionar todos",
            label_modificar_acciones_kanban: "Modificar Acciones Kanban",
            label_modificar_acciones_kanban_viaje: "Modificar Acciones Kanban Viaje",
            label_modificar_acciones_kanban_producto: "Modificar Acciones Kanban Producto",
            label_gestionar_formulario_programacion_camiones: "Gerenciar Formulario Programacion Camiones",
            label_administra_la_lista_de_formulario_programacion_camiones: "Administra la lista de Formulario Programacion Camiones",
            label_es_viaje_aprobado: "Es Viaje Aprobado",
            label_guardar_estado: "Guardar estado",
            label_fecha_programacion_salida: "Fecha Programacion Salida",
            label_fecha_carguio: "Fecha Carguio",
            label_distancia_alerta: "Distancia Alerta",
            label_geocerca_origen: "Geocerca Origen",
            label_geocerca_destino: "Geocerca Destino",
            label_es_cliente: "Es Cliente",
            label_agregar_producto: "Agregar Producto",
            label_fecha_programada_inicio: "Fecha Programada Inicio",
            label_fecha_programada_fin: "Fecha Programada Fin",
            label_kilo: "Kilo",
            label_tonelada: "Tonelada",
            label_libra: "Libra",
            label_litro: "Litro",
            label_m3: "M3",
            label_gallon: "Gallon",
            label_programacion_camiones: "Programacion Camiones",
            label_formulario_programacion_camiones: "Formulario Programacion Camiones",
            label_gestionar_estado_solicitudes: "Gestionar Estado Solicitudes",
            label_administra_la_lista_de_estado_solicitudes: "Administra la lista de estado solicitudes",
            label_nuevo_estado_solicitud: "Nuevo estado solicitud",
            label_modificar_estado_solicitud: "Modificar estado solicitud",
            label_estado_solicitud: "Estado Solicitud",
            label_administra_la_lista_de_estado_solicitud_producto: "Administra la lista de solicitud producto",
            label_aprobado: "Aprobado",
            label_rechazado: "Rechazado",
            label_filtro_fecha: "Filtro de fecha",
            label_filtro_todas: "Todas",
            label_filtro_hoy: "Hoy",
            label_filtro_ayer: "Ayer",
            label_filtro_rango: "Rango personalizado",
            label_seleccionar_personas_alerta: "Seleccionar personas a notificar",
            label_seleccionar_personas_alerta_desc: "Se enviarán las alertas a los correos y teléfonos de las personas seleccionadas.",
            label_notificar_sin_destinatario: "Notificar sin destinatario",
            label_confirmar: "Confirmar",
            label_formulario_solicitud_producto: "Formulario Solicitud Producto",

            alert_debe_seleccionar_producto: "Debe seleccionar un producto",
            alert_debe_ingresar_cantidad: "Debe ingresar una cantidad",
            alert_producto_ya_agregado: "Producto ya agregado",
            alert_usuario_o_contrasena_incorrecto: "Usuario o contrasena incorrecto",
            alert_procesando_solicitud: "Procesando solicitud...",
            alert_se_creo_correctamente: "Se creo correctamente",
            alert_se_actualizo_correctamente: "Se actualizo correctamente",
            alert_esta_de_deshabilitar_categoria: "¿Estás de deshabilitar Categoria?",
            alert_esta_de_habilitar_categoria: "¿Estás de habilitar Categoria?",
            alert_se_deshabilito_correctamente: "Deshabilitada correctamente",
            alert_se_habilito_correctamente: "Habilitada correctamente",
            alert_debe_ingresar_nombre: "Debe ingresar un nombre",
            alert_fecha_invalida: "Fecha inválida",
            alert_esta_de_deshabilitar_producto: "¿Estás de deshabilitar Producto?",
            alert_esta_de_habilitar_producto: "¿Estás de habilitar Producto?",
            alert_esta_de_deshabilitar_pais: "¿Estás de deshabilitar País?",
            alert_esta_de_habilitar_pais: "¿Estás de habilitar País?",
            alert_debe_ingresar_descripcion: "Debe ingresar una descripción",
            alert_esta_de_deshabilitar_ciudad: "¿Estás de deshabilitar Ciudad?",
            alert_esta_de_habilitar_ciudad: "¿Estás de habilitar Ciudad?",
            alert_esta_de_deshabilitar_vendedor: "¿Estás de deshabilitar Vendedor?",
            alert_esta_de_habilitar_vendedor: "¿Estás de habilitar Vendedor?",
            alert_esta_de_deshabilitar: "¿Estás de deshabilitar?",
            alert_esta_de_habilitar: "¿Estás de habilitar?",
            alert_formato_color_invalido: "Formato de color inválido. Use #RRGGBB o #RGB",
            alert_debe_ingresar_al_menos_un_campo_de_requerimiento: "Debe ingresar al menos un campo de requerimiento",
            alert_label_debe_tener_mas_de_2_caracteres: "La etiqueta debe tener más de 2 caracteres",
            alert_key_no_puede_estar_vacio: "La clave no puede estar vacía",
            alert_key_debe_ser_unico: "La clave debe ser única",
            alert_es_default: "Es default",
            alert_processed_successfully: "Procesado correctamente",
            alert_se_agrego_correctamente: "Se agrego correctamente",
            alert_debe_seleccionar_columnas: "Debe seleccionar columnas",
            alert_no_se_pudo_crear: "No se pudo crear",
            alert_no_se_pudo_modificar: "No se pudo modificar",
            alert_se_modifico_correctamente: "Se modifico correctamente",
            alert_archivo_invalido: "Archivo inválido",
            alert_archivo_vacio: "Archivo vacío",
            alert_maximo_500_elementos: "Máximo 500 elementos",
            alert_debe_seleccionar_vehiculo: "Debe seleccionar un vehículo",
            alert_debe_seleccionar_fecha: "Debe seleccionar una fecha",
            alert_debe_seleccionar_formulario: "Debe seleccionar un formulario",
            alert_no_se_pudo_leer_configuracion: "No se pudo leer la configuración",
            alert_debe_ingresar_prioridad: "Debe ingresar una prioridad",
            alert_debe_seleccionar_grupo_geocerca: "Debe seleccionar un grupo geocerca",
            alert_debe_seleccionar_al_menos_un_elemento: "Debe seleccionar al menos un elemento",
            alert_debe_seleccionar_vehiculo_fecha_formulario: "Debe seleccionar un vehículo, fecha y formulario",
            alert_se_dividio_correctamente: "Se dividio correctamente",
            alert_debe_ingresar_numero_documento: "Debe ingresar un número de documento",
            alert_copiado_al_portapapeles: "Copiado al portapapeles",
            alert_debe_seleccionar_mas_de_un_elemento: "Debe seleccionar más de un elemento",
            alert_se_unio_correctamente: "Se unio correctamente",
            alert_debe_seleccionar_unidad: "Debe seleccionar un vehículo",
            alert_debe_ingresar_nombre_conductor: "Debe ingresar un nombre conductor",
            alert_debe_ingresar_usuario: "Debe ingresar un usuario",
            alert_debe_ingresar_password: "Debe ingresar una contraseña",
            alert_debe_ingresar_peso: "Debe ingresar un peso",
            alert_debe_ingresar_volumen: "Debe ingresar un volumen",
            alert_debe_ingresar_inicio: "Debe ingresar un inicio",
            alert_debe_ingresar_fin: "Debe ingresar un fin",
            alert_debe_ingresar_color: "Debe ingresar un color",
            alert_punto_interes_no_valido: "El punto de interés no tiene una latitud y longitud válidas",
            alert_error_al_calcular_distancia: "Error al calcular la distancia del punto de interés",
            alert_vehiculo_no_seleccionado: "Vehículo no seleccionado",
            alert_no_hay_pedidos_para_ordenar: "No hay pedidos con origen/destino válidos",
            label_calcular_orden_recomendado: "Calcular orden recomendado",
            label_orden_recomendado: "Orden recomendado",
            label_sin_posicion_actual: "Sin posición actual, iniciando desde el primer origen",
            label_recoger: "Recoger",
            label_entregar: "Entregar",
            label_dibujar_ruta: "Dibujar ruta",
            label_ocultar_ruta: "Ocultar ruta",
            label_calculando_tiempos: "Calculando tiempos reales…",
            label_directions_fallback: "Distancias en línea recta",
            label_guardar_cambios: "Guardar cambios",
            alert_orden_creado: "Orden guardado",
            alert_orden_actualizado: "Orden actualizado",
            alert_secuencia_vacia: "Sin paradas para guardar",
            alert_sin_empresa: "No se pudo detectar la empresa (idEmpresa)",
            alert_confirmar_recalcular: "Ya calculaste un orden. ¿Recalcular y reemplazar la secuencia actual?",
            alert_confirmar_recalcular_guardado: "Ya hay un orden guardado para este vehículo. ¿Recalcular y reemplazar la secuencia? Los cambios no se guardarán hasta que hagas click en Guardar.",
            alert_orden_pickup_antes_destino: "No se puede entregar antes de recoger el mismo pedido",
            label_arrastrar_para_reordenar: "Arrastrar para reordenar",
            label_estado_borrador: "Borrador",
            label_estado_confirmado: "Confirmado",
            label_estado_en_curso: "En curso",
            label_estado_completado: "Completado",
            label_estado_cancelado: "Cancelado",
            label_confirmar_orden: "Confirmar",
            label_iniciar_viaje_orden: "Iniciar viaje",
            label_completar_orden: "Completar",
            label_cancelar_orden: "Cancelar",
            label_eliminar_orden: "Eliminar orden",
            alert_guardar_antes_cambiar_estado: "Guarda el orden antes de cambiar el estado",
            alert_guardar_cambios_pendientes: "Tienes cambios sin guardar. Guarda primero.",
            alert_estado_actualizado: "Estado actualizado",
            alert_orden_deshabilitado: "Orden eliminado",
            alert_no_se_pudo_deshabilitar: "No se pudo deshabilitar el orden",
            alert_confirmar_deshabilitar_orden: "¿Eliminar (deshabilitar) este orden? Podrás rehabilitarlo desde el historial.",
            label_sin_guardar: "sin guardar",
            alert_punto_vehiculo_no_valido: "Posición del vehículo no válida",
            alert_no_se_pudo_procesar: "No se pudo procesar",
            alert_orden_detalle_pedido_actualizada: "Orden de detalle pedido actualizada",
            alert_debe_seleccionar_solo_un_elemento: "Debe seleccionar solo un elemento",
            alert_se_cambio_placa_correctamente: "Se cambio vehiculo correctamente",
            alert_debe_seleccionar_grafico: "Debe seleccionar un gráfico",
            alert_debe_ingresar_al_menos_un_estado_de_pago: "Debe ingresar al menos un estado de pago",
            alert_label_no_puede_estar_vacio: "La etiqueta no puede estar vacía",
            alert_debe_seleccionar_concepto_geocerca: "Debe seleccionar un concepto geocerca",
            alert_esta_de_importar_clientes: "¿Estás seguro de importar clientes?",
            alert_se_importaron_correctamente: "Se importaron correctamente",
            alert_no_se_pudo_importar_clientes: "No se pudo importar clientes",
            alert_fecha_inicio_debe_ser_menor_a_fecha_fin: "La fecha de inicio debe ser menor a la fecha de fin",
            alert_maximo_31_dias_por_consulta: "Máximo 31 días por consulta",
            alert_procesando_solicitud_detalle_pedido: "Procesando solicitud para detalle de pedido",
            alert_fecha_inicio_no_valido: "Fecha Inicio No Valida",
            alert_fecha_fin_no_valido: "Fecha Fin No Valida",
            alert_hora_inicio_no_valido: "Hora inicio no válida (formato 24h HH:mm)",
            alert_hora_fin_no_valido: "Hora fin no válida (formato 24h HH:mm)",
            alert_debe_seleccionar_geocerca_inicio: "Debe seleccionar una geocerca inicio",
            alert_debe_seleccionar_geocerca_fin: "Debe seleccionar una geocerca fin",
            alert_debe_seleccionar_georuta: "Debe seleccionar una georuta",
            alert_debe_ingresar_cantidad_vehiculos_requeridos: "Debe ingresar una cantidad de vehiculos requeridos",
            alert_debe_seleccionar_estado_viaje: "Debe seleccionar un estado viaje",
            alert_debe_seleccionar_tipo_usuario_movil: "Debe seleccionar un tipo de usuario movil",
            alert_debe_ingresar_confirmar_password: "Debe ingresar una contraseña de confirmación",
            alert_debe_ingresar_nombre_usuario: "Debe ingresar un nombre de usuario",
            alert_la_contraseña_y_la_confirmación_de_la_contraseña_no_coinciden: "La contraseña y la confirmación de la contraseña no coinciden",
            alert_debe_seleccionar_rol_usuario_web: "Debe seleccionar un rol usuario web",
            alert_usuario_movil_ya_existe: "El usuario movil ya existe",
            alert_se_cambio_fecha_entrega_correctamente: "Se cambio fecha entrega correctamente",
            alert_debe_seleccionar_formulario_viaje: "Debe seleccionar un formulario de viaje",
            alert_no_se_pudo_obtener_campos_dinamicos: "No se pudieron obtener los campos dinámicos",
            alert_debe_ingresar_orden: "Debe ingresar una orden",
            alert_debe_ingresar_orden_numerico: "Debe ingresar una orden numérica",
            alert_debe_ingresar_peso_valido: "Debe ingresar un peso válido",
            alert_debe_ingresar_etiqueta: "Debe ingresar una etiqueta",
            alert_numero_invalido: "Número inválido",
            alert_debe_seleccionar_unidad_medida: "Debe seleccionar una unidad de medida",
            alert_debe_seleccionar_cliente: "Debe seleccionar un cliente",

            menu_dashboard: "Dashboard",
            menu_administracion: "Administración",
            menu_categorias: "Categorías",
            menu_salir: "Salir",
            menu_productos: "Productos",
            menu_pais: "Países",
            menu_ciudades: "Ciudades",
            menu_vendedores: "Vendedores",
            menu_estados: "Estados",
            menu_grupo_clientes: "Grupo Clientes",
            menu_clientes: "Clientes",
            menu_estado_pago: "Estado de Pago",
            menu_quien_recibe_entrega: "Quien Recibe Entrega",
            menu_formulario: "Formulario",
            menu_asignacion: "Asignación",
            menu_configuracion: "Configuración",
            menu_principal: "Principal",
            menu_almacen: "Almacén",
            menu_seguimiento: "Seguimiento",
            menu_mapa: "Mapa",
            menu_grilla: "Grilla",
            menu_tipo_cliente: "Tipo Cliente",
            menu_grupo_geocerca: "Grupo Geocerca",
            menu_usuarios: "Usuarios",
            menu_usuarios_web: "Usuarios Web",
            menu_usuarios_movil: "Usuarios Movil",
            menu_tipo_usuario_web: "Tipo Usuario Web",
            menu_tipo_usuario_movil: "Tipo Usuario Movil",
            menu_rol_usuario_web: "Rol Usuario Web",
            menu_progress_bar: "Progress Bar",
            menu_reportes: "Reportes",
            menu_reporte_estado_entregas: "Estado Entregas",
            menu_incidente: "Incidente",
            menu_estado_incidente: "Estado Incidente",
            menu_lista_incidentes: "Lista Incidentes",
            menu_persona: "Persona",
            menu_resumen_entregas: "Resumen Entregas",
            menu_viaje: "Viaje",
            menu_lista_viajes: "Lista Viajes",
            menu_estado_viajes: "Estado Viajes",
            menu_gestionar_clientes: "Gestionar Clientes",
            menu_mapa_clientes: "Mapa Clientes",
            menu_configuracion_clientes: "Configuración Clientes",
            menu_paises: "Países",
            menu_estado_de_pago: "Estado de Pago",
            menu_asignacion_principal: "Asignación Principal",
            menu_asignacion_configuracion: "Configuración Asignación",
            menu_seguimiento_mapa: "Mapa Seguimiento",
            menu_seguimiento_grilla: "Grilla Seguimiento",
            menu_reporte_resumen_entregas: "Reporte Resumen Entregas",
            menu_programacion_viajes: "Programación Viajes",
            menu_tipo_carguio: "Tipo Carguio",
            menu_registro_camiones: "Registro Camiones",
            menu_kanban: "Kanban",
            menu_kanban_viaje: "Kanban Viaje",
            menu_kanban_producto: "Kanban Producto",
            menu_estado_vehiculo: "Estado Vehiculo",
            menu_ejes_vehiculo: "Ejes Vehiculo",
            menu_tipo_chofer: "Tipo Chofer",
            menu_lista_estado_vehiculo: "Lista Estado Vehiculo",
            menu_lista_ejes_vehiculo: "Lista Ejes Vehiculo",
            menu_formulario_viaje: "Formulario Viaje",
            menu_gestionar_transportadora_sindicato: "Gestionar Transportadora/Sindicato",
            menu_formulario_programacion_camiones: "Formulario Programación Camiones",
            menu_estado_solicitud_programacion_camiones: "Estado Solicitud Programación Camiones",
            menu_solicitud_producto: "Solicitud Producto",
            menu_seguimiento_viaje: "Seguimiento viaje",
            menu_prioridad_entrega: "Prioridad Entrega",
            menu_programacion_solicitud_productos: "Programacion Solicitud Productos",
            menu_respuesta_solicitud_programacion_camiones: "Respuesta Solicitud Programación Camiones",
            menu_listar_solicitud_programacion_camiones: "Listar Solicitud Programación Camiones",
            menu_listar_solicitud_producto: "Listar Solicitud Producto",
            menu_programacion: "Programación",
            menu_programacion_camiones_kanban: "Kanban Camiones",
            menu_programacion_productos_kanban: "Kanban Productos",
            menu_estado_solicitud: "Estado Solicitud",

            grilla_placeholderbuscar: "Buscar",
            column_acciones: "Acciones",
            column_descripcion: "Descripción",
            column_nota: "Nota",
            column_fechaProceso: "Fecha Proceso",
            column_modificar: "Modificar",
            column_eliminar: "Eliminar",
            column_deshabilitar: "Deshabilitar",
            column_habilitar: "Habilitar",
            column_estado: "Estado",
            column_habilitado: "Habilitado",
            column_deshabilitado: "Deshabilitado",
            column_categoria: "Categoria",
            column_codigo: "Código",
            column_nombre: "Nombre",
            column_pais: "País",
            column_sub_status: "Sub Status",
            column_latitud: "Latitud",
            column_longitud: "Longitud",
            column_hacer_default: "Hacer Default",
            column_es_default: "Es Default",
            column_prioridad: "Prioridad",
            column_tipo_cliente: "Tipo Cliente",
            column_color: "Color",
            column_ciudad: "Ciudad",
            column_usuario: "Usuario",
            column_password: "Contraseña",
            column_tipo_usuario_movil: "Tipo Usuario Movil",
            column_vehiculo: "Vehiculo",
            column_formulario: "Formulario",
            column_detalles: "Detalles",
            column_placa: "Placa",
            column_si: "Si",
            column_no: "No",
            column_pedir_descripcion: "Pedir descripción",
            column_inicio: "Inicio",
            column_fin: "Fin",
            column_cliente: "Cliente",
            column_geocerca: "Geocerca",
            column_estado_pendiente: "Estado Pendiente",
            column_estado_iniciado: "Estado Iniciado",
            column_sub_estado: "Sub Estado",
            column_latitud_workflow: "Latitud Workflow",
            column_longitud_workflow: "Longitud Workflow",
            column_fecha_proceso: "Fecha Proceso",
            column_finalizado: "Finalizado",
            column_coordenadas_cliente: "Coordenadas Cliente",
            column_coordenadas_inicio_atencion: "Coordenadas Inicio Atención",
            column_coordenadas_fin_atencion: "Coordenadas Fin Atención",
            column_concepto_geocerca: "Concepto Geocerca",
            column_geocerca_inicio: "Geocerca Inicio",
            column_geocerca_fin: "Geocerca Fin",
            column_fecha_inicio: "Fecha Inicio",
            column_hora_inicio: "Hora Inicio",
            column_fecha_fin: "Fecha Fin",
            column_hora_fin: "Hora Fin",
            column_nombre_usuario: "Nombre Usuario",
            column_tipo_usuario_web: "Tipo Usuario Web",
            column_rol_usuario_web: "Rol Usuario Web",
            column_reset_password: "Reset Password",
            column_grupo: "Grupo",
            column_producto: "Producto",
            column_requerimiento: "Requerimiento",
            column_despachado: "Despachado",
            column_fecha_entrega_programada: "Fecha Entrega Programada",
            column_fecha_programacion_salida: "Fecha Programación Salida",
            column_fecha_carguio: "Fecha Carguio",
            column_fecha_entrega_excel: "Fecha Entrega Excel",
            column_fecha_hora_entrada_geocerca: "Fecha/hora ingreso",
            column_fecha_hora_salida_geocerca: "Fecha/hora salida",
            column_tiempo_estadia_geocerca: "Tiempo de estadía",
            column_nombre_cliente: "Nombre Cliente",
            column_numero_documento: "Número de Documento",
            column_nro: "Nro",
            column_weight: "Peso",
            column_sub_estados: "Sub Estados",
            column_telefonos: "Telefonos",
            column_correos: "Correos",
            column_estado_incidente: "Estado Incidente",
            column_sub_estado_incidente: "Sub Estado Incidente",
            column_nombre_chofer: "Nombre Chofer",
            column_fecha_hora_incidente: "Fecha/Hora Incidente",
            column_fecha_registro: "Fecha Registro",
            column_nombre_conductor: "Nombre Conductor",
            column_notificar_a: "Notificar a",
            column_codigo_producto: "Código producto",
            column_nombre_producto: "Nombre producto",
            column_unidad_medida: "Unidad medida",
            column_cantidad: "Cantidad",
            column_peso: "Peso",
            column_volumen: "Volumen",
            column_monto: "Monto",
            column_moneda: "Moneda",
            column_permisos: "Permisos",
            column_formulario_viaje: "Formulario Viaje",
            column_fecha_hora_inicio_atencion: "Fecha/Hora Inicio Atención",
            column_fecha_hora_fin_atencion: "Fecha/Hora Fin Atención",
            column_fecha_entrega_conductor: "Fecha Entrega Conductor",
            column_almacen: "Almacen",

            placeholder_seleccione_estado: "Seleccione Estado",
            placeholder_seleccione_categoria: "Seleccione Categoría",
            placeholder_ingresa_nombre: "Ingrese nombre",
            placeholder_ingresa_nota: "Ingrese nota",
            placeholder_ingresa_codigo: "Ingrese código",
            placeholder_ingresa_descripcion: "Ingrese descripción",
            placeholder_seleccione_pais: "Seleccione País",
            placeholder_seleccione_grupo_cliente: "Seleccione Grupo Cliente",
            placeholder_seleccione_ciudad: "Seleccione Ciudad",
            placeholder_ingresa_latitud: "Ingrese latitud",
            placeholder_ingresa_longitud: "Ingrese longitud",
            placeholder_seleccione_tipo: "Seleccione tipo",
            placeholder_ingresa_texto: "Ingrese texto",
            placeholder_ingresa_numero: "Ingrese número",
            placeholder_ingresa_etiqueta: "Ingrese etiqueta",
            placeholder_ingresa_key: "Ingrese key",
            placeholder_seleccione_estado_de_pago: "Seleccione estado de pago",
            placeholder_seleccione_quien_recibe_entrega: "Seleccione quién recibe/entrega",
            placeholder_seleccione_vehiculo: "Seleccione vehiculo",
            placeholder_seleccione_fecha: "Seleccione fecha YYYY-MM-DD",
            placeholder_seleccione_formulario: "Seleccione formulario",
            placeholder_ingresa_prioridad: "Ingrese prioridad",
            placeholder_seleccione_tipo_cliente: "Seleccione tipo cliente",
            placeholder_seleccione_grupo_geocerca: "Seleccione grupo geocerca",
            placeholder_seleccione_geocerca: "Seleccione geocerca",
            placeholder_seleccione_geocercas: "Seleccione geocercas",
            placeholder_seleccione_unidad: "Seleccione vehiculo",
            placeholder_seleccione_tipo_usuario_movil: "Seleccione tipo usuario movil",
            placeholder_ingresa_peso: "Ingrese peso",
            placeholder_ingresa_volumen: "Ingrese volumen",
            placeholder_ingresa_nombre_conductor: "Ingrese nombre conductor",
            placeholder_ingresa_usuario: "Ingrese usuario",
            placeholder_ingresa_password: "Ingrese contraseña",
            placeholder_ingresa_inicio: "Ingrese inicio",
            placeholder_ingresa_fin: "Ingrese fin",
            placeholder_seleccione_grafico: "Seleccione gráfico",
            placeholder_seleccione_concepto_geocerca: "Seleccione concepto geocerca",
            placeholder_ingrese_numero_documento: "Ingrese número de documento",
            placeholder_seleccione_persona: "Seleccione persona",
            placeholder_seleccione_fecha_hora: "Seleccione fecha/hora",
            placeholder_seleccione_grupo: "Seleccione grupo",
            placeholder_seleccione_sub_grupo: "Seleccione sub grupo",
            placeholder_seleccione_vehiculos: "Seleccione vehiculos",
            placeholder_seleccione_georuta: "Seleccione georuta",
            placeholder_ingresa_cantidad_vehiculos_requeridos: "Ingrese cantidad de vehiculos requeridos",
            placeholder_seleccione_estado_viaje: "Seleccione estado viaje",
            placeholder_seleccione_hora: "Seleccione hora",
            placeholder_ingresa_nombre_usuario: "Ingrese nombre de usuario",
            placeholder_seleccione_rol_usuario_web: "Seleccione rol usuario web",
            placeholder_ingresa_licencia: "Ingrese licencia",
            placeholder_ingresa_telefono: "Ingrese teléfono",
            placeholder_seleccione_tipo_chofer: "Seleccione tipo chofer",
            placeholder_seleccione_ejes_vehiculo: "Seleccione ejes vehiculo",
            placeholder_seleccione_formulario_viaje: "Seleccione formulario de viaje",
            placeholder_seleccionar_tipo_kanban: "Seleccione tipo kanban",
            placeholder_seleccione_transportadora: "Seleccione transportadora",
            placeholder_seleccione_geocerca_origen: "Seleccione Geocerca Origen",
            placeholder_seleccione_geocerca_destino: "Seleccione Geocerca Destino",
            placeholder_seleccione_producto: "Seleccione Producto",
            placeholder_seleccione_tipo_de_carga: "Seleccione tipo de carga",
            placeholder_seleccione_chofer: "Seleccione Chofer",
            placeholder_seleccione_estado_vehiculo: "Seleccione estado vehiculo",
            placeholder_seleccione_geocerca_georuta: "Seleccione Geocerca Georuta",
            placeholder_ingresa_orden: "Ingrese orden",
            placeholder_ingresa_grupo: "Ingrese grupo",
            placeholder_ingresa_requerimiento: "Ingrese requerimiento",
            placeholder_ingresa_despachado: "Ingrese despachado",
            placeholder_seleccione_prioridad: "Seleccione prioridad",
            placeholder_ingresa_distancia_alerta: "Ingrese distancia alerta",
            placeholder_ingresa_cantidad: "Ingrese cantidad",
            placeholder_seleccione_unidad_medida: "Seleccione unidad medida",
            placeholder_seleccione_cliente: "Seleccione cliente",
            placeholder_seleccione_estado_solicitud: "Seleccione estado solicitud",

            titulo_configuracion_asignacion: "Configuración de Asignación",
            titulo_crear_asignacion: "Crear Asignación",

            title_empresa: "EMPRESA",
            title_nombre_del_chofer: "NOMBRE DEL CHOFER",
            title_fecha: "FECHA",
            title_placa_del_camion: "PLACA DEL CAMION",
            title_n_documento: "N°DOCUMENTO",
            title_hora_de_salida: "HORA DE SALIDA",
            title_hora_de_retorno: "HORA DE RETORNO",
            title_fecha_emision: "FECHA DE EMISION",
            title_n_venta: "N°VENTA",
            title_n_factura: "N°FACTURA",
            title_cliente: "CLIENTE",
            title_verificado: "VERIFICADO",
            title_tiempo: "TIEMPO",

            chart_pie_chart_estados: "Estados",
            chart_estado_pagos: "Estado de Pagos",

            btn_productos: "Productos",
            btn_workflow: "Workflow",
            btn_ver: "Ver",
            btn_agregar: "Agregar",
            btn_guardar: "Guardar",
            btn_buscar: "Buscar",
            btn_eliminar: "Eliminar",
            btn_nuevo: "Nuevo",
            btn_modificar: "Modificar",
            btn_deshabilitar: "Deshabilitar",
            btn_habilitar: "Habilitar",
            btn_permisos: "Permisos",
            btn_importar: "Importar",
            btn_exportar: "Exportar",
            btn_aceptar: "Aceptar",
            btn_cancelar: "Cancelar",
            btn_sub_estados: "Sub Estados",
            btn_default: "Default",
            btn_configuracion: "Configuración",
            btn_limpiar: "Limpiar",
            btn_eliminar_pedido: "Eliminar Pedido",
            btn_detalles_pedido: "Detalles Pedido",
            btn_eliminar_detalle_pedido: "Eliminar Detalle Pedido",
            btn_configuracion_placa: "Configuración Placa",
            btn_filtros: "Filtros",
            btn_configuracion_pedido: "Configuración Pedido",
            btn_acciones: "Acciones",
            label_aplicar_template: "Aplicar template",
            label_guardar_como_template: "Guardar como template",
            label_gestionar_templates: "Gestionar templates",
            label_template_global: "Disponible para todos los usuarios (global)",
            label_global: "Global",
            label_campos: "campos",
            label_aplicar: "Aplicar",
            label_deshabilitar: "Deshabilitar",
            placeholder_seleccione_template: "Seleccione un template",
            alert_debe_seleccionar_template: "Seleccione un template",
            alert_no_hay_campos_para_guardar: "No hay campos para guardar",
            alert_debe_ingresar_nombre: "Debe ingresar un nombre",
            alert_se_deshabilito_correctamente: "Se deshabilitó correctamente",
            alert_campos_template_omitidos_duplicados: "Algunos campos del template fueron omitidos porque su flag semántico ya estaba presente",
            label_vehiculo_viaje: "Vehículo del viaje",
        }
    },
    pt: {
        translation: {
            label_seguimiento_en_tiempo_real: "Seguimento em Tempo Real",
            label_gestion_de_entregas: "Gestão de Entregas",
            label_optimizacion_de_rutas: "Otimização de Rotas",
            label_notificaciones_automaticas: "Notificações Automáticas",
            label_reportes_detallados: "Relatórios Detalhados",
            label_etas_precisos: "ETAs Precisos",
            label_mayor_satisfaccion_del_cliente: "Maior Satisfação do Cliente",
            label_reduccion_de_costos: "Redução de Custos",
            label_escalabilidad: "Escalabilidade",
            label_entregas_puntuales: "Entregas Pontuais",
            label_tus_clientes_pueden_ver_exactamente_donde_esta_su_pedido_en_todo_momento: "Seus clientes podem ver exatamente onde está seu pedido em qualquer momento",
            label_carga_y_administra_todas_tus_entregas_desde_una_unica_plataforma: "Carrega e administra todas as suas entregas desde uma única plataforma",
            label_algoritmos_inteligentes_para_las_rutas_mas_eficientes: "Algoritmos inteligentes para as rotas mais eficientes",
            label_alertas_instantaneas_para_clientes_y_gestores_de_flota: "Alertas instantâneas para clientes e gestores de frota",
            label_analitica_completa_de_tiempos_eficiencia_y_satisfaccion: "Análise completa de tempo, eficiência e satisfação",
            label_tiempos_estimados_de_llegada_actualizados_en_tiempo_real: "Tempos estimados de chegada atualizados em tempo real",
            label_transparencia_total_en_cada_entrega_genera_confianza_y_lealtad: "Transparência total em cada entrega gera confiança e lealdade",
            label_optimiza_rutas_y_reduce_llamadas_de_dnde_esta_mi_pedido: "Otimiza rotas e reduz chamadas de \"Onde está meu pedido?\"",
            label_crece_sin_limites_desde_1_hasta_10000_entregas_diarias: "Cresça sem limites, desde 1 até 10,000 entregas diárias",
            label_mejora_tus_tiempos_de_entrega_hasta_un_40: "Melhore seus tempos de entrega até 40%",
            label_ultima_milla: "Ultima Milla",
            label_ultima_milla_corto: "UM",
            label_tms: "TMS",
            label_caracteristicas: "Características",
            label_beneficios: "Beneficios",
            label_contacto: "Contato",
            label_iniciar_sesion: "Iniciar Sesión",
            label_comenzar_ahora: "Comenzar Agora",
            label_ultima_milla_inteligente: "Ultima Milla Inteligente",
            label_transforma_tus_entregas_en: "Transforma tus entregas em",
            label_experiencias_inolvidables: "Experiências inesquecíveis",
            label_la_plataforma_de_seguimiento_en_tiempo_real_que_conecta_tu_empresa_con_tus_clientes: "A plataforma de rastreamento em tempo real que conecta sua empresa com seus clientes.",
            label_ellos_ven_exactamente_donde_esta_su_pedido_tu_optimizas_cada_entrega: "Eles veem exatamente onde está seu pedido, você otimiza cada entrega.",
            label_ver_demo: "Ver Demo",
            label_mejora_en_tiempos_de_entrega: "Melhora em tempos de entrega",
            label_satisfaccion_del_cliente: "Satisfação do Cliente",
            label_reduccion_de_llamadas: "Redução de Chamadas",
            label_todo_lo_que_necesitas_para_tms: "Tudo o que você precisa para a TMS",
            label_una_plataforma_completa_diseñada_para_empresas_que_entregan_productos_personalizados: "Uma plataforma completa projetada para empresas que entregam produtos personalizados",
            label_como_funciona: "Como funciona",
            label_tan_simple_que_empezaras_en_minutos: "Tão simples que você começará em minutos",
            label_carga_tus_entregas: "Carrega tus entregas",
            label_sube_tu_lista_de_pedidos_con_direcciones_de_clientes_puedes_hacerlo_manualmente_o_mediante_excel_api: "Carrega sua lista de pedidos com endereços de clientes. Você pode fazer isso manualmente ou através de Excel/API.",
            label_asigna_vehiculos: "Asigna vehículos",
            label_el_sistema_optimiza_rutas_automaticamente_tus_conductores_reciben_las_entregas_en_su_app_movil: "O sistema otimiza rotas automaticamente. Seus motoristas recebem as entregas em sua app móvel.",
            label_clientes_rastrean: "Clientes rastrean",
            label_tus_clientes_reciben_un_link_unico_para_ver_en_tiempo_real_donde_esta_su_pedido_sin_llamadas_ni_dudas: "Seus clientes recebem um link único para ver em tempo real onde está seu pedido. Sem chamadas ou dúvidas!",
            label_por_que_elegirnos: "¿Por que escolher-nos?",
            label_ventajas_que_transformaran_tu_operacion: "Vantagens que transformarão sua operação",
            label_listo_para_revolucionar_tus_entregas: "¿Listo para revolucionar tus entregas?",
            label_unete_a_las_empresas_que_ya_estan_ofreciendo_la_mejor_experiencia_de_entrega: "Únete a las empresas que ya están ofreciendo la mejor experiencia de entrega",
            label_hablar_con_ventas: "Hablar con ventas",
            label_politica_de_privacidad: "Política de Privacidade e Termos de Uso",
            label_ultima_actualizacion: "Última atualização",
            label_politica_intro: "Este documento descreve os termos de uso e as práticas de privacidade aplicáveis à plataforma DataTerra TMS (Sistema de Gestão de Transporte) e aos produtos relacionados oferecidos por nossa empresa.",
            label_politica_seccion_servicio_titulo: "1. Sobre o serviço",
            label_politica_seccion_servicio_texto: "O DataTerra TMS é uma plataforma de software que permite que empresas e usuários se registrem e utilizem ferramentas para gestão de entregas, otimização de rotas, rastreamento em tempo real e operações logísticas relacionadas. O acesso à plataforma pode exigir registro e a aceitação destes termos.",
            label_politica_seccion_proveedor_titulo: "2. Papel do provedor",
            label_politica_seccion_proveedor_texto: "Atuamos exclusivamente como provedor de tecnologia do software TMS, dos aplicativos móveis e de qualquer outro produto digital disponibilizado sob a marca DataTerra. Não operamos o seu negócio logístico, não controlamos suas entregas e não somos parte das relações entre você e seus clientes, motoristas ou terceiros.",
            label_politica_seccion_responsabilidad_titulo: "3. Limitação de responsabilidade",
            label_politica_seccion_responsabilidad_texto: "Na máxima extensão permitida pela lei aplicável, a DataTerra e suas afiliadas não serão responsáveis por danos diretos, indiretos, incidentais, especiais ou consequenciais decorrentes do uso ou da impossibilidade de uso do software, do aplicativo móvel, das APIs ou de qualquer outro produto ou serviço que fornecemos. Não somos responsáveis de forma alguma pelo uso que você, sua organização, seus funcionários, contratados ou usuários finais façam da plataforma, incluindo, entre outros, dados inseridos, rotas planejadas, comunicações enviadas ou decisões comerciais tomadas com nossas ferramentas.",
            label_politica_seccion_uso_usuario_titulo: "4. Responsabilidade do usuário e do cliente",
            label_politica_seccion_uso_usuario_texto: "Você é o único responsável pelas credenciais da sua conta, pela exatidão das informações que carregar, pelo cumprimento das leis e regulamentos locais e pelo uso adequado do software em suas operações. Você concorda em utilizar o TMS e os produtos relacionados apenas para fins lícitos e por sua conta e risco.",
            label_politica_seccion_cambios_titulo: "5. Alterações nos termos e condições",
            label_politica_seccion_cambios_texto: "Podemos modificar estes termos, esta política de privacidade, preços, funcionalidades ou qualquer outra condição de uso a qualquer momento e a nosso exclusivo critério. As alterações podem entrar em vigor imediatamente após a publicação nesta página ou dentro do aplicativo. Não somos obrigados a notificar previamente usuários ou clientes. O uso continuado do software após as alterações constitui sua aceitação dos termos atualizados.",
            label_politica_seccion_privacidad_titulo: "6. Privacidade e dados",
            label_politica_seccion_privacidad_texto: "As informações processadas pela plataforma são usadas para fornecer e melhorar o serviço. Você permanece como titular dos seus dados operacionais. Implementamos medidas de segurança razoáveis; no entanto, nenhum sistema é totalmente seguro. Para dúvidas sobre o tratamento de dados, entre em contato conosco pelas informações abaixo.",
            label_politica_seccion_aceptacion_titulo: "7. Aceitação",
            label_politica_seccion_aceptacion_texto: "Ao criar uma conta, fazer login ou utilizar qualquer produto DataTerra, você reconhece que leu, compreendeu e concorda com esta Política de Privacidade e Termos de Uso.",
            label_politica_volver_landing: "Voltar ao início",
            label_plataforma_de_ultima_milla: "Plataforma de Ultima Milla",
            label_usuario: "Usuario",
            label_contrasena: "Senha",
            label_mostrar_contrasena: "Mostrar senha",
            label_ocultar_contrasena: "Ocultar senha",
            label_ingresar: "Entrar",
            label_volver_al_inicio: "Voltar para a Home",
            label_ingresa_tus_credenciales_para_continuar: "Digite suas credenciais para continuar",
            label_cargando: "Carregando...",
            label_ingresa_tu_usuario: "Digite seu usuário",
            label_ingresa_tu_contrasena: "Digite sua senha",
            label_gestionar_categoria: "Gerenciar Categoria",
            label_administra_la_lista_de_categorias: "Gerencia a lista de categorias",
            label_estado: "Estado",
            label_buscar: "Buscar",
            label_nuevo: "Novo",
            label_compartir: "Compartilhar",
            alert_enlace_copiado: "Link copiado",
            alert_no_se_pudo_compartir: "Não foi possível compartilhar",
            label_peticion_enviada_titulo: "Solicitação enviada com sucesso",
            label_peticion_enviada_mensaje: "Sua solicitação foi enviada ao servidor corretamente.",
            label_puede_cerrar_pestana: "Você já pode fechar esta aba.",
            label_cerrar_pestana: "Fechar aba",
            label_gestionar_producto: "Gerenciar Produto",
            label_administra_la_lista_de_productos: "Gerencia a lista de produtos",
            label_crear_producto: "Criar Produto",
            label_categoria: "Categoria",
            label_codigo: "Código",
            label_nombre: "Nome",
            label_nota: "Nota",
            label_modificar_producto: "Modificar Produto",
            label_modificar_pais: "Modificar País",
            label_crear_pais: "Criar País",
            label_descripcion: "Descrição",
            label_gestionar_paises: "Gerenciar Países",
            label_administra_la_lista_de_paises: "Gerencia a lista de países",
            label_gestionar_ciudades: "Gerenciar Cidades",
            label_administra_la_lista_de_ciudades: "Gerencia a lista de cidades",
            label_modificar_ciudad: "Modificar Cidade",
            label_crear_ciudad: "Criar Cidade",
            label_pais: "País",
            label_modificar_vendedor: "Modificar Vendedor",
            label_crear_vendedor: "Criar Vendedor",
            label_gestionar_vendedores: "Gerenciar Vendedores",
            label_administra_la_lista_de_vendedores: "Gerencia a lista de vendedores",
            label_modificar_estado: "Modificar Estado",
            label_crear_estado: "Criar Estado",
            label_gestionar_estados: "Gerenciar Estados",
            label_administra_la_lista_de_estados: "Gerencia a lista de estados",
            label_modificar_sub_estado: "Modificar Sub Estado",
            label_crear_sub_estado: "Criar Sub Estado",
            label_gestionar_sub_estados: "Gerenciar Sub Estados",
            label_administra_la_lista_de_sub_estados: "Gerencia a lista de sub estados",
            label_modificar_grupo_cliente: "Modificar Grupo Cliente",
            label_crear_grupo_cliente: "Criar Grupo Cliente",
            label_gestionar_grupo_clientes: "Gerenciar Grupo Clientes",
            label_administra_la_lista_de_grupo_clientes: "Gerencia a lista de grupo clientes",
            label_modificar_cliente: "Modificar Cliente",
            label_crear_cliente: "Criar Cliente",
            label_gestionar_clientes: "Gerenciar Clientes",
            label_administra_la_lista_de_clientes: "Gerencia a lista de clientes",
            label_grupo_cliente: "Grupo Cliente",
            label_ciudad: "Cidade",
            label_latitud: "Latitude",
            label_longitud: "Longitude",
            label_mapa: "Mapa",
            label_telefonos: "Telefonos",
            label_email: "Email",
            label_color: "Cor",
            label_seleccionar_color: "Selecionar cor",
            label_usuarios_permitidos: "Usuários permitidos",
            placeholder_seleccione_usuarios: "Selecione usuários",
            alert_accion_creada_usuarios_error: "A ação foi criada, mas alguns permissões de usuário não puderam ser salvas",
            alert_accion_modificada_usuarios_error: "A ação foi atualizada, mas alguns permissões de usuário não puderam ser sincronizadas",
            label_gestionar_telefono: "Gerenciar Teléfono",
            label_aceptar: "Aceptar",
            label_cancelar: "Cancelar",
            label_gestionar_email: "Gerenciar Email",
            label_modificar_estado_pago: "Modificar Estado de Pago",
            label_modificar_estado_pedido: "Modificar estado do pedido",
            label_crear_estado_pago: "Criar Estado de Pago",
            label_gestionar_estado_pago: "Gerenciar Estados de Pago",
            label_administra_la_lista_de_estado_pago: "Gerencia a lista de estados de pago",
            label_agregar_campo: "Agregar Campo",
            label_agregar: "Agregar",
            label_no_hay_campos: "No hay campos agregados",
            label_etiqueta: "Etiqueta",
            label_tipo: "Tipo",
            label_texto: "Texto",
            label_numero: "Número",
            label_fecha: "Fecha",
            label_valor: "Valor",
            label_habilitado: "Habilitado",
            label_deshabilitado: "Deshabilitado",
            label_eliminar: "Eliminar",
            label_placeholder: "Placeholder",
            label_hora: "Hora",
            label_hora_salida: "Hora salida",
            label_hora_llegada: "Hora llegada",
            label_fecha_salida: "Fecha salida",
            label_fecha_llegada: "Fecha llegada",
            label_seleccione_transportadora: "Seleccione Transportadora",
            label_estado_vehiculo: "Estado do veículo",
            label_seleccione_vehiculo: "Selecione veículo",
            label_seleccione_destino: "Selecione destino",
            label_seleccione_producto: "Selecione produto",
            label_seleccione_tipo_de_carga: "Selecione tipo de carga",
            label_input_cantidad: "Quantidade",
            label_date_time: "Fecha y Hora",
            label_only_letters_and_underscore_allowed: "Solo letras y guiones bajos permitidos",
            label_gestionar_quien_recibe_entrega: "Gestionar Quién Recibe Entrega",
            label_administra_la_lista_de_quien_recibe_entrega: "Administra la lista de quién recibe entrega",
            label_crear_quien_recibe_entrega: "Crear Quién Recibe Entrega",
            label_modificar_quien_recibe_entrega: "Modificar Quién Recibe Entrega",
            label_gestionar_formulario: "Gestionar Formulario",
            label_administra_la_lista_de_formulario: "Administra la lista de formulario",
            label_crear_formulario: "Criar Formulario",
            label_modificar_formulario: "Modificar Formulario",
            label_firma: "Firma",
            label_fotografia: "Fotografia",
            label_estado_de_pago: "Estado de Pago",
            label_quien_recibe_entrega: "Persona Entregando / Persona Recibiendo",
            label_key: "key",
            label_campo: "Campo",
            label_tms_inteligente: "TMS Inteligente",
            label_numero_documento: "Número de Documento",
            label_codigo_cliente: "Código de Cliente",
            label_nombre_cliente: "Nombre de Cliente",
            label_latitud_cliente: "Latitud Cliente",
            label_longitud_cliente: "Longitud Cliente",
            label_direccion_cliente: "Dirección Cliente",
            label_telefono_cliente: "Teléfono Cliente",
            label_fecha_factura: "Fecha de Factura",
            label_numero_factura: "Número de Factura",
            label_valor_factura: "Valor de Factura",
            label_codigo_almacen: "Código de Almacén",
            label_nombre_almacen: "Nombre de Almacén",
            label_latitud_almacen: "Latitud Almacén",
            label_longitud_almacen: "Longitud Almacén",
            label_codigo_producto: "Código de Producto",
            label_nombre_producto: "Nombre de Producto",
            label_unidad_medida: "Unidad de Medida",
            label_cantidad: "Cantidad",
            label_peso: "Peso",
            label_capacidad_carga: "Capacidad de carga",
            label_peso_esta_solicitud: "Peso de esta solicitud",
            label_peso_otras_solicitudes: "Peso de otras solicitudes",
            label_peso_total: "Peso total",
            label_exceso: "Exceso",
            label_solicitudes_en_conflicto: "Solicitudes en conflicto",
            alert_capacidad_carga_excedida: "Capacidad de carga del vehículo excedida",
            label_carga_asignada_vehiculo: "Carga asignada al vehículo",
            label_desglose_por_unidad: "Desglose por unidad",
            label_disponible: "Disponible",
            label_ver_carga_asignada: "Ver carga asignada",
            label_sin_periodo_definido: "Sin período definido (mostrando solo esta solicitud)",
            alert_no_se_pudo_obtener_info_vehiculo: "No se pudo obtener información del vehículo",
            label_volumen: "Volumen",
            label_monto: "Monto",
            label_moneda: "Moneda",
            label_codigo_vendedor: "Código de Vendedor",
            label_nombre_vendedor: "Nombre de Vendedor",
            label_region: "Región",
            label_fecha_entrega: "Fecha de Entrega",
            label_numero_embarque: "Número de Embarque",
            label_tipo_servicio: "Tipo de Servicio",
            label_estado_pago: "Estado de Pago",
            label_telefonos_notificacion: "Teléfonos de Notificación",
            label_correos_notificacion: "Correos de Notificación",
            label_prefijo: "Prefijo",
            label_observaciones: "Observaciones",
            label_importar: "Importar",
            label_exportar: "Exportar",
            label_importar_general: "Importar General",
            label_importar_personalizado: "Importar Personalizado",
            label_vehiculo: "Vehiculo",
            label_formulario: "Formulario",
            label_limpiar: "Limpiar",
            label_gestionar_almacen: "Gestionar Almacén",
            label_administra_la_lista_de_almacen: "Administra la lista de almacén",
            label_crear_almacen: "Crear Almacén",
            label_modificar_almacen: "Modificar Almacén",
            label_gestionar_tipo_cliente: "Gestionar Tipo Cliente",
            label_administra_la_lista_de_tipo_cliente: "Administra la lista de tipo cliente",
            label_crear_tipo_cliente: "Crear Tipo Cliente",
            label_modificar_tipo_cliente: "Modificar Tipo Cliente",
            label_prioridad: "Prioridad",
            label_tipo_cliente: "Tipo Cliente",
            label_detalle: "Detalle",
            label_seleccionar_fecha: "Seleccionar fecha",
            label_ver_detalle: "Ver detalle",
            label_gestionar_grupo_geocerca: "Gestionar Grupo Geocerca",
            label_administra_la_lista_de_grupo_geocerca: "Administra la lista de grupo geocerca",
            label_crear_grupo_geocerca: "Crear Grupo Geocerca",
            label_modificar_grupo_geocerca: "Modificar Grupo Geocerca",
            label_grupo_geocerca: "Grupo Geocerca",
            label_geocerca: "Geocerca",
            label_opciones_avanzadas: "Opciones Avanzadas",
            tooltip_opciones_avanzadas_vehiculo: "Clique para abrir opções avançadas. Clique com o botão direito para ativar ou desativar.",
            label_invertir: "Invertir",
            label_dividir: "Dividir",
            label_items_seleccionados: "Items seleccionados",
            label_cerrar: "Cerrar",
            label_continuar: "Continuar",
            label_volver: "Voltar",
            label_copiar: "Copiar",
            label_sin_items_seleccionados: "Ningún item seleccionado",
            label_unir_pedidos: "Unir pedidos",
            label_crear_tipo_usuario_movil: "Criar Tipo Usuario Movil",
            label_gestionar_rol_usuario_web: "Gerenciar Rol Usuario Web",
            label_administra_la_lista_de_rol_usuario_web: "Gerencia a lista de rol usuario web",
            label_crear_rol_usuario_web: "Criar Rol Usuario Web",
            label_modificar_rol_usuario_web: "Modificar Rol de Usuário Web",
            label_gestionar_usuario_movil: "Gerenciar Usuario Móvil",
            label_administra_la_lista_de_usuario_movil: "Gerencia a lista de usuario móvil",
            label_crear_usuario_movil: "Criar Usuario Móvil",
            label_modificar_usuario_movil: "Modificar Usuario Móvil",
            label_tipo_usuario_movil: "Tipo Usuario Móvil",
            label_password: "Senha",
            label_nombre_conductor: "Nome do Conductor",
            label_ocultar_sidebar: "Ocultar sidebar",
            label_configuracion: "Configuración",
            label_ruteo: "Ruteo",
            label_obtener_mejor_ruta: "Obtener mejor ruta",
            label_obtener_mejor_ruta_por_prioridad: "Obtener mejor ruta por prioridad",
            label_asignacion: "Asignación",
            label_administra_la_lista_de_asignacion: "Administra la lista de asignación",
            label_finalizar_proceso: "Finalizar proceso",
            label_gestionar_progress_bar: "Gestionar Progress Bar",
            label_administra_la_lista_de_progress_bar: "Administra la lista de progress bar",
            label_crear_progress_bar: "Crear Progress Bar",
            label_modificar_progress_bar: "Modificar Progress Bar",
            label_start: "Inicio",
            label_end: "Fin",
            label_guardar: "Guardar",
            label_actualizar: "Actualizar",
            label_ver_ruta: "Ver ruta",
            label_lista_seguimiento: "Lista de Seguimiento",
            label_administra_la_lista_de_seguimiento: "Administra la lista de seguimiento",
            label_productos: "Productos",
            label_todos: "Todos",
            label_camiones: "Caminhões",
            label_sin_productos: "Sem produtos",
            label_cantidad_programada: "Quantidade programada",
            label_cantidad_entregada: "Quantidade entregada",
            label_cambiar_placa: "Cambiar Vehículo",
            label_sin_datos: "No hay datos disponibles",
            label_resumen_recorrido: "Resumen del recorrido",
            label_ver_resumen_recorrido: "Ver resumen del recorrido",
            label_tiempo_total: "Tiempo total",
            label_distancia_total: "Distancia total",
            label_mover_a_otra_posicion: "Mover a otra posición",
            label_sin_workflow: "No hay workflow disponible",
            label_detalle_workflow: "Detalle de Workflow",
            label_workflow: "Workflow",
            label_historico: "Historico",
            label_velocidad: "Velocidade",
            label_tipo_evento: "Tipo de evento",
            label_sin_coordenadas_historico: "Sin coordenadas de inicio/fin para mostrar en el mapa.",
            label_inicio: "Inicio",
            label_fin: "Fin",
            label_hoja_de_ruta: "Hoja de Ruta",
            label_exportar_pdf: "Exportar PDF",
            label_exportar_csv: "Exportar CSV",
            label_imprimir: "Imprimir",
            label_hoja_de_ruta_y_carga: "Hoja de Ruta y Carga",
            label_control_despacho_y_transporte: "Control del despacho y transporte",
            label_agregar_grafico_seleccionado: "Agregar gráfico seleccionado",
            label_guardar_layout: "Guardar layout",
            label_quitar: "Eliminar",
            label_error_al_cargar_datos: "Error al cargar datos",
            label_piechartestados: "Estados",
            label_dashboard_vacio: "No hay datos disponibles",
            label_configuracion_guardada_servidor: "Configuración guardada en el servidor",
            label_configuracion_guardada_localmente: "Configuración guardada localmente",
            label_detalle_pagos: "Detalles de pagos",
            label_no_hay_informacion_disponible: "No hay información disponible",
            label_total: "Total",
            label_formulario_retorno: "Formulario de Retorno",
            label_pendiente: "Pendiente",
            label_iniciado: "Iniciado",
            label_copiar_hoja_de_ruta: "Copiar hoja de ruta",
            label_detalle_entrega: "Detalle Entrega",
            label_hoja_de_ruta_tiempos_entrega: "Hoja de Ruta Tiempos de Entrega",
            label_detalle_monto_que_debio_ser_pagado_a_conductor: "Detalle de monto que debio ser pagado a conductor",
            label_detalle_monto_pagado_a_conductor: "Detalle de monto pagado a conductor",
            label_pedir_detalles_productos: "Pedir detalle de productos",
            label_detalles_totales: "Detalle totales",
            label_entrada_salida_geocerca: "Entrada/Salida Geocerca",
            label_detalle_salida_entrada_geocerca: "Detalle de salida/entrada de geocerca",
            label_tabla: "Tabela",
            label_mapa_de_clientes: "Mapa de clientes",
            label_visualiza_el_mapa_de_clientes: "Visualiza el mapa de clientes",
            label_mostrar_etiquetas_clientes_mapa: "Mostrar nomes dos clientes no mapa",
            label_detalle_cliente_en_mapa: "Detalhes do cliente",
            label_clientes_por_geocerca_mapa: "Clientes na geocerca",
            label_concepto_geocerca: "Concepto Geocerca",
            label_proximamente: "Em breve",
            label_error_carga_mapa: "Não foi possível carregar o mapa. Verifique a conexão e tente novamente.",
            label_placa: "Placa",
            label_cargando_informacion: "Cargando información",
            label_grupo_geocerca_cliente: "Grupo Geocerca Cliente",
            label_grupo_geocerca_ciudades: "Grupo Geocerca Ciudades",
            label_ruta_planificada: "Ruta planificada",
            label_ruta_vehiculo: "Ruta vehiculo",
            label_lista_vehiculos: "Lista de vehiculos",
            label_reporte_estado_entregas: "Reporte de estado de entregas",
            label_genera_el_reporte_de_estado_de_entregas: "Genera el reporte de estado de entregas",
            label_fecha_programada: "Fecha programada",
            label_pedidos_programados: "Pedidos programados",
            label_pedidos_realizados: "Pedidos realizados",
            label_km_planificada: "Km planificada",
            label_km_recorrido: "Km recorrido",
            label_obligatorio: "Obligatorio",
            label_no_obligatorio: "No obligatorio",
            label_gestionar_estados_incidente: "Gestionar Estados Incidente",
            label_administra_la_lista_de_estados_incidente: "Administra la lista de estados incidente",
            label_crear_estado_incidente: "Criar Estado Incidente",
            label_modificar_estado_incidente: "Modificar Estado Incidente",
            label_gestionar_sub_estados_incidente: "Gestionar Sub Estados Incidente",
            label_administra_la_lista_de_sub_estados_incidente: "Administra la lista de sub estados incidente",
            label_crear_sub_estado_incidente: "Criar Sub Estado Incidente",
            label_modificar_sub_estado_incidente: "Modificar Sub Estado Incidente",
            label_gestionar_persona: "Gestionar Persona",
            label_administra_la_lista_de_personas: "Administra la lista de personas",
            label_crear_persona: "Crear Persona",
            label_modificar_persona: "Modificar Persona",
            label_notificar_a: "Notificar a",
            label_grupo_geocerca_georuta: "Grupo Geocerca Georuta",
            label_gestionar_incidentes: "Gestionar Incidentes",
            label_administra_la_lista_de_incidentes: "Administra la lista de incidentes",
            label_detalle_incidente: "Detalle Incidente",
            label_sin_detalle: "Sin detalle",
            label_ubicacion: "Ubicación",
            label_vista_previa: "Vista previa",
            label_copiado: "Copiado",
            label_abrir: "Abrir",
            label_asignar_por_peso: "Asignar por peso",
            label_usar_vehiculo_solo_una_vez: "Usar vehiculo solo una vez",
            label_si: "Si",
            label_no: "No",
            label_unidades_disponibles: "Unidades disponibles",
            label_usar_vehiculo_del_excel: "Usar vehiculo del excel",
            label_fecha_inicio: "Fecha inicio",
            label_fecha_fin: "Fecha fin",
            label_cliente: "Cliente",
            label_documento: "Nro Documento",
            label_finalizado: "Finalizado",
            label_pedidos: "Pedidos",
            label_estadopagos: "Estados de Pago",
            label_metodo: "Método",
            label_subtotal: "Subtotal",
            label_dividir_si_no_se_encuentra_vehiculo: "Dividir si no se encuentra vehiculo",
            label_reporte_resumen_entregas: "Resumen de entregas",
            label_genera_el_reporte_de_resumen_de_entregas: "Genera el reporte de resumen de entregas",
            label_registros: "Registros",
            label_exportar_excel: "Exportar Excel",
            label_sub_estado: "Sub Estado",
            label_estado_asignado: "Asignado",
            label_estado_en_proceso: "En Proceso",
            label_detalle_estado_pago: "Detalle estado pago",
            label_gestionar_viajes: "Gestionar Viajes",
            label_administra_la_lista_de_viajes: "Administra la lista de viajes",
            label_nuevo_viaje: "Nuevo viaje",
            label_notificar_inicio_viaje: "Notificar inicio de viaje",
            label_notificar_fin_viaje: "Notificar fin de viaje",
            label_grupo_geocerca_viaje: "Grupo Geocerca Viaje",
            label_geocerca_inicio: "Geofence Start",
            label_geocerca_fin: "Geofence End",
            label_fecha_hora_inicio: "Data/Hora Inicio",
            label_fecha_hora_fin: "Data/Hora Fin",
            label_minutos: "Minutos",
            label_now: "Ahora",
            label_modificar_viaje: "Modificar viaje",
            label_tranportadora_sindicato: "Transportadora/Sindicato",
            label_usuario_singular: "Usuario singular",
            label_grupo: "Grupo",
            label_sub_grupo: "Sub Grupo",
            label_vehiculos: "Vehiculos",
            label_grupo_geocerca_clientes: "Grupo Geocerca Clientes",
            label_georuta: "Georuta",
            label_cantidad_vehiculos_requeridos: "Vehiculos requeridos",
            label_notificar_alerta: "Notificar alerta",
            label_gestionar_estado_viajes: "Gestionar Estado Viajes",
            label_administra_la_lista_de_estado_viajes: "Administra la lista de estado viajes",
            label_nuevo_estado_viaje: "Nuevo estado viaje",
            label_modificar_estado_viaje: "Modificar estado viaje",
            label_visible_para_transportadora: "Visible para transportadora",
            label_estado_viaje: "Estado viaje",
            label_datos_generales: "Datos generales",
            label_geocercas: "Geocercas",
            label_notificaciones: "Notificaciones",
            label_este_usuario_puede_hacer_gestion_estrege_recogo_productos: "Este usuario puede hacer gestión estrega/recogo productos",
            label_visible_para_app: "Visible para app",
            label_crear_usuario_web: "Crear Usuario Web",
            label_rol_usuario_web: "Rol Usuario Web",
            label_nombre_usuario: "Nombre Usuario",
            label_confirmar_password: "Confirmar Senha",
            label_cambiar_fecha_entrega: "Cambiar Fecha Entrega",
            label_gestionar_permisos: "Gerenciar Permisos",
            label_seleccionar_todo: "Selecionar tudo",
            label_funcionalidad: "Funcionalidade",
            label_gestionar_tipo_carguio: "Gerenciar Tipo Carguio",
            label_administra_la_lista_de_tipo_carguio: "Gerenciar a lista de tipo carguio",
            label_crear_tipo_carguio: "Criar Tipo Carguio",
            label_modificar_tipo_carguio: "Modificar Tipo Carguio",
            label_gestionar_registro_camiones: "Gerenciar Registro Camiones",
            label_administra_la_lista_de_registro_camiones: "Gerenciar a lista de registro camiones",
            label_crear_registro_camiones: "Criar Registro Camiones",
            label_modificar_registro_camiones: "Modificar Registro Camiones",
            label_gestionar_kanban: "Gerenciar Kanban",
            label_administra_la_lista_de_kanban: "Gerenciar a lista de kanban",
            label_crear_kanban: "Criar Kanban",
            label_modificar_kanban: "Modificar Kanban",
            label_gestionar_kanban_viaje: "Gerenciar Kanban Viagem",
            label_administra_la_lista_de_kanban_viaje: "Gerenciar a lista de kanban viagem",
            label_crear_kanban_viaje: "Criar Kanban Viagem",
            label_modificar_kanban_viaje: "Modificar Kanban Viagem",
            label_gestionar_kanban_producto: "Gerenciar Kanban Produto",
            label_administra_la_lista_de_kanban_producto: "Gerenciar a lista de kanban produto",
            label_crear_kanban_producto: "Criar Kanban Produto",
            label_modificar_kanban_producto: "Modificar Kanban Produto",
            label_agregar_columna: "Adicionar coluna",
            label_seleccionar_tipo_columna: "Tipo de coluna",
            label_gestionar_estados_vehiculo: "Gestionar Estados Vehiculo",
            label_administra_la_lista_de_estados_vehiculo: "Administra la lista de estados vehiculo",
            label_crear_estado_vehiculo: "Crear Estado Vehiculo",
            label_modificar_estado_vehiculo: "Modificar Estado Vehiculo",
            label_gestionar_ejes_vehiculo: "Gestionar Ejes Vehiculo",
            label_administra_la_lista_de_ejes_vehiculo: "Administra la lista de ejes vehiculo",
            label_crear_ejes_vehiculo: "Crear Ejes Vehiculo",
            label_modificar_ejes_vehiculo: "Modificar Ejes Vehiculo",
            label_pedir_descripcion: "Pedir descrição",
            label_gestionar_usuario_web: "Gestionar Usuario Web",
            label_administra_la_lista_de_usuario_web: "Administra la lista de usuario web",
            label_modificar_usuario_web: "Modificar Usuario Web",
            label_gestionar_tipo_choferes: "Gerenciar Tipo Chofer",
            label_administra_la_lista_de_tipo_choferes: "Administra la lista de tipo chofer",
            label_crear_tipo_chofer: "Criar Tipo Chofer",
            label_modificar_tipo_chofer: "Modificar tipo chofer",
            label_licencia: "Licencia",
            label_telefono: "Teléfono",
            label_tipo_chofer: "Tipo Chofer",
            label_ejes_vehiculo: "Ejes Vehiculo",
            label_gestionar_requerimiento_viajes: "Gerenciar Requerimento Viajes",
            label_administra_la_lista_de_requerimiento_viajes: "Gerenciar a lista de requerimento viajes",
            label_nuevo_requerimiento_viaje: "Novo requerimento viaje",
            label_modificar_requerimiento_viaje: "Modificar requerimento de viagem",
            label_es_transportadora_o_sindicato: "Es transportadora o sindicato",
            label_gestionar_transportadoras_sindicato: "Gerenciar Transportadoras/Sindicato",
            label_administra_la_lista_de_transportadoras_sindicato: "Administrar a lista de transportadoras/sindicato",
            label_crear_transportadora_sindicato: "Criar Transportadora/Sindicato",
            label_modificar_transportadora_sindicato: "Modificar Transportadora/Sindicato",
            label_gestionar_formulario_viajes: "Gerenciar Formulário de Viagens",
            label_administra_la_lista_de_formulario_viajes: "Administrar a lista de formulários de viagens",
            label_nuevo_formulario_viaje: "Novo formulário de viagem",
            label_modificar_formulario_viaje: "Modificar formulário de viagem",
            label_seleccione_origen: "Seleccione origen",
            label_seleccione_chofer: "Seleccione chofer",
            label_gestionar_programacion_camiones: "Gestionar Programación Camiones",
            label_administra_la_lista_de_programacion_camiones: "Administra la lista de programación camiones",
            label_nuevo_programacion_camiones: "Nuevo programación camiones",
            label_modificar_programacion_camiones: "Modificar programación camiones",
            label_formulario_viaje: "Formulario de viaje",
            label_siguiente: "Proximo",
            label_atras: "Atrás",
            label_es_chofer: "Es chofer",
            label_gestionar_respuesta_solicitud_programacion_camiones: "Gerenciar Estado Solicitud Programación Camiones",
            label_administra_la_lista_de_estado_solicitud_programacion_camiones: "Administra la lista de estado solicitud programación camiones",
            label_solicitud: "Solicitação",
            label_respuestas: "Respostas",
            label_configurar_acciones_solicitud: "Configurar ações da solicitação",
            label_configurar_acciones_solicitud_desc: "Configure a mensagem e os destinatários opcionais para OK e X.",
            label_accion_aceptar_ok: "Aceitar (OK)",
            label_accion_aceptar_estado_viaje_ayuda: "Ao clicar em OK, a solicitação é atualizada com este status de viagem.",
            label_accion_rechazar_x: "Rejeitar (X)",
            label_accion_rechazar_estado_viaje_ayuda: "Ao clicar em X, a solicitação é atualizada com este status de viagem.",
            label_mensaje_notificacion: "Mensagem de notificação",
            placeholder_mensaje_notificacion_rechazo: "Digite a mensagem de notificação",
            alert_solicitud_aceptada: "Solicitação aceita",
            alert_solicitud_rechazada: "Solicitação rejeitada",
            alert_configure_acciones_solicitud: "Configure OK e X: selecione um status de viagem para cada ação primeiro.",
            label_fecha_inicio_viaje: "Fecha inicio viaje",
            label_fecha_fin_viaje: "Fecha fin viaje",
            label_hora_inicio_viaje: "Hora inicio viaje",
            label_hora_fin_viaje: "Hora fin viaje",
            label_seleccione_georuta: "Seleccione georuta",
            label_grupo_geocerca_depositos: "Grupo Geocerca Depósitos",
            label_orden: "Orden",
            label_gestionar_prioridad_entrega: "Gestionar Prioridad Entrega",
            label_administra_la_lista_de_prioridad_entrega: "Administra la lista de prioridad entrega",
            label_crear_prioridad_entrega: "Criar Prioridad Entrega",
            label_modificar_prioridad_entrega: "Modificar prioridade de entrega",
            label_gestionar_solicitud_producto: "Gerenciar Solicitud de Produto",
            label_administra_la_lista_de_solicitud_producto: "Gerenciar a lista de solicitud de produto",
            label_crear_solicitud_producto: "Criar Solicitud de Produto",
            label_modificar_solicitud_producto: "Modificar solicitud de produto",
            label_producto: "Producto",
            label_destino: "Destino",
            label_requerimiento: "Requerimiento",
            label_despachado: "Despachado",
            label_gestionar_programacion_solicitud_producto: "Gestionar Programacion Solicitud Producto",
            label_administra_la_lista_de_programacion_solicitud_producto: "Administra la lista de programacion solicitud producto",
            label_gestionar_programacion_camiones_kanban: "Gerenciar Kanban Caminhões",
            label_administra_la_lista_de_programacion_camiones_kanban: "Gerencia o quadro kanban de caminhões",
            label_gestionar_programacion_productos_kanban: "Gerenciar Kanban Produtos",
            label_administra_la_lista_de_programacion_productos_kanban: "Gerencia o quadro kanban de produtos",
            // label_crear_programacion_solicitud_producto: "Crear Programacion Solicitud Producto",
            // label_modificar_programacion_solicitud_producto: "Modificar programacion solicitud producto",
            label_este_estado_inicia_viaje: "Este estado inicia viaje",
            label_acciones_kanban: "Acciones Kanban",
            label_acciones_kanban_viaje: "Ações Kanban Viagem",
            label_acciones_kanban_producto: "Ações Kanban Produto",
            label_crear_acciones_kanban: "Criar Acciones Kanban",
            label_crear_acciones_kanban_viaje: "Criar Ações Kanban Viagem",
            label_crear_acciones_kanban_producto: "Criar Ações Kanban Produto",
            label_configurar_acciones_programacion_kanban: "Configurar ações do kanban",
            label_configurar_acciones_programacion_kanban_desc: "Para cada ação, escolha a coluna de destino, a mensagem opcional e quem notificar.",
            label_mover_a_kanban: "Mover para coluna kanban",
            label_mover_a_kanban_ayuda: "Ao clicar nesta ação, o cartão é movido para a coluna selecionada.",
            placeholder_seleccione_kanban: "Selecione coluna kanban",
            alert_configure_acciones_programacion_kanban: "Configure esta ação primeiro: selecione uma coluna kanban de destino.",
            alert_card_movida_kanban: "Cartão movido para a coluna kanban",
            label_datos_faltantes_iniciar_viaje: "Faltam dados para iniciar a viagem",
            label_faltan_datos_iniciar_viaje_desc: "Para mover este cartão para a coluna que inicia viagens, o formulário deve conter os seguintes campos:",
            label_detalle_respuestas: "Detalhes das respostas",
            label_sin_respuesta: "Sem resposta",
            label_meta: "Dados adicionais",
            label_motivo: "Motivo",
            label_aprobar_solicitud: "Aprovar solicitação",
            label_rechazar_solicitud: "Rejeitar solicitação",
            placeholder_ingrese_motivo: "Insira o motivo",
            alert_debe_ingresar_motivo: "Você deve inserir um motivo",
            alert_solicitud_aprobada: "Solicitação aprovada",
            label_iniciar_viaje: "Iniciar viagem",
            label_viajes: "viagens",
            label_mapa_viaje: "Mapa viagem",
            alert_no_hay_columna_inicia_viaje: "Nenhuma coluna kanban está marcada como 'inicia viagem'. Configure-a nas configurações do kanban.",
            label_mostrar_todos: "Mostrar todos",
            label_mostrar_seleccionados: "Somente selecionados",
            label_seleccionar_todos: "Selecionar todos",
            label_modificar_acciones_kanban: "Modificar ações Kanban",
            label_modificar_acciones_kanban_viaje: "Modificar Ações Kanban Viagem",
            label_modificar_acciones_kanban_producto: "Modificar Ações Kanban Produto",
            label_gestionar_formulario_programacion_camiones: "Gerenciar Formulario Programacion Camiones",
            label_administra_la_lista_de_formulario_programacion_camiones: "Administra la lista de Formulario Programacion Camiones",
            label_es_viaje_aprobado: "Es Viaje Aprobado",
            label_guardar_estado: "Guardar estado",
            label_fecha_programacion_salida: "Fecha Programacion Salida",
            label_fecha_carguio: "Fecha Carguio",
            label_distancia_alerta: "Distancia Alerta",
            label_geocerca_origen: "Geocerca Origen",
            label_geocerca_destino: "Geocerca Destino",
            label_es_cliente: "Es Cliente",
            label_agregar_producto: "Agregar Producto",
            label_fecha_programada_inicio: "Fecha Programada Inicio",
            label_fecha_programada_fin: "Fecha Programada Fin",
            label_kilo: "Quilograma",
            label_tonelada: "Tonelada",
            label_libra: "Libra",
            label_litro: "Litro",
            label_m3: "Metro cúbico",
            label_gallon: "Galão",
            label_programacion_camiones: "Programacion Camiones",
            label_formulario_programacion_camiones: "Formulario Programacion Camiones",
            label_gestionar_estado_solicitudes: "Gestionar Estado Solicitudes",
            label_administra_la_lista_de_estado_solicitudes: "Administra la lista de estado solicitudes",
            label_nuevo_estado_solicitud: "Nuevo estado solicitud",
            label_modificar_estado_solicitud: "Modificar estado solicitud",
            label_estado_solicitud: "Estado Solicitud",
            label_administra_la_lista_de_estado_solicitud_producto: "Administra a lista de estados de solicitação de produto",
            label_aprobado: "Aprovado",
            label_rechazado: "Rejeitado",
            label_filtro_fecha: "Filtro de data",
            label_filtro_todas: "Todos",
            label_filtro_hoy: "Hoje",
            label_filtro_ayer: "Ontem",
            label_filtro_rango: "Intervalo personalizado",
            label_seleccionar_personas_alerta: "Selecionar pessoas a notificar",
            label_seleccionar_personas_alerta_desc: "Os alertas serão enviados aos e-mails e telefones das pessoas selecionadas.",
            label_notificar_sin_destinatario: "Notificar sem destinatário",
            label_confirmar: "Confirmar",
            label_formulario_solicitud_producto: "Formulário de Solicitação de Produto",

            alert_debe_seleccionar_producto: "Debe seleccionar un producto",
            alert_debe_ingresar_cantidad: "Debe ingresar una cantidad",
            alert_producto_ya_agregado: "Producto ya agregado",
            alert_usuario_o_contrasena_incorrecto: "Usuário ou senha incorretos",
            alert_procesando_solicitud: "Processando solicitação...",
            alert_se_creo_correctamente: "Se criado corretamente",
            alert_se_actualizo_correctamente: "Se actualizo correctamente",
            alert_esta_de_deshabilitar_categoria: "¿Estás de deshabilitar Categoria?",
            alert_esta_de_habilitar_categoria: "¿Estás de habilitar Categoria?",
            alert_se_deshabilito_correctamente: "Desabilitada com sucesso",
            alert_se_habilito_correctamente: "Habilitada com sucesso",
            alert_debe_ingresar_nombre: "Você deve digitar um nome",
            alert_fecha_invalida: "Data inválida",
            alert_esta_de_deshabilitar_producto: "Você está de desabilitar o produto?",
            alert_esta_de_habilitar_producto: "Você está de habilitar o produto?",
            alert_esta_de_deshabilitar_pais: "Você está de desabilitar o país?",
            alert_esta_de_habilitar_pais: "Você está de habilitar o país?",
            alert_debe_ingresar_descripcion: "Você deve digitar uma descrição",
            alert_esta_de_deshabilitar_ciudad: "Você está de desabilitar a cidade?",
            alert_esta_de_habilitar_ciudad: "Você está de habilitar a cidade?",
            alert_esta_de_deshabilitar_vendedor: "Você está de desabilitar o vendedor?",
            alert_esta_de_habilitar_vendedor: "Você está de habilitar o vendedor?",
            alert_esta_de_deshabilitar: "Você está de desabilitar?",
            alert_esta_de_habilitar: "Você está de habilitar?",
            alert_formato_color_invalido: "Formato de cor inválido. Use #RRGGBB ou #RGB",
            alert_debe_ingresar_al_menos_un_campo_de_requerimiento: "Você deve digitar pelo menos um campo de requerimento",
            alert_label_debe_tener_mas_de_2_caracteres: "O rótulo deve ter mais de 2 caracteres",
            alert_key_no_puede_estar_vacio: "A chave não pode estar vazia",
            alert_key_debe_ser_unico: "A chave deve ser única",
            alert_es_default: "É default",
            alert_processed_successfully: "Processado com sucesso",
            alert_se_agrego_correctamente: "Se adicionado corretamente",
            alert_debe_seleccionar_columnas: "Você deve selecionar colunas",
            alert_no_se_pudo_crear: "Não foi possível criar",
            alert_no_se_pudo_modificar: "Não foi possível modificar",
            alert_se_modifico_correctamente: "Se modifico corretamente",
            alert_archivo_invalido: "Arquivo inválido",
            alert_archivo_vacio: "Arquivo vazio",
            alert_maximo_500_elementos: "Máximo 500 elementos",
            alert_debe_seleccionar_vehiculo: "Você deve selecionar um veículo",
            alert_debe_seleccionar_fecha: "Você deve selecionar uma fecha",
            alert_debe_seleccionar_formulario: "Você deve selecionar um formulario",
            alert_no_se_pudo_leer_configuracion: "Não foi possível ler a configuração",
            alert_debe_ingresar_prioridad: "Você deve digitar uma prioridade",
            alert_debe_seleccionar_grupo_geocerca: "Você deve selecionar um grupo geocerca",
            alert_debe_seleccionar_al_menos_un_elemento: "Você deve selecionar pelo menos um elemento",
            alert_debe_seleccionar_vehiculo_fecha_formulario: "Você deve selecionar um veículo, uma fecha e um formulario",
            alert_se_dividio_correctamente: "Se dividio corretamente",
            alert_debe_ingresar_numero_documento: "Você deve digitar um número de documento",
            alert_copiado_al_portapapeles: "Copiado para a área de transferência",
            alert_debe_seleccionar_mas_de_un_elemento: "Você deve selecionar mais de um elemento",
            alert_se_unio_correctamente: "Se unio corretamente",
            alert_debe_seleccionar_unidad: "Você deve selecionar um veículo",
            alert_debe_ingresar_nombre_conductor: "Você deve digitar um nome de condutor",
            alert_debe_ingresar_usuario: "Você deve digitar um username",
            alert_debe_ingresar_password: "Você deve digitar uma senha",
            alert_debe_ingresar_peso: "Você deve digitar um peso",
            alert_debe_ingresar_volumen: "Você deve digitar um volume",
            alert_debe_ingresar_inicio: "Você deve digitar um inicio",
            alert_debe_ingresar_fin: "Você deve digitar um fin",
            alert_debe_ingresar_color: "Você deve digitar um color",
            alert_punto_interes_no_valido: "O ponto de interesse não é válido",
            alert_error_al_calcular_distancia: "Erro ao calcular a distancia do ponto de interesse",
            alert_vehiculo_no_seleccionado: "Veículo não selecionado",
            alert_no_hay_pedidos_para_ordenar: "Não há pedidos com origem/destino válidos",
            label_calcular_orden_recomendado: "Calcular ordem recomendada",
            label_orden_recomendado: "Ordem recomendada",
            label_sin_posicion_actual: "Sem posição atual, iniciando do primeiro origem",
            label_recoger: "Coletar",
            label_entregar: "Entregar",
            label_dibujar_ruta: "Desenhar rota",
            label_ocultar_ruta: "Ocultar rota",
            label_calculando_tiempos: "Calculando tempos reais…",
            label_directions_fallback: "Distâncias em linha reta",
            label_guardar_cambios: "Salvar alterações",
            alert_orden_creado: "Ordem salva",
            alert_orden_actualizado: "Ordem atualizada",
            alert_secuencia_vacia: "Sem paradas para salvar",
            alert_sin_empresa: "Empresa (idEmpresa) não detectada",
            alert_confirmar_recalcular: "Você já calculou uma ordem. Recalcular e substituir a sequência atual?",
            alert_confirmar_recalcular_guardado: "Já existe uma ordem salva para este veículo. Recalcular e substituir a sequência? As alterações não serão salvas até você clicar em Salvar.",
            alert_orden_pickup_antes_destino: "A entrega não pode ocorrer antes da coleta do mesmo pedido",
            label_arrastrar_para_reordenar: "Arrastar para reordenar",
            label_estado_borrador: "Rascunho",
            label_estado_confirmado: "Confirmado",
            label_estado_en_curso: "Em andamento",
            label_estado_completado: "Concluído",
            label_estado_cancelado: "Cancelado",
            label_confirmar_orden: "Confirmar",
            label_iniciar_viaje_orden: "Iniciar viagem",
            label_completar_orden: "Concluir",
            label_cancelar_orden: "Cancelar",
            label_eliminar_orden: "Excluir ordem",
            alert_guardar_antes_cambiar_estado: "Salve a ordem antes de mudar o estado",
            alert_guardar_cambios_pendientes: "Você tem alterações não salvas. Salve primeiro.",
            alert_estado_actualizado: "Estado atualizado",
            alert_orden_deshabilitado: "Ordem removida",
            alert_no_se_pudo_deshabilitar: "Não foi possível desabilitar a ordem",
            alert_confirmar_deshabilitar_orden: "Excluir (desabilitar) esta ordem? Você pode reabilitá-la a partir do histórico.",
            label_sin_guardar: "não salvo",
            alert_punto_vehiculo_no_valido: "Posição do veículo não válida",
            alert_no_se_pudo_procesar: "Não foi possível processar",
            alert_orden_detalle_pedido_actualizada: "Pedido de detalhe atualizado",
            alert_debe_seleccionar_solo_un_elemento: "Você deve selecionar apenas um elemento",
            alert_se_cambio_placa_correctamente: "Se cambio vehiculo corretamente",
            alert_debe_seleccionar_grafico: "Você deve selecionar um gráfico",
            alert_debe_ingresar_al_menos_un_estado_de_pago: "Você deve digitar pelo menos um estado de pagamento",
            alert_label_no_puede_estar_vacio: "A etiqueta não pode estar vazia",
            alert_debe_seleccionar_concepto_geocerca: "Você deve selecionar um concepto geocerca",
            alert_esta_de_importar_clientes: "Você está de importar clientes?",
            alert_se_importaron_correctamente: "Se importaron correctamente",
            alert_no_se_pudo_importar_clientes: "No se pudo importar clientes",
            alert_fecha_inicio_debe_ser_menor_a_fecha_fin: "La fecha de inicio debe ser menor a la fecha de fin",
            alert_maximo_31_dias_por_consulta: "Máximo 31 días por consulta",
            alert_procesando_solicitud_detalle_pedido: "Procesando solicitud para detalle de pedido",
            alert_fecha_inicio_no_valido: "Fecha Inicio No Valida",
            alert_fecha_fin_no_valido: "Fecha Fin No Valida",
            alert_hora_inicio_no_valido: "Hora inicio no válida (formato 24h HH:mm)",
            alert_hora_fin_no_valido: "Hora fin no válida (formato 24h HH:mm)",
            alert_debe_seleccionar_geocerca_inicio: "Você deve selecionar uma geocerca inicio",
            alert_debe_seleccionar_geocerca_fin: "Você deve selecionar uma geocerca fin",
            alert_debe_seleccionar_georuta: "Você deve selecionar uma georuta",
            alert_debe_ingresar_cantidad_vehiculos_requeridos: "Você deve digitar uma quantidade de veículos requeridos",
            alert_debe_seleccionar_estado_viaje: "Você deve selecionar um estado viaje",
            alert_debe_seleccionar_tipo_usuario_movil: "Você deve selecionar um tipo de usuario movil",
            alert_debe_ingresar_confirmar_password: "Você deve digitar uma senha de confirmação",
            alert_debe_ingresar_nombre_usuario: "Você deve digitar um nome de usuário",
            alert_la_contraseña_y_la_confirmación_de_la_contraseña_no_coinciden: "A senha e a confirmação da senha não coincidem",
            alert_debe_seleccionar_rol_usuario_web: "Você deve selecionar um rol usuario web",
            alert_usuario_movil_ya_existe: "O usuário móvel já existe",
            alert_se_cambio_fecha_entrega_correctamente: "Se cambio fecha entrega corretamente",
            alert_debe_seleccionar_formulario_viaje: "Você deve selecionar um formulario de viaje",
            alert_no_se_pudo_obtener_campos_dinamicos: "Não foi possível obter os campos dinâmicos",
            alert_debe_ingresar_orden: "Você deve digitar uma orden",
            alert_debe_ingresar_orden_numerico: "Você deve digitar uma orden numérica",
            alert_debe_ingresar_peso_valido: "Você deve digitar um peso válido",
            alert_debe_ingresar_etiqueta: "Você deve digitar uma etiqueta",
            alert_numero_invalido: "Número inválido",
            alert_debe_seleccionar_unidad_medida: "Você deve selecionar uma unidade de medida",
            alert_debe_seleccionar_cliente: "Você deve selecionar um cliente",

            menu_dashboard: "Dashboard",
            menu_administracion: "Administração",
            menu_categorias: "Categorias",
            menu_salir: "Sair",
            menu_productos: "Produtos",
            menu_pais: "Países",
            menu_ciudades: "Cidades",
            menu_vendedores: "Vendedores",
            menu_estados: "Estados",
            menu_grupo_clientes: "Grupo Clientes",
            menu_clientes: "Clientes",
            menu_estado_pago: "Estado de Pago",
            menu_quien_recibe_entrega: "Quién Recibe Entrega",
            menu_formulario: "Formulario",
            menu_asignacion: "Asinacion",
            menu_configuracion: "Configuración",
            menu_principal: "Principal",
            menu_almacen: "Almacén",
            menu_seguimiento: "Seguimiento",
            menu_mapa: "Mapa",
            menu_grilla: "Grilla",
            menu_tipo_cliente: "Tipo Cliente",
            menu_grupo_geocerca: "Grupo Geocerca",
            menu_usuarios: "Usuarios",
            menu_usuarios_web: "Usuarios Web",
            menu_usuarios_movil: "Usuarios Movil",
            menu_tipo_usuario_web: "Tipo Usuario Web",
            menu_tipo_usuario_movil: "Tipo Usuario Movil",
            menu_rol_usuario_web: "Rol Usuario Web",
            menu_progress_bar: "Progress Bar",
            menu_reportes: "Reportes",
            menu_reporte_estado_entregas: "Estado Entregas",
            menu_incidente: "Incidente",
            menu_estado_incidente: "Estado Incidente",
            menu_lista_incidentes: "Lista Incidentes",
            menu_persona: "Persona",
            menu_resumen_entregas: "Resumen Entregas",
            menu_viaje: "Viaje",
            menu_lista_viajes: "Lista Viajes",
            menu_estado_viajes: "Estado Viajes",
            menu_gestionar_clientes: "Gerenciar Clientes",
            menu_mapa_clientes: "Mapa Clientes",
            menu_configuracion_clientes: "Configuración Clientes",
            menu_paises: "Países",
            menu_estado_de_pago: "Estado de Pago",
            menu_asignacion_principal: "Asignación Principal",
            menu_asignacion_configuracion: "Configuración Asignación",
            menu_seguimiento_mapa: "Mapa Seguimiento",
            menu_seguimiento_grilla: "Grilla Seguimiento",
            menu_reporte_resumen_entregas: "Reporte Resumen Entregas",
            menu_programacion_viajes: "Programación Viajes",
            menu_tipo_carguio: "Tipo Carguio",
            menu_registro_camiones: "Registro Camiones",
            menu_kanban: "Kanban",
            menu_kanban_viaje: "Kanban Viagem",
            menu_kanban_producto: "Kanban Produto",
            menu_estado_vehiculo: "Estado Vehiculo",
            menu_ejes_vehiculo: "Ejes Vehiculo",
            menu_tipo_chofer: "Tipo Chofer",
            menu_lista_estado_vehiculo: "Listar Estado do Veículo",
            menu_lista_ejes_vehiculo: "Listar Eixos do Veículo",
            menu_formulario_viaje: "Formulario de Viagem",
            menu_gestionar_transportadora_sindicato: "Gerenciar Transportadora/Sindicato",
            menu_formulario_programacion_camiones: "Formulario Programación Camiones",
            menu_estado_solicitud_programacion_camiones: "Estado Solicitud Programación Camiones",
            menu_solicitud_producto: "Solicitud Producto",
            menu_seguimiento_viaje: "Acompanhamento viagem",
            menu_prioridad_entrega: "Prioridad Entrega",
            menu_programacion_solicitud_productos: "Programacion Solicitud Productos",
            menu_respuesta_solicitud_programacion_camiones: "Respuesta Solicitud Programación Camiones",
            menu_listar_solicitud_programacion_camiones: "Listar Solicitud Programación Camiones",
            menu_listar_solicitud_producto: "Listar Solicitud Producto",
            menu_programacion: "Programación",
            menu_programacion_camiones_kanban: "Kanban Caminhões",
            menu_programacion_productos_kanban: "Kanban Produtos",
            menu_estado_solicitud: "Estado Solicitud",

            grilla_placeholderbuscar: "Buscar",

            column_acciones: "Ações",
            column_descripcion: "Descrição",
            column_nota: "Nota",
            column_fechaProceso: "Data de Processo",
            column_modificar: "Modificar",
            column_eliminar: "Eliminar",
            column_deshabilitar: "Deshabilitar",
            column_habilitar: "Habilitar",
            column_estado: "Estado",
            column_habilitado: "Habilitado",
            column_deshabilitado: "Deshabilitado",
            column_categoria: "Categoria",
            column_codigo: "Código",
            column_nombre: "Nome",
            column_pais: "País",
            column_sub_status: "Sub Status",
            column_latitud: "Latitud",
            column_longitud: "Longitud",
            column_hacer_default: "Hacer Default",
            column_es_default: "Es Default",
            column_prioridad: "Prioridad",
            column_tipo_cliente: "Tipo Cliente",
            column_color: "Color",
            column_ciudad: "Ciudad",
            column_usuario: "User",
            column_password: "Senha",
            column_tipo_usuario_movil: "Tipo Usuario Móvil",
            column_vehiculo: "Vehiculo",
            column_formulario: "Formulario",
            column_detalles: "Detalles",
            column_placa: "Placa",
            column_si: "Si",
            column_no: "No",
            column_pedir_descripcion: "Pedir descripción",
            column_inicio: "Inicio",
            column_fin: "Fin",
            column_cliente: "Cliente",
            column_geocerca: "Geocerca",
            column_estado_pendiente: "Estado Pendiente",
            column_estado_iniciado: "Estado Iniciado",
            column_sub_estado: "Sub Estado",
            column_latitud_workflow: "Latitud Workflow",
            column_longitud_workflow: "Longitud Workflow",
            column_fecha_proceso: "Fecha Proceso",
            column_finalizado: "Finalizado",
            column_coordenadas_cliente: "Coordenadas Cliente",
            column_coordenadas_inicio_atencion: "Coordenadas Inicio Atención",
            column_coordenadas_fin_atencion: "Coordenadas Fin Atención",
            column_concepto_geocerca: "Concepto Geocerca",
            column_geocerca_inicio: "Geocerca Inicio",
            column_geocerca_fin: "Geocerca Fin",
            column_fecha_inicio: "Fecha Inicio",
            column_hora_inicio: "Hora Inicio",
            column_fecha_fin: "Fecha Fin",
            column_hora_fin: "Hora Fin",
            column_nombre_usuario: "Nombre Usuario",
            column_tipo_usuario_web: "Tipo Usuario Web",
            column_rol_usuario_web: "Rol Usuario Web",
            column_reset_password: "Reset Password",
            column_grupo: "Grupo",
            column_producto: "Producto",
            column_requerimiento: "Requerimiento",
            column_despachado: "Despachado",
            column_fecha_entrega_programada: "Fecha Entrega Programada",
            column_fecha_programacion_salida: "Fecha Programación Salida",
            column_fecha_carguio: "Fecha Carguio",
            column_fecha_entrega_excel: "Fecha Entrega Excel",
            column_fecha_hora_entrada_geocerca: "Data/hora entrada",
            column_fecha_hora_salida_geocerca: "Data/hora saída",
            column_tiempo_estadia_geocerca: "Tempo de permanência",
            column_nombre_cliente: "Nome do Cliente",
            column_numero_documento: "Número de Documento",
            column_nro: "Nro",
            column_weight: "Peso",
            column_sub_estados: "Sub Estados",
            column_telefonos: "Telefonos",
            column_correos: "Correos",
            column_estado_incidente: "Estado Incidente",
            column_sub_estado_incidente: "Sub Estado Incidente",
            column_nombre_chofer: "Nombre Chofer",
            column_fecha_hora_incidente: "Fecha/Hora Incidente",
            column_fecha_registro: "Fecha Registro",
            column_nombre_conductor: "Nombre Conductor",
            column_notificar_a: "Notificar a",
            column_permisos: "Permisos",
            column_formulario_viaje: "Formulario Viaje",
            column_fecha_hora_inicio_atencion: "Fecha/Hora Inicio Atención",
            column_fecha_hora_fin_atencion: "Fecha/Hora Fin Atención",
            column_fecha_entrega_conductor: "Fecha Entrega Conductor",
            column_almacen: "Almacen",

            placeholder_seleccione_estado: "Selecione Estado",
            placeholder_seleccione_categoria: "Selecione Categoria",
            placeholder_ingresa_nombre: "Digite o nome",
            placeholder_ingresa_nota: "Digite a nota",
            placeholder_ingresa_codigo: "Digite o código",
            placeholder_ingresa_descripcion: "Digite a descrição",
            placeholder_seleccione_pais: "Selecione País",
            placeholder_seleccione_grupo_cliente: "Selecione Grupo Cliente",
            placeholder_seleccione_ciudad: "Selecione Cidade",
            placeholder_ingresa_latitud: "Digite a latitude",
            placeholder_ingresa_longitud: "Digite a longitude",
            placeholder_seleccione_tipo: "Selecione tipo",
            placeholder_ingresa_texto: "Digite o texto",
            placeholder_ingresa_numero: "Digite o número",
            placeholder_ingresa_etiqueta: "Digite a etiqueta",
            placeholder_ingresa_key: "Digite a key",
            placeholder_seleccione_estado_de_pago: "Selecione estado de pago",
            placeholder_seleccione_quien_recibe_entrega: "Selecione quién recibe/entrega",
            placeholder_seleccione_vehiculo: "Selecione vehiculo",
            placeholder_seleccione_fecha: "Seleccione fecha YYYY-MM-DD",
            placeholder_seleccione_formulario: "Seleccione formulario",
            placeholder_ingresa_prioridad: "Ingrese prioridad",
            placeholder_seleccione_tipo_cliente: "Seleccione tipo cliente",
            placeholder_seleccione_grupo_geocerca: "Seleccione grupo geocerca",
            placeholder_seleccione_geocerca: "Seleccione geocerca",
            placeholder_seleccione_geocercas: "Seleccione geocercas",
            placeholder_seleccione_unidad: "Seleccione unidad",
            placeholder_seleccione_tipo_usuario_movil: "Seleccione tipo usuario movil",
            placeholder_ingresa_peso: "Ingrese peso",
            placeholder_ingresa_volumen: "Ingrese volumen",
            placeholder_ingresa_nombre_conductor: "Ingrese nombre conductor",
            placeholder_ingresa_usuario: "Ingrese username",
            placeholder_ingresa_password: "Ingrese senha",
            placeholder_ingresa_inicio: "Ingrese inicio",
            placeholder_ingresa_fin: "Ingrese fin",
            placeholder_seleccione_grafico: "Seleccione gráfico",
            placeholder_seleccione_concepto_geocerca: "Seleccione concepto geocerca",
            placeholder_ingrese_numero_documento: "Ingrese número de documento",
            placeholder_seleccione_persona: "Seleccione persona",
            placeholder_seleccione_fecha_hora: "Seleccione fecha/hora",
            placeholder_seleccione_grupo: "Seleccione grupo",
            placeholder_seleccione_sub_grupo: "Seleccione sub grupo",
            placeholder_seleccione_vehiculos: "Seleccione vehiculos",
            placeholder_seleccione_georuta: "Seleccione georuta",
            placeholder_ingresa_cantidad_vehiculos_requeridos: "Ingrese cantidad de vehiculos requeridos",
            placeholder_seleccione_estado_viaje: "Seleccione estado viaje",
            placeholder_seleccione_hora: "Seleccione hora",
            placeholder_ingresa_nombre_usuario: "Ingrese nombre de usuario",
            placeholder_seleccione_rol_usuario_web: "Seleccione rol usuario web",
            placeholder_ingresa_licencia: "Ingrese licencia",
            placeholder_ingresa_telefono: "Ingrese teléfono",
            placeholder_seleccione_tipo_chofer: "Seleccione tipo chofer",
            placeholder_seleccione_ejes_vehiculo: "Seleccione ejes vehiculo",
            placeholder_seleccione_formulario_viaje: "Seleccione formulario de viaje",
            placeholder_seleccionar_tipo_kanban: "Selecione tipo kanban",
            placeholder_seleccione_transportadora: "Seleccione transportadora",
            placeholder_seleccione_geocerca_origen: "Seleccione geocerca origen",
            placeholder_seleccione_geocerca_destino: "Seleccione geocerca destino",
            placeholder_seleccione_producto: "Seleccione producto",
            placeholder_seleccione_tipo_de_carga: "Seleccione tipo de carga",
            placeholder_seleccione_chofer: "Seleccione chofer",
            placeholder_seleccione_estado_vehiculo: "Seleccione estado vehiculo",
            placeholder_seleccione_geocerca_georuta: "Seleccione geocerca georuta",
            placeholder_ingresa_orden: "Ingrese orden",
            placeholder_ingresa_grupo: "Ingrese grupo",
            placeholder_ingresa_requerimiento: "Ingrese requerimiento",
            placeholder_ingresa_despachado: "Ingrese despachado",
            placeholder_seleccione_prioridad: "Seleccione prioridad",
            placeholder_ingresa_distancia_alerta: "Ingrese distancia alerta",
            placeholder_ingresa_cantidad: "Ingrese cantidad",
            placeholder_seleccione_unidad_medida: "Selecione a unidade de medida",
            placeholder_seleccione_cliente: "Seleccione cliente",
            placeholder_seleccione_estado_solicitud: "Seleccione estado solicitud",

            titulo_configuracion_asignacion: "Configuración de Asignación",
            titulo_crear_asignacion: "Crear Asignación",


            title_empresa: "EMPRESA",
            title_nombre_del_chofer: "NOMBRE DEL CHOFER",
            title_fecha: "FECHA",
            title_placa_del_camion: "PLACA DEL CAMION",
            title_n_documento: "N°DOCUMENTO",
            title_hora_de_salida: "HORA DE SALIDA",
            title_hora_de_retorno: "HORA DE RETORNO",
            title_fecha_emision: "FECHA DE EMISION",
            title_n_venta: "N°VENTA",
            title_n_factura: "N°FACTURA",
            title_cliente: "CLIENTE",
            title_verificado: "VERIFICADO",
            title_tiempo: "TIEMPO",

            chart_pie_chart_estados: "Estados",
            chart_estado_pagos: "Estado de Pagos",

            btn_productos: "Productos",
            btn_workflow: "Workflow",
            btn_modificar: "Modificar",
            btn_ver: "Ver",
            btn_agregar: "Agregar",
            btn_guardar: "Guardar",
            btn_buscar: "Buscar",
            btn_eliminar: "Eliminar",
            btn_nuevo: "Nuevo",
            btn_deshabilitar: "Deshabilitar",
            btn_habilitar: "Habilitar",
            btn_permisos: "Permisos",
            btn_importar: "Importar",
            btn_exportar: "Exportar",
            btn_aceptar: "Aceptar",
            btn_cancelar: "Cancelar",
            btn_sub_estados: "Sub Estados",
            btn_default: "Default",
            btn_configuracion: "Configuración",
            btn_limpiar: "Limpiar",
            btn_eliminar_pedido: "Eliminar Pedido",
            btn_detalles_pedido: "Detalles Pedido",
            btn_eliminar_detalle_pedido: "Eliminar Detalle Pedido",
            btn_configuracion_placa: "Configuración Placa",
            btn_filtros: "Filtros",
            btn_configuracion_pedido: "Configuración Pedido",
            btn_acciones: "Acciones",
            label_aplicar_template: "Aplicar template",
            label_guardar_como_template: "Salvar como template",
            label_gestionar_templates: "Gerenciar templates",
            label_template_global: "Disponível para todos os usuários (global)",
            label_global: "Global",
            label_campos: "campos",
            label_aplicar: "Aplicar",
            label_deshabilitar: "Desabilitar",
            placeholder_seleccione_template: "Selecione um template",
            alert_debe_seleccionar_template: "Selecione um template",
            alert_no_hay_campos_para_guardar: "Não há campos para salvar",
            alert_debe_ingresar_nombre: "Você deve inserir um nome",
            alert_se_deshabilito_correctamente: "Desabilitado com sucesso",
            alert_campos_template_omitidos_duplicados: "Alguns campos do template foram ignorados porque sua flag semântica já estava presente",
            label_vehiculo_viaje: "Veículo da viagem",
        }
    }
};

i18n
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        resources,
        lng: "en", // Set default language
        fallbackLng: "en", // Fallback if the selected language isn't available
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export default i18n;